
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire893f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire893f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("72z4V", function(module, exports) {

$parcel$export(module.exports, "DefaultAmplify", () => $8462ca0fe1ef67cb$export$11ac3725994bec7b);

var $1qbEC = parcelRequire("1qbEC");
var $lKsZv = parcelRequire("lKsZv");
var $57Of0 = parcelRequire("57Of0");

var $guvIf = parcelRequire("guvIf");

var $5rVdp = parcelRequire("5rVdp");
var $e2NQk = parcelRequire("e2NQk");
var $54W3M = parcelRequire("54W3M");
var $2vm2m = parcelRequire("2vm2m");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8462ca0fe1ef67cb$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $guvIf.parseAmplifyConfig)(resourceConfig);
        const cookieBasedKeyValueStorage = new (0, $lKsZv.CookieStorage)({
            sameSite: "lax"
        });
        const resolvedKeyValueStorage = libraryOptions?.ssr ? cookieBasedKeyValueStorage : (0, $57Of0.defaultStorage);
        const resolvedCredentialsProvider = libraryOptions?.ssr ? new (0, $5rVdp.CognitoAWSCredentialsAndIdentityIdProvider)(new (0, $2vm2m.DefaultIdentityIdStore)(cookieBasedKeyValueStorage)) : (0, $e2NQk.cognitoCredentialsProvider);
        if (!resolvedResourceConfig.Auth || libraryOptions?.Auth) {
            (0, $1qbEC.Amplify).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        (0, $54W3M.cognitoUserPoolsTokenProvider).setAuthConfig(resolvedResourceConfig.Auth);
        (0, $54W3M.cognitoUserPoolsTokenProvider).setKeyValueStorage(// TODO: allow configure with a public interface
        resolvedKeyValueStorage);
        (0, $1qbEC.Amplify).configure(resolvedResourceConfig, {
            ...libraryOptions,
            Auth: {
                tokenProvider: (0, $54W3M.cognitoUserPoolsTokenProvider),
                credentialsProvider: resolvedCredentialsProvider
            }
        });
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $1qbEC.Amplify).getConfig();
    }
};

});
parcelRegister("1qbEC", function(module, exports) {

$parcel$export(module.exports, "Amplify", () => $30fdc25c6f443021$export$a3858a9a153cffc7);

var $5RCQ5 = parcelRequire("5RCQ5");





var $iceoz = parcelRequire("iceoz");


var $43O8I = parcelRequire("43O8I");


var $guvIf = parcelRequire("guvIf");

parcelRequire("78v1Z");
parcelRequire("lUOK3");






var $hMbLp = parcelRequire("hMbLp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $30fdc25c6f443021$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.isConfigured = false;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $hMbLp.AuthClass)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $guvIf.parseAmplifyConfig)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $iceoz.deepFreeze)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        // Warn if Pinpoint is configured
        if (this.resourcesConfig.Analytics?.Pinpoint || this.resourcesConfig.Notifications?.InAppMessaging?.Pinpoint || this.resourcesConfig.Notifications?.PushNotification?.Pinpoint) // eslint-disable-next-line no-console
        console.warn("AWS will end support for Amazon Pinpoint on October 30, 2026. The guidance is to use AWS End User Messaging for push notifications and SMS, Amazon Simple Email Service for sending emails, Amazon Connect for campaigns, journeys, endpoints, and engagement analytics. Pinpoint recommends Amazon Kinesis for event collection and mobile analytics.");
        (0, $5RCQ5.Hub).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $5RCQ5.AMPLIFY_SYMBOL));
        this.notifyOAuthListener();
        this.isConfigured = true;
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        if (!this.isConfigured) // eslint-disable-next-line no-console
        console.warn(`Amplify has not been configured. Please call Amplify.configure() before using this service.`);
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $43O8I.ADD_OAUTH_LISTENER)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $30fdc25c6f443021$export$a3858a9a153cffc7 = new $30fdc25c6f443021$export$b412d755cfa0136();

});
parcelRegister("5RCQ5", function(module, exports) {

$parcel$export(module.exports, "AMPLIFY_SYMBOL", () => $008d8f6886d8544f$export$aadf71dd9875dd20);
$parcel$export(module.exports, "Hub", () => $008d8f6886d8544f$export$8c41bb232f1008b1);

var $gJw02 = parcelRequire("gJw02");

var $1ZViM = parcelRequire("1ZViM");

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $008d8f6886d8544f$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $008d8f6886d8544f$var$logger = new (0, $gJw02.ConsoleLogger)("Hub");
class $008d8f6886d8544f$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $008d8f6886d8544f$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $008d8f6886d8544f$export$aadf71dd9875dd20;
            if (!hasAccess) $008d8f6886d8544f$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $008d8f6886d8544f$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $e0exy.AmplifyError)({
            name: (0, $1ZViM.NO_HUBCALLBACK_PROVIDED_EXCEPTION),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $008d8f6886d8544f$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $008d8f6886d8544f$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $008d8f6886d8544f$export$8c41bb232f1008b1 = new $008d8f6886d8544f$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $008d8f6886d8544f$export$45dde0743a4c8d6e = new $008d8f6886d8544f$export$6b38ef2be9abbbb9("internal-hub");

});
parcelRegister("gJw02", function(module, exports) {

$parcel$export(module.exports, "ConsoleLogger", () => $4b398182966a4810$export$ba6a9c7ac8291f7f);

var $1ZViM = parcelRequire("1ZViM");

var $4qg9e = parcelRequire("4qg9e");
/* eslint-disable no-console */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4b398182966a4810$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $4b398182966a4810$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $4qg9e.LogType).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $4b398182966a4810$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $4b398182966a4810$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $4qg9e.LogType).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $4qg9e.LogType).WARN && console.warn) log = console.warn.bind(console);
        if ($4b398182966a4810$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $4qg9e.LogType).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $4qg9e.LogType).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $4qg9e.LogType).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $4qg9e.LogType).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $4qg9e.LogType).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $4qg9e.LogType).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $4qg9e.LogType).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $4qg9e.LogType).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $1ZViM.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$4b398182966a4810$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;

});
parcelRegister("1ZViM", function(module, exports) {

$parcel$export(module.exports, "AWS_CLOUDWATCH_CATEGORY", () => $e362d339f3c21ca2$export$13470c6f1642bbce);
$parcel$export(module.exports, "USER_AGENT_HEADER", () => $e362d339f3c21ca2$export$16032fc466434892);
$parcel$export(module.exports, "NO_HUBCALLBACK_PROVIDED_EXCEPTION", () => $e362d339f3c21ca2$export$86d53207c3c20049);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $e362d339f3c21ca2$export$13470c6f1642bbce = "Logging";
const $e362d339f3c21ca2$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $e362d339f3c21ca2$export$86d53207c3c20049 = "NoHubcallbackProvidedException";

});

parcelRegister("4qg9e", function(module, exports) {

$parcel$export(module.exports, "LogType", () => $efbbd0209ea980b7$export$a0472aa3a356446c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $efbbd0209ea980b7$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($efbbd0209ea980b7$export$a0472aa3a356446c || ($efbbd0209ea980b7$export$a0472aa3a356446c = {}));

});


parcelRegister("e0exy", function(module, exports) {

$parcel$export(module.exports, "AmplifyError", () => $946cdba1e264a995$export$37321a6dace1881c);
class $946cdba1e264a995$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError, metadata: metadata }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        if (metadata) {
            // If metadata exists, explicitly only record the following properties.
            const { extendedRequestId: extendedRequestId, httpStatusCode: httpStatusCode, requestId: requestId } = metadata;
            this.metadata = {
                extendedRequestId: extendedRequestId,
                httpStatusCode: httpStatusCode,
                requestId: requestId
            };
        }
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $946cdba1e264a995$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $946cdba1e264a995$export$37321a6dace1881c.prototype);
    }
}

});


parcelRegister("iceoz", function(module, exports) {

$parcel$export(module.exports, "deepFreeze", () => $35e949d961a4bb54$export$7e32b29e1cb162e1);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $35e949d961a4bb54$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $35e949d961a4bb54$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};

});

parcelRegister("43O8I", function(module, exports) {

$parcel$export(module.exports, "ADD_OAUTH_LISTENER", () => $3ac22caa9341ca12$export$35210b3191d26437);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3ac22caa9341ca12$export$35210b3191d26437 = Symbol("oauth-listener");

});

parcelRegister("guvIf", function(module, exports) {

$parcel$export(module.exports, "parseAmplifyConfig", () => $ef54e63dd8f4866f$export$f101a69cd6dc6202);

var $FIaO4 = parcelRequire("FIaO4");

var $htw2G = parcelRequire("htw2G");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $ef54e63dd8f4866f$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith("aws_"))) return (0, $FIaO4.parseAWSExports)(amplifyConfig);
    else if ((0, $htw2G.isAmplifyOutputs)(amplifyConfig)) return (0, $htw2G.parseAmplifyOutputs)(amplifyConfig);
    else return amplifyConfig;
};

});
parcelRegister("FIaO4", function(module, exports) {

$parcel$export(module.exports, "parseAWSExports", () => $12e0f7072a5016a7$export$1ef2e9c2da492d);

var $gJw02 = parcelRequire("gJw02");

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $12e0f7072a5016a7$var$logger = new (0, $gJw02.ConsoleLogger)("parseAWSExports");
const $12e0f7072a5016a7$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $12e0f7072a5016a7$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $e0exy.AmplifyError)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $12e0f7072a5016a7$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $12e0f7072a5016a7$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$12e0f7072a5016a7$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $12e0f7072a5016a7$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $12e0f7072a5016a7$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $12e0f7072a5016a7$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $12e0f7072a5016a7$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $12e0f7072a5016a7$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $12e0f7072a5016a7$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};

});

parcelRegister("htw2G", function(module, exports) {

$parcel$export(module.exports, "isAmplifyOutputs", () => $7dcd6190391b2d90$export$99bf765e6322c00);
$parcel$export(module.exports, "parseAmplifyOutputs", () => $7dcd6190391b2d90$export$11d0da171d17ab63);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7dcd6190391b2d90$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version } = config;
    if (!version) return false;
    return version.startsWith("1");
}
function $7dcd6190391b2d90$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name, aws_region: aws_region, buckets: buckets } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && $7dcd6190391b2d90$var$createBucketInfoMap(buckets)
        }
    };
}
function $7dcd6190391b2d90$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id, user_pool_client_id: user_pool_client_id, identity_pool_id: identity_pool_id, password_policy: password_policy, mfa_configuration: mfa_configuration, mfa_methods: mfa_methods, unauthenticated_identities_enabled: unauthenticated_identities_enabled, oauth: oauth, username_attributes: username_attributes, standard_required_attributes: standard_required_attributes, groups: groups, passwordless: passwordless } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups: groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = {
        ...authConfig.Cognito,
        identityPoolId: identity_pool_id
    };
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: password_policy.min_length ?? 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $7dcd6190391b2d90$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods?.includes("SMS"),
        totpEnabled: mfa_methods?.includes("TOTP")
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === "token" ? "token" : "code",
            scopes: oauth.scopes,
            providers: $7dcd6190391b2d90$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = {
        ...authConfig.Cognito.loginWith,
        email: username_attributes.includes("email"),
        phone: username_attributes.includes("phone_number"),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes("username")
    };
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>({
            ...acc,
            [curr]: {
                required: true
            }
        }), {});
    if (passwordless) authConfig.Cognito.passwordless = {
        emailOtpEnabled: passwordless.email_otp_enabled,
        smsOtpEnabled: passwordless.sms_otp_enabled,
        webAuthn: passwordless.web_authn ? {
            relyingPartyId: passwordless.web_authn.relying_party_id,
            userVerification: passwordless.web_authn.user_verification
        } : undefined,
        preferredChallenge: passwordless.preferred_challenge
    };
    return authConfig;
}
function $7dcd6190391b2d90$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties?.amazon_pinpoint) return undefined;
    const { amazon_pinpoint: amazon_pinpoint } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $7dcd6190391b2d90$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region, geofence_collections: geofence_collections, maps: maps, search_indices: search_indices } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $7dcd6190391b2d90$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region, default_authorization_type: default_authorization_type, url: url, api_key: api_key, model_introspection: model_introspection } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $7dcd6190391b2d90$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $7dcd6190391b2d90$var$parseCustom(amplifyOutputsCustomProperties) {
    if (!amplifyOutputsCustomProperties?.events) return undefined;
    const { url: url, aws_region: aws_region, api_key: api_key, default_authorization_type: default_authorization_type } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: $7dcd6190391b2d90$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events: Events
    };
}
function $7dcd6190391b2d90$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region, channels: channels, amazon_pinpoint_app_id: amazon_pinpoint_app_id, amazon_connect: amazon_connect } = amplifyOutputsNotificationsProperties;
    const supportedChannels = channels ?? [];
    const hasInAppMessaging = supportedChannels.includes("IN_APP_MESSAGING");
    const hasPushNotification = supportedChannels.includes("APNS") || supportedChannels.includes("FCM");
    const hasCustomerProfilesPush = !!amazon_connect;
    if (!(hasInAppMessaging || hasPushNotification || hasCustomerProfilesPush)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging && amazon_pinpoint_app_id && aws_region) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    // Push device registration can be backed by Amazon Pinpoint and/or Amazon
    // Connect Customer Profiles. Each provider is emitted independently when its
    // configuration is present, mirroring how analytics is parsed.
    const pushNotificationConfig = {};
    if (hasPushNotification && amazon_pinpoint_app_id && aws_region) pushNotificationConfig.Pinpoint = {
        appId: amazon_pinpoint_app_id,
        region: aws_region
    };
    if (amazon_connect) pushNotificationConfig.CustomerProfiles = {
        endpoint: amazon_connect.endpoint,
        region: amazon_connect.aws_region
    };
    if (Object.keys(pushNotificationConfig).length > 0) notificationsConfig.PushNotification = pushNotificationConfig;
    return notificationsConfig;
}
function $7dcd6190391b2d90$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $7dcd6190391b2d90$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $7dcd6190391b2d90$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $7dcd6190391b2d90$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $7dcd6190391b2d90$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $7dcd6190391b2d90$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = $7dcd6190391b2d90$var$parseCustom(amplifyOutputs.custom);
        if (customConfig && "Events" in customConfig) resourcesConfig.API = {
            ...resourcesConfig.API,
            ...customConfig
        };
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $7dcd6190391b2d90$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $7dcd6190391b2d90$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: "userPool",
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AWS_LAMBDA: "lambda",
    OPENID_CONNECT: "oidc"
};
function $7dcd6190391b2d90$var$getGraphQLAuthMode(authType) {
    return $7dcd6190391b2d90$var$authModeNames[authType];
}
const $7dcd6190391b2d90$var$providerNames = {
    GOOGLE: "Google",
    LOGIN_WITH_AMAZON: "Amazon",
    FACEBOOK: "Facebook",
    SIGN_IN_WITH_APPLE: "Apple"
};
function $7dcd6190391b2d90$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($7dcd6190391b2d90$var$providerNames[provider] !== undefined) oAuthProviders.push($7dcd6190391b2d90$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $7dcd6190391b2d90$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === "OPTIONAL") return "optional";
    if (mfaConfiguration === "REQUIRED") return "on";
    return "off";
}
function $7dcd6190391b2d90$var$createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name: name, bucket_name: bucketName, aws_region: region, paths: paths })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        const sanitizedPaths = paths ? Object.entries(paths).reduce((acc, [key, value])=>{
            if (value !== undefined) acc[key] = value;
            return acc;
        }, {}) : undefined;
        mappedBuckets[name] = {
            bucketName: bucketName,
            region: region,
            paths: sanitizedPaths
        };
    });
    return mappedBuckets;
}

});


parcelRegister("78v1Z", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("4xNDb")).Sha256);
parcelRequire("4xNDb");

});
parcelRegister("4xNDb", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $34f0be31e76b3852$export$3b58ea8124ac5e28);

var $7WQrb = parcelRequire("7WQrb");

var $4saKg = parcelRequire("4saKg");

var $bGlNU = parcelRequire("bGlNU");
parcelRequire("6dvWF");
var $3cPkP = parcelRequire("3cPkP");
var $ZB00P = parcelRequire("ZB00P");
var $34f0be31e76b3852$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $bGlNU.RawSha256)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ZB00P.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $3cPkP.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $bGlNU.RawSha256)();
        if (this.secret) {
            this.outer = new (0, $bGlNU.RawSha256)();
            var inner = $34f0be31e76b3852$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
            outer.set(inner);
            for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $34f0be31e76b3852$var$bufferFromSecret(secret) {
    var input = (0, $3cPkP.convertToBuffer)(secret);
    if (input.byteLength > (0, $4saKg.BLOCK_SIZE)) {
        var bufferHash = new (0, $bGlNU.RawSha256)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
    buffer.set(input);
    return buffer;
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $5c96a02c592fcff1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $5c96a02c592fcff1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $5c96a02c592fcff1$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("4saKg", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", () => $33e21cb3f745e23a$export$b2e3d6d444266a5c);
$parcel$export(module.exports, "DIGEST_LENGTH", () => $33e21cb3f745e23a$export$d7bd469488748c5f);
$parcel$export(module.exports, "KEY", () => $33e21cb3f745e23a$export$7167c830cefcb6b5);
$parcel$export(module.exports, "INIT", () => $33e21cb3f745e23a$export$d788bc089976c004);
$parcel$export(module.exports, "MAX_HASHABLE_LENGTH", () => $33e21cb3f745e23a$export$856b3d11dc447b50);
/**
 * @internal
 */ var $33e21cb3f745e23a$export$b2e3d6d444266a5c = 64;
var $33e21cb3f745e23a$export$d7bd469488748c5f = 32;
var $33e21cb3f745e23a$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $33e21cb3f745e23a$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $33e21cb3f745e23a$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;

});

parcelRegister("bGlNU", function(module, exports) {

$parcel$export(module.exports, "RawSha256", () => $881487c8a44da5fa$export$aab6bc1ad3c77a42);

var $4saKg = parcelRequire("4saKg");
/**
 * @internal
 */ var $881487c8a44da5fa$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $4saKg.INIT));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $4saKg.MAX_HASHABLE_LENGTH)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $4saKg.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $4saKg.BLOCK_SIZE) >= (0, $4saKg.BLOCK_SIZE) - 8) {
                for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $4saKg.DIGEST_LENGTH));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $4saKg.KEY)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();

});

parcelRegister("6dvWF", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => (parcelRequire("3cPkP")).convertToBuffer);
$parcel$export(module.exports, "isEmptyData", () => (parcelRequire("ZB00P")).isEmptyData);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $3cPkP = parcelRequire("3cPkP");

var $ZB00P = parcelRequire("ZB00P");

var $aecxA = parcelRequire("aecxA");

var $kjfFh = parcelRequire("kjfFh");

});
parcelRegister("3cPkP", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => $255a5028cde3f3bc$export$4f21f20c2f1a9063);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");

var $6ZWSX = parcelRequire("6ZWSX");
var $255a5028cde3f3bc$require$Buffer = $6ZWSX.Buffer;
// Quick polyfill
var $255a5028cde3f3bc$var$fromUtf8 = typeof $255a5028cde3f3bc$require$Buffer !== "undefined" && $255a5028cde3f3bc$require$Buffer.from ? function(input) {
    return $255a5028cde3f3bc$require$Buffer.from(input, "utf8");
} : (0, $1uolR.fromUtf8);
function $255a5028cde3f3bc$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $255a5028cde3f3bc$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("geIv0", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("1uolR")).fromUtf8);
parcelRequire("1uolR");
parcelRequire("jGtn4");
parcelRequire("3cIry");

});
parcelRegister("1uolR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc);
const $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("jGtn4", function(module, exports) {

var $1uolR = parcelRequire("1uolR");
const $e548b91235db5cfc$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $1uolR.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("3cIry", function(module, exports) {
const $2554f7a5fe934436$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);

});


parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("ZB00P", function(module, exports) {

$parcel$export(module.exports, "isEmptyData", () => $0b9265e3f06832e9$export$ea55f474a468804e);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0b9265e3f06832e9$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}

});

parcelRegister("aecxA", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7724f0827d728d87$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}

});

parcelRegister("kjfFh", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $ec91bbb6f0039d68$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}

});




parcelRegister("lUOK3", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $ff463032e6a14a0a$export$7ea66e3774a60b67);
const $ff463032e6a14a0a$var$SHORT_TO_HEX = {};
const $ff463032e6a14a0a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $ff463032e6a14a0a$var$SHORT_TO_HEX[i] = encodedByte;
    $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $ff463032e6a14a0a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $ff463032e6a14a0a$var$HEX_TO_SHORT) out[i / 2] = $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $ff463032e6a14a0a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $ff463032e6a14a0a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});

parcelRegister("hMbLp", function(module, exports) {

$parcel$export(module.exports, "AuthClass", () => $af0fe83fb084e5d7$export$eeff9d1a8b8c057b);

var $gJw02 = parcelRequire("gJw02");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $af0fe83fb084e5d7$var$logger = new (0, $gJw02.ConsoleLogger)("Auth");
class $af0fe83fb084e5d7$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
        if (authResourcesConfig && authResourcesConfig.Cognito?.userPoolEndpoint) $af0fe83fb084e5d7$var$logger.warn($af0fe83fb084e5d7$var$getCustomEndpointWarningMessage("Amazon Cognito User Pool"));
        if (authResourcesConfig && authResourcesConfig.Cognito?.identityPoolEndpoint) $af0fe83fb084e5d7$var$logger.warn($af0fe83fb084e5d7$var$getCustomEndpointWarningMessage("Amazon Cognito Identity Pool"));
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
     * of non-expired tokens with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}
const $af0fe83fb084e5d7$var$getCustomEndpointWarningMessage = (target)=>`You are using a custom Amazon ${target} endpoint, ensure the endpoint is correct.`;

});


parcelRegister("lKsZv", function(module, exports) {

$parcel$export(module.exports, "CookieStorage", () => $8a827f16696ff978$export$dae7d845015939d5);

var $8Nbse = parcelRequire("8Nbse");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $8a827f16696ff978$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

});
parcelRegister("8Nbse", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === "__proto__") continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    return api;
});

});


parcelRegister("57Of0", function(module, exports) {

$parcel$export(module.exports, "defaultStorage", () => $c47f21f216a22ace$export$586b30dcaeecb901);
$parcel$export(module.exports, "syncSessionStorage", () => $c47f21f216a22ace$export$9015f19b74348a18);

var $ejny4 = parcelRequire("ejny4");

var $g1gqr = parcelRequire("g1gqr");

var $ceLb3 = parcelRequire("ceLb3");

var $4EL3H = parcelRequire("4EL3H");

var $eygwb = parcelRequire("eygwb");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c47f21f216a22ace$export$586b30dcaeecb901 = new (0, $ejny4.DefaultStorage)();
const $c47f21f216a22ace$export$f119d83aa936d634 = new (0, $4EL3H.SessionStorage)();
const $c47f21f216a22ace$export$9015f19b74348a18 = new (0, $eygwb.SyncSessionStorage)();
const $c47f21f216a22ace$export$41feb988b3a84f03 = new (0, $ceLb3.KeyValueStorage)(new (0, $g1gqr.InMemoryStorage)());

});
parcelRegister("ejny4", function(module, exports) {

$parcel$export(module.exports, "DefaultStorage", () => $9f78cbd356024b7e$export$bec45e7703e93690);

var $ceLb3 = parcelRequire("ceLb3");

var $5Y39P = parcelRequire("5Y39P");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9f78cbd356024b7e$export$bec45e7703e93690 extends (0, $ceLb3.KeyValueStorage) {
    constructor(){
        super((0, $5Y39P.getLocalStorageWithFallback)());
    }
}

});
parcelRegister("ceLb3", function(module, exports) {

$parcel$export(module.exports, "KeyValueStorage", () => $0d6aa7e6d5a3429c$export$8536778e426ddf92);

var $fngA0 = parcelRequire("fngA0");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $0d6aa7e6d5a3429c$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.clear();
    }
}

});
parcelRegister("fngA0", function(module, exports) {

$parcel$export(module.exports, "PlatformNotSupportedError", () => $a91ea1244b77fef7$export$f5362e8a6666a455);

var $8rSHg = parcelRequire("8rSHg");

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a91ea1244b77fef7$export$f5362e8a6666a455 extends (0, $e0exy.AmplifyError) {
    constructor(){
        super({
            name: (0, $8rSHg.AmplifyErrorCode).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}

});
parcelRegister("8rSHg", function(module, exports) {

$parcel$export(module.exports, "AmplifyErrorCode", () => $032079a569aa4e0d$export$4e712df6b850c8d0);
var $032079a569aa4e0d$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})($032079a569aa4e0d$export$4e712df6b850c8d0 || ($032079a569aa4e0d$export$4e712df6b850c8d0 = {}));

});



parcelRegister("5Y39P", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageWithFallback", () => $a932b92f8e337975$export$5d9abaf8ff62cd65);
$parcel$export(module.exports, "getSessionStorageWithFallback", () => $a932b92f8e337975$export$518dcc1598f87b);

var $gJw02 = parcelRequire("gJw02");

var $g1gqr = parcelRequire("g1gqr");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $a932b92f8e337975$var$logger = new (0, $gJw02.ConsoleLogger)("CoreStorageUtils");
const $a932b92f8e337975$export$5d9abaf8ff62cd65 = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        $a932b92f8e337975$var$logger.info("localStorage not found. InMemoryStorage is used as a fallback.");
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, $g1gqr.InMemoryStorage)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $a932b92f8e337975$export$518dcc1598f87b = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== "undefined" && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem("test");
            return window.sessionStorage;
        }
        throw new Error("sessionStorage is not defined");
    } catch (e) {
        // Handle any errors related to sessionStorage access
        $a932b92f8e337975$var$logger.info("sessionStorage not found. InMemoryStorage is used as a fallback.");
        return new (0, $g1gqr.InMemoryStorage)();
    }
};

});
parcelRegister("g1gqr", function(module, exports) {

$parcel$export(module.exports, "InMemoryStorage", () => $2875d3cc5c2dfbf0$export$e4315e25b840a0ea);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $2875d3cc5c2dfbf0$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}

});



parcelRegister("4EL3H", function(module, exports) {

$parcel$export(module.exports, "SessionStorage", () => $a3c2eb980ed98e6f$export$2c4b17e1c2e0931);

var $ceLb3 = parcelRequire("ceLb3");

var $5Y39P = parcelRequire("5Y39P");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $a3c2eb980ed98e6f$export$2c4b17e1c2e0931 extends (0, $ceLb3.KeyValueStorage) {
    constructor(){
        super((0, $5Y39P.getSessionStorageWithFallback)());
    }
}

});

parcelRegister("eygwb", function(module, exports) {

$parcel$export(module.exports, "SyncSessionStorage", () => $9fd79fe0a753d145$export$eb7b875b75a2c8df);

var $3Ebx5 = parcelRequire("3Ebx5");

var $5Y39P = parcelRequire("5Y39P");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9fd79fe0a753d145$export$eb7b875b75a2c8df extends (0, $3Ebx5.SyncKeyValueStorage) {
    constructor(){
        super((0, $5Y39P.getSessionStorageWithFallback)());
    }
}

});
parcelRegister("3Ebx5", function(module, exports) {

$parcel$export(module.exports, "SyncKeyValueStorage", () => $9cf2f49300c31e72$export$f7640313c5d17c27);

var $fngA0 = parcelRequire("fngA0");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9cf2f49300c31e72$export$f7640313c5d17c27 {
    constructor(storage){
        this._storage = storage;
    }
    get storage() {
        if (!this._storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
}

});



parcelRegister("5rVdp", function(module, exports) {

$parcel$export(module.exports, "CognitoAWSCredentialsAndIdentityIdProvider", () => $1b1ef4a1e101da96$export$be6550e37264dc26);

var $gJw02 = parcelRequire("gJw02");
var $dIRmt = parcelRequire("dIRmt");

var $bfiP6 = parcelRequire("bfiP6");

var $b62N7 = parcelRequire("b62N7");

var $iNzmv = parcelRequire("iNzmv");

var $hXC67 = parcelRequire("hXC67");

var $kOfpC = parcelRequire("kOfpC");


var $eNoiH = parcelRequire("eNoiH");

var $4a2RL = parcelRequire("4a2RL");

var $inqgD = parcelRequire("inqgD");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1b1ef4a1e101da96$var$logger = new (0, $gJw02.ConsoleLogger)("CognitoCredentialsProvider");
const $1b1ef4a1e101da96$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $1b1ef4a1e101da96$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $1b1ef4a1e101da96$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $1b1ef4a1e101da96$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens } = getCredentialsOptions;
        const { authConfig: authConfig } = getCredentialsOptions;
        try {
            (0, $bfiP6.assertIdentityPoolIdConfig)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $4a2RL.cognitoIdentityIdProvider)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $kOfpC.assertIdTokenInAuthTokens)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $1b1ef4a1e101da96$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $hXC67.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $dIRmt.createGetCredentialsForIdentityClient)({
            endpointResolver: (0, $eNoiH.createCognitoIdentityPoolEndpointResolver)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId
            });
        } catch (e) {
            (0, $iNzmv.assertServiceError)(e);
            throw new (0, $b62N7.AuthError)(e);
        }
        if (clientResult?.Credentials?.AccessKeyId && clientResult?.Credentials?.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $1b1ef4a1e101da96$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $b62N7.AuthError)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $1b1ef4a1e101da96$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $inqgD.formLoginsMap)(authTokens.idToken.toString()) : {};
        const region = (0, $hXC67.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $dIRmt.createGetCredentialsForIdentityClient)({
            endpointResolver: (0, $eNoiH.createCognitoIdentityPoolEndpointResolver)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId,
                Logins: logins
            });
        } catch (e) {
            (0, $iNzmv.assertServiceError)(e);
            throw new (0, $b62N7.AuthError)(e);
        }
        if (clientResult?.Credentials?.AccessKeyId && clientResult?.Credentials?.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $1b1ef4a1e101da96$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                // note: the following call removes guest identityId from the persistent store (localStorage)
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: "primary"
                });
            }
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            return res;
        } else throw new (0, $b62N7.AuthError)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}

});
parcelRegister("dIRmt", function(module, exports) {

$parcel$export(module.exports, "createGetCredentialsForIdentityClient", () => $31f5c5fd5accd3a1$export$5994eaf220022b69);







parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $dj9FS = parcelRequire("dj9FS");






var $7ecIZ = parcelRequire("7ecIZ");

var $bM38a = parcelRequire("bM38a");

var $6vbP8 = parcelRequire("6vbP8");

var $loRHs = parcelRequire("loRHs");

var $gd7G7 = parcelRequire("gd7G7");

var $7BTzY = parcelRequire("7BTzY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $31f5c5fd5accd3a1$export$5994eaf220022b69 = (config)=>(0, $6vbP8.composeServiceApi)((0, $gd7G7.cognitoIdentityTransferHandler), (0, $7BTzY.createClientSerializer)("GetCredentialsForIdentity"), $31f5c5fd5accd3a1$var$getCredentialsForIdentityDeserializer, {
        ...(0, $loRHs.DEFAULT_SERVICE_CLIENT_API_CONFIG),
        ...config,
        userAgentValue: (0, $dj9FS.getAmplifyUserAgent)()
    });
const $31f5c5fd5accd3a1$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $bM38a.parseJsonError)(response);
        throw error;
    }
    const body = await (0, $bM38a.parseJsonBody)(response);
    return {
        IdentityId: body.IdentityId,
        Credentials: $31f5c5fd5accd3a1$var$deserializeCredentials(body.Credentials),
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    };
};
const $31f5c5fd5accd3a1$var$deserializeCredentials = ({ Expiration: Expiration, ...rest } = {})=>({
        ...rest,
        Expiration: Expiration && new Date(Expiration * 1000)
    });

});
parcelRegister("dj9FS", function(module, exports) {

$parcel$export(module.exports, "getAmplifyUserAgent", () => $a3c63f83cda4eabf$export$ede38edb26c0bfdf);

var $k2DuP = parcelRequire("k2DuP");

var $bJXer = parcelRequire("bJXer");

var $iHOzP = parcelRequire("iHOzP");

var $lA3xE = parcelRequire("lA3xE");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a3c63f83cda4eabf$var$BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const $a3c63f83cda4eabf$export$b8f78c57ec316f83 = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, "");
class $a3c63f83cda4eabf$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$a3c63f83cda4eabf$var$BASE_USER_AGENT}/${$a3c63f83cda4eabf$export$b8f78c57ec316f83((0, $bJXer.version))}`;
    }
    get framework() {
        return (0, $iHOzP.detectFramework)();
    }
    get isReactNative() {
        return this.framework === (0, $k2DuP.Framework).ReactNative || this.framework === (0, $k2DuP.Framework).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $iHOzP.observeFrameworkChanges)(fcn);
    }
}
const $a3c63f83cda4eabf$export$2dffd0b5373a4389 = new $a3c63f83cda4eabf$var$PlatformBuilder();
const $a3c63f83cda4eabf$export$7d201307d8979e21 = ({ category: category, action: action } = {})=>{
    const userAgent = [
        [
            $a3c63f83cda4eabf$var$BASE_USER_AGENT,
            $a3c63f83cda4eabf$export$b8f78c57ec316f83((0, $bJXer.version))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $iHOzP.detectFramework)()
    ]);
    if (category && action) {
        const customState = (0, $lA3xE.getCustomUserAgent)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $a3c63f83cda4eabf$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $a3c63f83cda4eabf$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};

});
parcelRegister("k2DuP", function(module, exports) {

$parcel$export(module.exports, "Framework", () => $03a78c53205d4e48$export$638889172ebce0c4);
$parcel$export(module.exports, "Category", () => $03a78c53205d4e48$export$3a8840c5b2ecf003);
$parcel$export(module.exports, "ApiAction", () => $03a78c53205d4e48$export$126e20fdc0f0d34b);
$parcel$export(module.exports, "AuthAction", () => $03a78c53205d4e48$export$900b1436d7e65f4);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $03a78c53205d4e48$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($03a78c53205d4e48$export$638889172ebce0c4 || ($03a78c53205d4e48$export$638889172ebce0c4 = {}));
var $03a78c53205d4e48$export$3a8840c5b2ecf003;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($03a78c53205d4e48$export$3a8840c5b2ecf003 || ($03a78c53205d4e48$export$3a8840c5b2ecf003 = {}));
var $03a78c53205d4e48$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($03a78c53205d4e48$export$89656a7f296a8665 || ($03a78c53205d4e48$export$89656a7f296a8665 = {}));
var $03a78c53205d4e48$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($03a78c53205d4e48$export$30c16f5c43437fd7 || ($03a78c53205d4e48$export$30c16f5c43437fd7 = {}));
var $03a78c53205d4e48$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($03a78c53205d4e48$export$126e20fdc0f0d34b || ($03a78c53205d4e48$export$126e20fdc0f0d34b = {}));
var $03a78c53205d4e48$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})($03a78c53205d4e48$export$900b1436d7e65f4 || ($03a78c53205d4e48$export$900b1436d7e65f4 = {}));
var $03a78c53205d4e48$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($03a78c53205d4e48$export$2f5a715aba4cde93 || ($03a78c53205d4e48$export$2f5a715aba4cde93 = {}));
var $03a78c53205d4e48$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($03a78c53205d4e48$export$afafab3eb8fc6fef || ($03a78c53205d4e48$export$afafab3eb8fc6fef = {}));
var $03a78c53205d4e48$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($03a78c53205d4e48$export$c01a8c16ffda791e || ($03a78c53205d4e48$export$c01a8c16ffda791e = {}));
var $03a78c53205d4e48$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($03a78c53205d4e48$export$68e0695a774ab7fa || ($03a78c53205d4e48$export$68e0695a774ab7fa = {}));
var $03a78c53205d4e48$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($03a78c53205d4e48$export$aa89b4c447a07cee || ($03a78c53205d4e48$export$aa89b4c447a07cee = {}));
var $03a78c53205d4e48$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($03a78c53205d4e48$export$ade48b30f1e78672 || ($03a78c53205d4e48$export$ade48b30f1e78672 = {}));
var $03a78c53205d4e48$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
    PushNotificationAction["RegisterDevice"] = "3";
    PushNotificationAction["RemoveDevice"] = "4";
})($03a78c53205d4e48$export$2c5ee06ab9fa5040 || ($03a78c53205d4e48$export$2c5ee06ab9fa5040 = {}));
var $03a78c53205d4e48$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})($03a78c53205d4e48$export$d4f3c54b808b00ce || ($03a78c53205d4e48$export$d4f3c54b808b00ce = {}));

});

parcelRegister("bJXer", function(module, exports) {

$parcel$export(module.exports, "version", () => $f2bdc992a31a3840$export$83d89fbfd8236492);
// generated by genversion
const $f2bdc992a31a3840$export$83d89fbfd8236492 = "6.20.0";

});

parcelRegister("iHOzP", function(module, exports) {

$parcel$export(module.exports, "detectFramework", () => $8e898e8be4dc09ea$export$9ce73e459ec93b6a);
$parcel$export(module.exports, "observeFrameworkChanges", () => $8e898e8be4dc09ea$export$5d5c467ce0b213f);

var $k2DuP = parcelRequire("k2DuP");

var $1XCWz = parcelRequire("1XCWz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $8e898e8be4dc09ea$var$frameworkCache;
const $8e898e8be4dc09ea$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $8e898e8be4dc09ea$var$resetTriggered = false;
const $8e898e8be4dc09ea$var$SSR_RESET_TIMEOUT = 10; // ms
const $8e898e8be4dc09ea$var$WEB_RESET_TIMEOUT = 10; // ms
const $8e898e8be4dc09ea$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $8e898e8be4dc09ea$export$9ce73e459ec93b6a = ()=>{
    if (!$8e898e8be4dc09ea$var$frameworkCache) {
        $8e898e8be4dc09ea$var$frameworkCache = (0, $1XCWz.detect)();
        if ($8e898e8be4dc09ea$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($8e898e8be4dc09ea$export$d56891f33aa26edc.length)$8e898e8be4dc09ea$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $8e898e8be4dc09ea$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $8e898e8be4dc09ea$var$resetTimeout((0, $k2DuP.Framework).ServerSideUnknown, $8e898e8be4dc09ea$var$SSR_RESET_TIMEOUT);
        $8e898e8be4dc09ea$var$resetTimeout((0, $k2DuP.Framework).WebUnknown, $8e898e8be4dc09ea$var$WEB_RESET_TIMEOUT);
    }
    return $8e898e8be4dc09ea$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $8e898e8be4dc09ea$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($8e898e8be4dc09ea$var$resetTriggered) return;
    $8e898e8be4dc09ea$export$d56891f33aa26edc.push(fcn);
};
function $8e898e8be4dc09ea$export$d2adf65b87e47523() {
    $8e898e8be4dc09ea$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $8e898e8be4dc09ea$var$resetTimeout(framework, delay) {
    if ($8e898e8be4dc09ea$var$frameworkCache === framework && !$8e898e8be4dc09ea$var$resetTriggered) setTimeout(()=>{
        $8e898e8be4dc09ea$export$d2adf65b87e47523();
        $8e898e8be4dc09ea$var$resetTriggered = true;
        setTimeout($8e898e8be4dc09ea$export$9ce73e459ec93b6a, $8e898e8be4dc09ea$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}

});
parcelRegister("1XCWz", function(module, exports) {

$parcel$export(module.exports, "detect", () => $4f5e49be6c2f4c6b$export$17b446b869dad473);

var $k2DuP = parcelRequire("k2DuP");

var $5SWUB = parcelRequire("5SWUB");

var $89E5v = parcelRequire("89E5v");

var $dXsZ3 = parcelRequire("dXsZ3");

var $3uPOM = parcelRequire("3uPOM");

var $7wUjf = parcelRequire("7wUjf");

var $cZAgk = parcelRequire("cZAgk");

var $04Bbd = parcelRequire("04Bbd");

var $cN0eS = parcelRequire("cN0eS");

var $SrjZ5 = parcelRequire("SrjZ5");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $4f5e49be6c2f4c6b$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $k2DuP.Framework).Expo,
        detectionMethod: (0, $cN0eS.expoDetect)
    },
    {
        platform: (0, $k2DuP.Framework).ReactNative,
        detectionMethod: (0, $04Bbd.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, $k2DuP.Framework).NextJs,
        detectionMethod: (0, $3uPOM.nextWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Nuxt,
        detectionMethod: (0, $7wUjf.nuxtWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Angular,
        detectionMethod: (0, $cZAgk.angularWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).React,
        detectionMethod: (0, $5SWUB.reactWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).VueJs,
        detectionMethod: (0, $89E5v.vueWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Svelte,
        detectionMethod: (0, $dXsZ3.svelteWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).WebUnknown,
        detectionMethod: (0, $SrjZ5.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $k2DuP.Framework).NextJsSSR,
        detectionMethod: (0, $3uPOM.nextSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).NuxtSSR,
        detectionMethod: (0, $7wUjf.nuxtSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).ReactSSR,
        detectionMethod: (0, $5SWUB.reactSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).VueJsSSR,
        detectionMethod: (0, $89E5v.vueSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).AngularSSR,
        detectionMethod: (0, $cZAgk.angularSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).SvelteSSR,
        detectionMethod: (0, $dXsZ3.svelteSSRDetect)
    }
];
function $4f5e49be6c2f4c6b$export$17b446b869dad473() {
    return $4f5e49be6c2f4c6b$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $k2DuP.Framework).ServerSideUnknown;
}

});
parcelRegister("5SWUB", function(module, exports) {

$parcel$export(module.exports, "reactWebDetect", () => $627d0a27c40192cb$export$ba3f37c54f0f7805);
$parcel$export(module.exports, "reactSSRDetect", () => $627d0a27c40192cb$export$86269c582305790);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $627d0a27c40192cb$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $i0jHL.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function $627d0a27c40192cb$export$86269c582305790() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env !== "undefined" && !!Object.keys($hPtJY.env).find((key)=>key.includes("react"));
}

});
parcelRegister("i0jHL", function(module, exports) {

$parcel$export(module.exports, "globalExists", () => $143673b599f131f0$export$a15eed0e463030a9);
$parcel$export(module.exports, "windowExists", () => $143673b599f131f0$export$daba2802a1a41c1f);
$parcel$export(module.exports, "documentExists", () => $143673b599f131f0$export$b949ebcb877faa59);
$parcel$export(module.exports, "processExists", () => $143673b599f131f0$export$ba10401363d0f7f6);
$parcel$export(module.exports, "keyPrefixMatch", () => $143673b599f131f0$export$252f88727cff70c7);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $hPtJY = parcelRequire("hPtJY");
const $143673b599f131f0$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $143673b599f131f0$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $143673b599f131f0$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $143673b599f131f0$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $143673b599f131f0$export$ba10401363d0f7f6 = ()=>{
    return typeof $hPtJY !== "undefined";
};
const $143673b599f131f0$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("89E5v", function(module, exports) {

$parcel$export(module.exports, "vueWebDetect", () => $ca4f85d593562053$export$d91d90d62b78936d);
$parcel$export(module.exports, "vueSSRDetect", () => $ca4f85d593562053$export$257a4c0f8294a101);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $ca4f85d593562053$export$d91d90d62b78936d() {
    return (0, $i0jHL.windowExists)() && (0, $i0jHL.keyPrefixMatch)(window, "__VUE");
}
function $ca4f85d593562053$export$257a4c0f8294a101() {
    return (0, $i0jHL.globalExists)() && (0, $i0jHL.keyPrefixMatch)($parcel$global, "__VUE");
}

});

parcelRegister("dXsZ3", function(module, exports) {

$parcel$export(module.exports, "svelteWebDetect", () => $10841416b19b9aca$export$6dafc32a94edaed3);
$parcel$export(module.exports, "svelteSSRDetect", () => $10841416b19b9aca$export$819dcb7fe144d8b0);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $10841416b19b9aca$export$6dafc32a94edaed3() {
    return (0, $i0jHL.windowExists)() && (0, $i0jHL.keyPrefixMatch)(window, "__SVELTE");
}
function $10841416b19b9aca$export$819dcb7fe144d8b0() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env !== "undefined" && !!Object.keys($hPtJY.env).find((key)=>key.includes("svelte"));
}

});

parcelRegister("3uPOM", function(module, exports) {

$parcel$export(module.exports, "nextWebDetect", () => $da3905a0dc1faf56$export$f8462bcf03110eff);
$parcel$export(module.exports, "nextSSRDetect", () => $da3905a0dc1faf56$export$61c08ed144a5d4ca);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $da3905a0dc1faf56$export$f8462bcf03110eff() {
    return (0, $i0jHL.windowExists)() && window.next && typeof window.next === "object";
}
function $da3905a0dc1faf56$export$61c08ed144a5d4ca() {
    return (0, $i0jHL.globalExists)() && ((0, $i0jHL.keyPrefixMatch)($parcel$global, "__next") || (0, $i0jHL.keyPrefixMatch)($parcel$global, "__NEXT"));
}

});

parcelRegister("7wUjf", function(module, exports) {

$parcel$export(module.exports, "nuxtWebDetect", () => $24fea5be4f379b80$export$bed54a4e6d9d25fb);
$parcel$export(module.exports, "nuxtSSRDetect", () => $24fea5be4f379b80$export$fb3ce982948d27e8);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $24fea5be4f379b80$export$bed54a4e6d9d25fb() {
    return (0, $i0jHL.windowExists)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $24fea5be4f379b80$export$fb3ce982948d27e8() {
    return (0, $i0jHL.globalExists)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}

});

parcelRegister("cZAgk", function(module, exports) {

$parcel$export(module.exports, "angularWebDetect", () => $f97e986d2a7067a7$export$b5a20bd39eb02ba0);
$parcel$export(module.exports, "angularSSRDetect", () => $f97e986d2a7067a7$export$8ab518c8987c870f);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $f97e986d2a7067a7$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $i0jHL.documentExists)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $i0jHL.windowExists)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $f97e986d2a7067a7$export$8ab518c8987c870f() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env === "object" && undefined?.startsWith("ng ") || false;
}

});

parcelRegister("04Bbd", function(module, exports) {

$parcel$export(module.exports, "reactNativeDetect", () => $ea500a36684bbe73$export$1c8414c1859e3748);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $ea500a36684bbe73$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}

});

parcelRegister("cN0eS", function(module, exports) {

$parcel$export(module.exports, "expoDetect", () => $0b4145bd3be7264c$export$85fd46d5e29a4f7e);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $0b4145bd3be7264c$export$85fd46d5e29a4f7e() {
    return (0, $i0jHL.globalExists)() && typeof $parcel$global.expo !== "undefined";
}

});

parcelRegister("SrjZ5", function(module, exports) {

$parcel$export(module.exports, "webDetect", () => $86fec584d392e5dc$export$41b1270b988065fb);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $86fec584d392e5dc$export$41b1270b988065fb() {
    return (0, $i0jHL.windowExists)();
}

});



parcelRegister("lA3xE", function(module, exports) {

$parcel$export(module.exports, "getCustomUserAgent", () => $aeac22076f27cf78$export$e399dbcfd99a2928);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $aeac22076f27cf78$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $aeac22076f27cf78$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $aeac22076f27cf78$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $aeac22076f27cf78$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $aeac22076f27cf78$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $aeac22076f27cf78$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $aeac22076f27cf78$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($aeac22076f27cf78$var$customUserAgentState[input.category]).length) delete $aeac22076f27cf78$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $aeac22076f27cf78$export$e399dbcfd99a2928 = (category, api)=>$aeac22076f27cf78$var$customUserAgentState[category]?.[api]?.additionalDetails;

});


parcelRegister("7ecIZ", function(module, exports) {

$parcel$export(module.exports, "parseMetadata", () => $f4d14d043a6280d5$export$978f9418fe0cb26c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f4d14d043a6280d5$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    return {
        ...$f4d14d043a6280d5$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $f4d14d043a6280d5$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";

});

parcelRegister("bM38a", function(module, exports) {

$parcel$export(module.exports, "parseJsonError", () => $79d947bf5668e8ed$export$be467dfcc0538e25);
$parcel$export(module.exports, "parseJsonBody", () => $79d947bf5668e8ed$export$759bcb35b0d1bf81);

var $7ecIZ = parcelRequire("7ecIZ");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $79d947bf5668e8ed$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $79d947bf5668e8ed$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $79d947bf5668e8ed$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    });
};

});

parcelRegister("6vbP8", function(module, exports) {

$parcel$export(module.exports, "composeServiceApi", () => $8099fb84e4081018$export$880429a8ae983d4d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ const $8099fb84e4081018$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};

});

parcelRegister("loRHs", function(module, exports) {

$parcel$export(module.exports, "COGNITO_IDENTITY_SERVICE_NAME", () => $73fbdf38221f58de$export$b8d936b6160bc3fa);
$parcel$export(module.exports, "DEFAULT_SERVICE_CLIENT_API_CONFIG", () => $73fbdf38221f58de$export$22a3716e7860147a);



var $5D9nd = parcelRequire("5D9nd");

var $4ZD6k = parcelRequire("4ZD6k");





parcelRequire("78v1Z");
parcelRequire("lUOK3");







var $bM38a = parcelRequire("bM38a");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $73fbdf38221f58de$export$b8d936b6160bc3fa = "cognito-identity";
const $73fbdf38221f58de$export$22a3716e7860147a = {
    service: $73fbdf38221f58de$export$b8d936b6160bc3fa,
    retryDecider: (0, $4ZD6k.getRetryDecider)((0, $bM38a.parseJsonError)),
    computeDelay: (0, $5D9nd.jitteredBackoff),
    cache: "no-store"
};

});
parcelRegister("5D9nd", function(module, exports) {

$parcel$export(module.exports, "jitteredBackoff", () => $6b984381f509b0c4$export$caea50bde345f648);




var $h05tY = parcelRequire("h05tY");


var $2Bgkm = parcelRequire("2Bgkm");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $6b984381f509b0c4$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $h05tY.jitteredBackoff)((0, $2Bgkm.DEFAULT_MAX_DELAY_MS));
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? (0, $2Bgkm.DEFAULT_MAX_DELAY_MS) : delay;
};

});
parcelRegister("h05tY", function(module, exports) {

$parcel$export(module.exports, "jitteredBackoff", () => $bb00929d82f30d06$export$caea50bde345f648);

var $1Ns4m = parcelRequire("1Ns4m");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $bb00929d82f30d06$export$caea50bde345f648(maxDelayMs = (0, $1Ns4m.MAX_DELAY_MS)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}

});
parcelRegister("1Ns4m", function(module, exports) {

$parcel$export(module.exports, "MAX_DELAY_MS", () => $2ebb2babc51c1967$export$76041b1400befb8b);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2ebb2babc51c1967$export$76041b1400befb8b = 300000;

});


parcelRegister("2Bgkm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_ATTEMPTS", () => $5d2d7858f1de7acf$export$75829a87374c6534);
$parcel$export(module.exports, "AMZ_SDK_INVOCATION_ID_HEADER", () => $5d2d7858f1de7acf$export$ec2fb17ba97fe7ed);
$parcel$export(module.exports, "AMZ_SDK_REQUEST_HEADER", () => $5d2d7858f1de7acf$export$d5da05c23e67fcde);
$parcel$export(module.exports, "DEFAULT_MAX_DELAY_MS", () => $5d2d7858f1de7acf$export$174c32b9a171db76);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5d2d7858f1de7acf$export$75829a87374c6534 = 3;
const $5d2d7858f1de7acf$export$ec2fb17ba97fe7ed = "amz-sdk-invocation-id";
const $5d2d7858f1de7acf$export$d5da05c23e67fcde = "amz-sdk-request";
const $5d2d7858f1de7acf$export$174c32b9a171db76 = 300000;

});


parcelRegister("4ZD6k", function(module, exports) {

$parcel$export(module.exports, "getRetryDecider", () => $8eda02c680edd0d6$export$b919d98317a7685f);

var $8rSHg = parcelRequire("8rSHg");

var $i3rGM = parcelRequire("i3rGM");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $8eda02c680edd0d6$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        const isRetryable = $8eda02c680edd0d6$var$isConnectionError(error) || $8eda02c680edd0d6$var$isThrottlingError(statusCode, errorCode) || (0, $i3rGM.isClockSkewError)(errorCode) || $8eda02c680edd0d6$var$isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $8eda02c680edd0d6$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $8eda02c680edd0d6$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $8eda02c680edd0d6$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $8eda02c680edd0d6$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $8eda02c680edd0d6$var$isConnectionError = (error)=>[
        (0, $8rSHg.AmplifyErrorCode).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        "ERR_NETWORK"
    ].includes(error?.name);
const $8eda02c680edd0d6$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $8eda02c680edd0d6$var$TIMEOUT_ERROR_CODES.includes(errorCode);

});
parcelRegister("i3rGM", function(module, exports) {

$parcel$export(module.exports, "isClockSkewError", () => $25c9c2f444e10e78$export$7b87435661177a94);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $25c9c2f444e10e78$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $25c9c2f444e10e78$export$7b87435661177a94 = (errorCode)=>!!errorCode && $25c9c2f444e10e78$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);

});



parcelRegister("gd7G7", function(module, exports) {

$parcel$export(module.exports, "cognitoIdentityTransferHandler", () => $5146894230cf459f$export$8029646671d2c482);



var $4CfPS = parcelRequire("4CfPS");





parcelRequire("78v1Z");
parcelRequire("lUOK3");







var $8e8Xp = parcelRequire("8e8Xp");

var $7ZymE = parcelRequire("7ZymE");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $5146894230cf459f$export$8029646671d2c482 = (0, $8e8Xp.composeTransferHandler)((0, $4CfPS.unauthenticatedHandler), [
    (0, $7ZymE.createDisableCacheMiddleware)
]);

});
parcelRegister("4CfPS", function(module, exports) {

$parcel$export(module.exports, "unauthenticatedHandler", () => $82a232155848450f$export$ed7e1ccf00f39c4a);

var $9NyS9 = parcelRequire("9NyS9");





var $2EFLV = parcelRequire("2EFLV");

var $fwE8n = parcelRequire("fwE8n");

var $aBoxv = parcelRequire("aBoxv");

var $8e8Xp = parcelRequire("8e8Xp");

var $anVi4 = parcelRequire("anVi4");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $82a232155848450f$export$ed7e1ccf00f39c4a = (0, $8e8Xp.composeTransferHandler)((0, $anVi4.fetchTransferHandler), [
    (0, $aBoxv.userAgentMiddlewareFactory),
    (0, $2EFLV.amzSdkInvocationIdHeaderMiddlewareFactory),
    (0, $9NyS9.retryMiddlewareFactory),
    (0, $fwE8n.amzSdkRequestHeaderMiddlewareFactory)
]);

});
parcelRegister("9NyS9", function(module, exports) {

$parcel$export(module.exports, "retryMiddlewareFactory", () => $b889abbdf709920b$export$72f002d3da1a429f);

var $2Bgkm = parcelRequire("2Bgkm");
/**
 * Middleware that executes the retry logic.
 */ const $b889abbdf709920b$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = (0, $2Bgkm.DEFAULT_RETRY_ATTEMPTS), retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $b889abbdf709920b$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $b889abbdf709920b$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError: isCredentialsExpiredError, retryable: retryable } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $b889abbdf709920b$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $b889abbdf709920b$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $b889abbdf709920b$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};

});

parcelRegister("2EFLV", function(module, exports) {

$parcel$export(module.exports, "amzSdkInvocationIdHeaderMiddlewareFactory", () => $8b58d9acd8e7094c$export$b0cced6a8201397f);






var $3jt4M = parcelRequire("3jt4M");

parcelRequire("78v1Z");
parcelRequire("lUOK3");







var $2Bgkm = parcelRequire("2Bgkm");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects a UUID string to `amz-sdk-invocation-id` header.
 * if the header is not set already. This header is helpful to provide
 * observability to group the requests caused by automatic retry.
 *
 * This middleware is standalone because of extra UUID dependency, we will
 * NOT use this middleware for API categories.
 *
 * Ref: https://sdk.amazonaws.com/kotlin/api/smithy-kotlin/api/1.0.9/http-client/aws.smithy.kotlin.runtime.http.operation/-http-operation-context/-sdk-invocation-id.html
 */ const $8b58d9acd8e7094c$export$b0cced6a8201397f = ()=>(next)=>{
        return async function amzSdkInvocationIdHeaderMiddleware(request) {
            if (!request.headers[0, $2Bgkm.AMZ_SDK_INVOCATION_ID_HEADER]) request.headers[0, $2Bgkm.AMZ_SDK_INVOCATION_ID_HEADER] = (0, $3jt4M.amplifyUuid)();
            return next(request);
        };
    };

});
parcelRegister("3jt4M", function(module, exports) {

$parcel$export(module.exports, "amplifyUuid", () => $1e1861aa821bc2be$export$80bbb53510529a00);

var $5sKyw = parcelRequire("5sKyw");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1e1861aa821bc2be$export$80bbb53510529a00 = (0, $5sKyw.default);

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $7qKRb.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});






parcelRegister("fwE8n", function(module, exports) {

$parcel$export(module.exports, "amzSdkRequestHeaderMiddlewareFactory", () => $ca29143cbe403a07$export$6550d5b3b0ddb1d5);

var $2Bgkm = parcelRequire("2Bgkm");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects `amz-sdk-request` header to indicate the retry state at the time an HTTP request is made.
 * This middleware should co-exist with retryMiddleware as it relies on the retryAttempts value in middleware context
 * set by the retry middleware.
 *
 * Example header: `amz-sdk-request: attempt=1; max=3`.
 *
 * This middleware is standalone because of extra headers may conflict with custom endpoint settings(e.g. CORS), we will
 * NOT use this middleware for API categories.
 */ const $ca29143cbe403a07$export$6550d5b3b0ddb1d5 = ({ maxAttempts: maxAttempts = (0, $2Bgkm.DEFAULT_RETRY_ATTEMPTS) })=>(next, context)=>{
        return async function amzSdkRequestHeaderMiddleware(request) {
            const attemptsCount = context.attemptsCount ?? 0;
            request.headers[0, $2Bgkm.AMZ_SDK_REQUEST_HEADER] = `attempt=${attemptsCount + 1}; max=${maxAttempts}`;
            return next(request);
        };
    };

});

parcelRegister("aBoxv", function(module, exports) {

$parcel$export(module.exports, "userAgentMiddlewareFactory", () => $2b3779b84f2cce55$export$ff28171a05413bc5);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $2b3779b84f2cce55$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent", userAgentValue: userAgentValue = "" })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };

});

parcelRegister("8e8Xp", function(module, exports) {

$parcel$export(module.exports, "composeTransferHandler", () => $faf95af99f8b5697$export$f074d76e52925468);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $faf95af99f8b5697$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };

});

parcelRegister("anVi4", function(module, exports) {

$parcel$export(module.exports, "fetchTransferHandler", () => $c6ff1f678a0bf7c2$export$d2573baf35521e4c);

var $e0exy = parcelRequire("e0exy");

var $8rSHg = parcelRequire("8rSHg");


var $joNXB = parcelRequire("joNXB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c6ff1f678a0bf7c2$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $c6ff1f678a0bf7c2$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $c6ff1f678a0bf7c2$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, $e0exy.AmplifyError)({
            name: (0, $8rSHg.AmplifyErrorCode).NetworkError,
            message: "A network error has occurred.",
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $joNXB.withMemoization)(()=>resp.text()),
        blob: (0, $joNXB.withMemoization)(()=>resp.blob()),
        json: (0, $joNXB.withMemoization)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};

});
parcelRegister("joNXB", function(module, exports) {

$parcel$export(module.exports, "withMemoization", () => $0cf8b26b324855c8$export$580ad1ce15092b15);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $0cf8b26b324855c8$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

});



parcelRegister("7ZymE", function(module, exports) {

$parcel$export(module.exports, "createDisableCacheMiddleware", () => $4b4935fa1cecbf45$export$86e9249ea12798b8);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $4b4935fa1cecbf45$export$86e9249ea12798b8 = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };

});


parcelRegister("7BTzY", function(module, exports) {

$parcel$export(module.exports, "createClientSerializer", () => $ca121d68d707954c$export$c234d706564f344);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ca121d68d707954c$export$c234d706564f344 = (operation)=>(input, endpoint)=>{
        const headers = $ca121d68d707954c$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $ca121d68d707954c$export$a692bdb7eb624f96(endpoint, headers, body);
    };
const $ca121d68d707954c$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
const $ca121d68d707954c$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });

});


parcelRegister("bfiP6", function(module, exports) {

$parcel$export(module.exports, "assertTokenProviderConfig", () => $47b41f0bc3dcf730$export$80c92581e59ed502);
$parcel$export(module.exports, "assertOAuthConfig", () => $47b41f0bc3dcf730$export$c13e6dbaf90a8e5f);
$parcel$export(module.exports, "assertIdentityPoolIdConfig", () => $47b41f0bc3dcf730$export$8a2f5318ea3215e3);
$parcel$export(module.exports, "decodeJWT", () => $47b41f0bc3dcf730$export$9a62e6c0a30e00bc);

var $iLExi = parcelRequire("iLExi");



var $cYnY3 = parcelRequire("cYnY3");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $47b41f0bc3dcf730$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $cYnY3.assert)(assertionValid, (0, $cYnY3.AuthConfigurationErrorCode).AuthUserPoolException);
}
function $47b41f0bc3dcf730$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $cYnY3.assert)(validOAuthConfig, (0, $cYnY3.AuthConfigurationErrorCode).OAuthNotConfigureException);
}
function $47b41f0bc3dcf730$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $cYnY3.assert)(validConfig, (0, $cYnY3.AuthConfigurationErrorCode).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function $47b41f0bc3dcf730$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $iLExi.base64Decoder).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}

});
parcelRegister("iLExi", function(module, exports) {

$parcel$export(module.exports, "base64Decoder", () => $0a6173e3df3e7293$export$1e303d38dab7b376);

var $dfMUF = parcelRequire("dfMUF");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0a6173e3df3e7293$export$1e303d38dab7b376 = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options?.urlSafe) inputStr = inputStr.replace(/-/g, "+").replace(/_/g, "/");
        return (0, $dfMUF.getAtob)()(inputStr);
    }
};

});
parcelRegister("dfMUF", function(module, exports) {

$parcel$export(module.exports, "getCrypto", () => $6f3b4030fc0f3ef5$export$e003cc239f955cb6);
$parcel$export(module.exports, "getBtoa", () => $6f3b4030fc0f3ef5$export$94f295707b435c6d);
$parcel$export(module.exports, "getAtob", () => $6f3b4030fc0f3ef5$export$ea737e7700106b27);

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6f3b4030fc0f3ef5$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $e0exy.AmplifyError)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $6f3b4030fc0f3ef5$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $e0exy.AmplifyError)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $6f3b4030fc0f3ef5$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $e0exy.AmplifyError)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};

});


parcelRegister("cYnY3", function(module, exports) {

$parcel$export(module.exports, "AuthConfigurationErrorCode", () => $c43ab8490e8ade2c$export$7b5c8b570ea8407);
$parcel$export(module.exports, "assert", () => $c43ab8490e8ade2c$export$a7a9523472993e97);

var $bggJy = parcelRequire("bggJy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c43ab8490e8ade2c$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($c43ab8490e8ade2c$export$7b5c8b570ea8407 || ($c43ab8490e8ade2c$export$7b5c8b570ea8407 = {}));
const $c43ab8490e8ade2c$var$authConfigurationErrorMap = {
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $c43ab8490e8ade2c$export$a7a9523472993e97 = (0, $bggJy.createAssertionFunction)($c43ab8490e8ade2c$var$authConfigurationErrorMap);

});
parcelRegister("bggJy", function(module, exports) {

$parcel$export(module.exports, "createAssertionFunction", () => $0d1a22fb669c23b6$export$5cb8fc27ccbe9d40);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0d1a22fb669c23b6$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $e0exy.AmplifyError))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };

});



parcelRegister("b62N7", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0bd2271901d3ce8f$export$145273558d58e0ac);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $0bd2271901d3ce8f$export$145273558d58e0ac extends (0, $e0exy.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0bd2271901d3ce8f$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $0bd2271901d3ce8f$export$145273558d58e0ac.prototype);
    }
}

});

parcelRegister("iNzmv", function(module, exports) {

$parcel$export(module.exports, "assertServiceError", () => $97dc54107f586751$export$5b3890f50cd4853f);

var $8rSHg = parcelRequire("8rSHg");

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $97dc54107f586751$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $b62N7.AuthError)({
        name: (0, $8rSHg.AmplifyErrorCode).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}

});

parcelRegister("hXC67", function(module, exports) {

$parcel$export(module.exports, "getRegionFromUserPoolId", () => $911ca14fd2d79250$export$5f7eb9761ac2d0d9);
$parcel$export(module.exports, "getRegionFromIdentityPoolId", () => $911ca14fd2d79250$export$8fb32fba519c460);

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $911ca14fd2d79250$export$5f7eb9761ac2d0d9(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $b62N7.AuthError)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $911ca14fd2d79250$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $b62N7.AuthError)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}

});

parcelRegister("kOfpC", function(module, exports) {

$parcel$export(module.exports, "assertIdTokenInAuthTokens", () => $611242aba31f7515$export$f4d99632f0717a4b);
$parcel$export(module.exports, "assertAuthTokensWithRefreshToken", () => $611242aba31f7515$export$be38b2d22222d505);
$parcel$export(module.exports, "OAuthStorageKeys", () => $611242aba31f7515$export$3820b4ff343394ea);

var $b62N7 = parcelRequire("b62N7");

var $cutI2 = parcelRequire("cutI2");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $611242aba31f7515$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $611242aba31f7515$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $611242aba31f7515$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $611242aba31f7515$export$31fce2aaeafa4b60 = new (0, $b62N7.AuthError)({
    name: (0, $cutI2.TOKEN_REFRESH_EXCEPTION),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $611242aba31f7515$export$35cfa8cbd2d5bcdd = new (0, $b62N7.AuthError)({
    name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $611242aba31f7515$export$be38b2d22222d505(tokens) {
    if ($611242aba31f7515$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $611242aba31f7515$export$31fce2aaeafa4b60;
    if (!$611242aba31f7515$var$isAuthenticatedWithRefreshToken(tokens)) throw $611242aba31f7515$export$35cfa8cbd2d5bcdd;
}
function $611242aba31f7515$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.DEVICE_METADATA_NOT_FOUND_EXCEPTION),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $611242aba31f7515$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $611242aba31f7515$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $611242aba31f7515$var$isAuthenticatedWithRefreshToken(tokens) {
    return $611242aba31f7515$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $611242aba31f7515$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $611242aba31f7515$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}

});
parcelRegister("cutI2", function(module, exports) {

$parcel$export(module.exports, "USER_UNAUTHENTICATED_EXCEPTION", () => $5d443480af2ea56c$export$d29d1996d6b6f5e3);
$parcel$export(module.exports, "DEVICE_METADATA_NOT_FOUND_EXCEPTION", () => $5d443480af2ea56c$export$740e7000ac27ebf3);
$parcel$export(module.exports, "TOKEN_REFRESH_EXCEPTION", () => $5d443480af2ea56c$export$a0a904daf48e2c33);

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5d443480af2ea56c$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $5d443480af2ea56c$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $5d443480af2ea56c$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $5d443480af2ea56c$export$fe46a12932d2550a = "AutoSignInException";
const $5d443480af2ea56c$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $5d443480af2ea56c$export$a2095d473f418f40 = "InvalidAppSchemeException";
const $5d443480af2ea56c$export$818bb4aeac915442 = "InvalidPreferredRedirectUrlException";
const $5d443480af2ea56c$export$60b68b138a52e5ae = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $5d443480af2ea56c$export$c1829c2a0b9b2e21 = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$a2095d473f418f40,
    message: "A valid non-http app scheme was not found in the config.",
    recoverySuggestion: "Please make sure a valid custom app scheme is present in the config."
});
const $5d443480af2ea56c$export$41a56a70fc1a4962 = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$818bb4aeac915442,
    message: "The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.",
    recoverySuggestion: "Please make sure a matching preferredRedirectUrl is provided."
});
const $5d443480af2ea56c$export$27ddc47447101bcf = "InvalidOriginException";
const $5d443480af2ea56c$export$c01b4acd6291e035 = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $5d443480af2ea56c$export$625255707e22459c = "OAuthSignOutException";
const $5d443480af2ea56c$export$a0a904daf48e2c33 = "TokenRefreshException";
const $5d443480af2ea56c$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";

});


parcelRegister("eNoiH", function(module, exports) {

$parcel$export(module.exports, "createCognitoIdentityPoolEndpointResolver", () => $5a3bc105f4407a41$export$e67952c510717cd6);

var $bNSSG = parcelRequire("bNSSG");

var $7Ar4G = parcelRequire("7Ar4G");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5a3bc105f4407a41$export$e67952c510717cd6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $7Ar4G.AmplifyUrl)(endpointOverride)
        };
        return (0, $bNSSG.cognitoIdentityPoolEndpointResolver)(input);
    };

});
parcelRegister("bNSSG", function(module, exports) {

$parcel$export(module.exports, "cognitoIdentityPoolEndpointResolver", () => $558f323985b88ed6$export$562f22ddc5fcdb97);

var $fqhqt = parcelRequire("fqhqt");







var $7Ar4G = parcelRequire("7Ar4G");

parcelRequire("78v1Z");
parcelRequire("lUOK3");







var $loRHs = parcelRequire("loRHs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $558f323985b88ed6$export$562f22ddc5fcdb97 = ({ region: region })=>({
        url: new (0, $7Ar4G.AmplifyUrl)(`https://${(0, $loRHs.COGNITO_IDENTITY_SERVICE_NAME)}.${region}.${(0, $fqhqt.getDnsSuffix)(region)}`)
    });

});
parcelRegister("fqhqt", function(module, exports) {

$parcel$export(module.exports, "getDnsSuffix", () => $8ce7edd304848afd$export$1c28e37cdcc37f6d);

var $amVal = parcelRequire("amVal");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $8ce7edd304848afd$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $amVal.partitionsInfo);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $amVal.defaultPartition).outputs.dnsSuffix;
};

});
parcelRegister("amVal", function(module, exports) {

$parcel$export(module.exports, "defaultPartition", () => $5c61b283b1e239d9$export$72f3cee421ee8a74);
$parcel$export(module.exports, "partitionsInfo", () => $5c61b283b1e239d9$export$d7c12af0c0f12206);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $5c61b283b1e239d9$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $5c61b283b1e239d9$export$d7c12af0c0f12206 = {
    partitions: [
        $5c61b283b1e239d9$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};

});


parcelRegister("7Ar4G", function(module, exports) {

$parcel$export(module.exports, "AmplifyUrl", () => $69ea4819ac006867$export$beb82d9d9136c16e);
$parcel$export(module.exports, "AmplifyUrlSearchParams", () => $69ea4819ac006867$export$4ea7bbdac595b5fb);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69ea4819ac006867$export$beb82d9d9136c16e = URL;
const $69ea4819ac006867$export$4ea7bbdac595b5fb = URLSearchParams;

});



parcelRegister("4a2RL", function(module, exports) {

$parcel$export(module.exports, "cognitoIdentityIdProvider", () => $afb7bce2c184eee7$export$7c3e576630d5e301);

var $fJPcm = parcelRequire("fJPcm");

var $b62N7 = parcelRequire("b62N7");

var $iNzmv = parcelRequire("iNzmv");

var $hXC67 = parcelRequire("hXC67");



var $eNoiH = parcelRequire("eNoiH");

var $inqgD = parcelRequire("inqgD");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $afb7bce2c184eee7$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    const identityId = await identityIdStore.loadIdentityId();
    if (identityId) return identityId.id;
    const logins = tokens?.idToken ? (0, $inqgD.formLoginsMap)(tokens.idToken.toString()) : {};
    const generatedIdentityId = await $afb7bce2c184eee7$var$generateIdentityId(logins, authConfig);
    // Store generated identityId
    identityIdStore.storeIdentityId({
        id: generatedIdentityId,
        type: tokens ? "primary" : "guest"
    });
    return generatedIdentityId;
}
async function $afb7bce2c184eee7$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $hXC67.getRegionFromIdentityPoolId)(identityPoolId);
    const getId = (0, $fJPcm.createGetIdClient)({
        endpointResolver: (0, $eNoiH.createCognitoIdentityPoolEndpointResolver)({
            endpointOverride: authConfig.identityPoolEndpoint
        })
    });
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    let idResult;
    // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    try {
        idResult = (await getId({
            region: region
        }, {
            IdentityPoolId: identityPoolId,
            Logins: logins
        })).IdentityId;
    } catch (e) {
        (0, $iNzmv.assertServiceError)(e);
        throw new (0, $b62N7.AuthError)(e);
    }
    if (!idResult) throw new (0, $b62N7.AuthError)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}

});
parcelRegister("fJPcm", function(module, exports) {

$parcel$export(module.exports, "createGetIdClient", () => $8f9e1c64abd5224f$export$4dec1d0c118e41c8);







parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $dj9FS = parcelRequire("dj9FS");






var $7ecIZ = parcelRequire("7ecIZ");

var $bM38a = parcelRequire("bM38a");

var $6vbP8 = parcelRequire("6vbP8");

var $loRHs = parcelRequire("loRHs");

var $gd7G7 = parcelRequire("gd7G7");

var $7BTzY = parcelRequire("7BTzY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8f9e1c64abd5224f$export$4dec1d0c118e41c8 = (config)=>(0, $6vbP8.composeServiceApi)((0, $gd7G7.cognitoIdentityTransferHandler), (0, $7BTzY.createClientSerializer)("GetId"), $8f9e1c64abd5224f$var$getIdDeserializer, {
        ...(0, $loRHs.DEFAULT_SERVICE_CLIENT_API_CONFIG),
        ...config,
        userAgentValue: (0, $dj9FS.getAmplifyUserAgent)()
    });
const $8f9e1c64abd5224f$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $bM38a.parseJsonError)(response);
        throw error;
    }
    const body = await (0, $bM38a.parseJsonBody)(response);
    return {
        IdentityId: body.IdentityId,
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    };
};

});

parcelRegister("inqgD", function(module, exports) {

$parcel$export(module.exports, "formLoginsMap", () => $1f210c15c4cfce94$export$edfb13e85a2c0dc4);

var $bfiP6 = parcelRequire("bfiP6");

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1f210c15c4cfce94$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $bfiP6.decodeJWT)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $b62N7.AuthError)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}

});



parcelRegister("e2NQk", function(module, exports) {

$parcel$export(module.exports, "cognitoCredentialsProvider", () => $58a834a1218aacfd$export$be43b753aec531e2);

var $57Of0 = parcelRequire("57Of0");

var $2vm2m = parcelRequire("2vm2m");

var $5rVdp = parcelRequire("5rVdp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $58a834a1218aacfd$export$be43b753aec531e2 = new (0, $5rVdp.CognitoAWSCredentialsAndIdentityIdProvider)(new (0, $2vm2m.DefaultIdentityIdStore)((0, $57Of0.defaultStorage)));

});
parcelRegister("2vm2m", function(module, exports) {

$parcel$export(module.exports, "DefaultIdentityIdStore", () => $9f93ccdc5f95c7af$export$3e97b78667a539a0);

var $gJw02 = parcelRequire("gJw02");

var $bfiP6 = parcelRequire("bfiP6");

var $029ov = parcelRequire("029ov");

var $88z72 = parcelRequire("88z72");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9f93ccdc5f95c7af$var$logger = new (0, $gJw02.ConsoleLogger)("DefaultIdentityIdStore");
class $9f93ccdc5f95c7af$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $bfiP6.assertIdentityPoolIdConfig)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $9f93ccdc5f95c7af$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $bfiP6.assertIdentityPoolIdConfig)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: "guest"
                    };
                }
                return null;
            }
        } catch (err) {
            $9f93ccdc5f95c7af$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $bfiP6.assertIdentityPoolIdConfig)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $9f93ccdc5f95c7af$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $029ov.getAuthStorageKeys)((0, $88z72.IdentityIdStorageKeys))(`com.amplify.${provider}`, identifier);
};

});
parcelRegister("029ov", function(module, exports) {

$parcel$export(module.exports, "DefaultTokenStore", () => $bfc286311b85b781$export$a36be852d43d512);
$parcel$export(module.exports, "getAuthStorageKeys", () => $bfc286311b85b781$export$dfb8da757ca62eed);

var $bfiP6 = parcelRequire("bfiP6");

var $b62N7 = parcelRequire("b62N7");

var $3O5pD = parcelRequire("3O5pD");

var $dvCiI = parcelRequire("dvCiI");

var $fa9cv = parcelRequire("fa9cv");
class $bfc286311b85b781$export$a36be852d43d512 {
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $b62N7.AuthError)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $b62N7.AuthError)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $bfiP6.decodeJWT)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $bfiP6.decodeJWT)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $dvCiI.assert)(tokens !== undefined, (0, $dvCiI.TokenProviderErrorCode).InvalidAuthTokens);
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        else await this.getKeyValueStorage().removeItem(authKeys.idToken);
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        else await this.getKeyValueStorage().removeItem(authKeys.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        else await this.getKeyValueStorage().removeItem(authKeys.signInDetails);
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $bfc286311b85b781$export$4647c72f6828a74d((0, $fa9cv.AUTH_KEY_PREFIX), `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${0, $fa9cv.AUTH_KEY_PREFIX}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const $bfc286311b85b781$export$4647c72f6828a74d = (provider, identifier)=>{
    return $bfc286311b85b781$export$dfb8da757ca62eed((0, $3O5pD.AuthTokenStorageKeys))(`${provider}`, identifier);
};
function $bfc286311b85b781$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}

});
parcelRegister("3O5pD", function(module, exports) {

$parcel$export(module.exports, "AuthTokenStorageKeys", () => $338fa29dda4a9a9e$export$b8429d1428aad8ba);
const $338fa29dda4a9a9e$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails",
    oauthMetadata: "oauthMetadata"
};

});

parcelRegister("dvCiI", function(module, exports) {

$parcel$export(module.exports, "TokenProviderErrorCode", () => $40486dcb7c4675e2$export$cc5909720f29144);
$parcel$export(module.exports, "assert", () => $40486dcb7c4675e2$export$a7a9523472993e97);

var $bggJy = parcelRequire("bggJy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $40486dcb7c4675e2$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($40486dcb7c4675e2$export$cc5909720f29144 || ($40486dcb7c4675e2$export$cc5909720f29144 = {}));
const $40486dcb7c4675e2$var$tokenValidationErrorMap = {
    [$40486dcb7c4675e2$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $40486dcb7c4675e2$export$a7a9523472993e97 = (0, $bggJy.createAssertionFunction)($40486dcb7c4675e2$var$tokenValidationErrorMap);

});

parcelRegister("fa9cv", function(module, exports) {

$parcel$export(module.exports, "AUTH_KEY_PREFIX", () => $639183b62dc5e02d$export$2c8f6d7ed1534551);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $639183b62dc5e02d$export$2c8f6d7ed1534551 = "CognitoIdentityServiceProvider";

});


parcelRegister("88z72", function(module, exports) {

$parcel$export(module.exports, "IdentityIdStorageKeys", () => $c1ea576318e91128$export$dad1700b96c3a835);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1ea576318e91128$export$dad1700b96c3a835 = {
    identityId: "identityId"
};

});



parcelRegister("54W3M", function(module, exports) {

$parcel$export(module.exports, "cognitoUserPoolsTokenProvider", () => $f908ae8342f11964$export$18e158b80aac31a7);

var $cNsoR = parcelRequire("cNsoR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $f908ae8342f11964$export$18e158b80aac31a7 = new (0, $cNsoR.CognitoUserPoolsTokenProvider)();
const { tokenOrchestrator: $f908ae8342f11964$export$66561e66d62991d0 } = $f908ae8342f11964$export$18e158b80aac31a7;

});
parcelRegister("cNsoR", function(module, exports) {

$parcel$export(module.exports, "CognitoUserPoolsTokenProvider", () => $50ac27d44f503ae7$export$85b743bbda58cb6c);

var $57Of0 = parcelRequire("57Of0");

var $fNgI2 = parcelRequire("fNgI2");

var $029ov = parcelRequire("029ov");

var $8sJng = parcelRequire("8sJng");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $50ac27d44f503ae7$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $029ov.DefaultTokenStore)();
        this.authTokenStore.setKeyValueStorage((0, $57Of0.defaultStorage));
        this.tokenOrchestrator = new (0, $8sJng.TokenOrchestrator)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $fNgI2.refreshAuthTokens));
    }
    getTokens(options = {}) {
        return this.tokenOrchestrator.getTokens(options);
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.tokenOrchestrator.setClientMetadataProvider(clientMetadataProvider);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}

});
parcelRegister("fNgI2", function(module, exports) {

$parcel$export(module.exports, "refreshAuthTokens", () => $ec8c93d7f96724a1$export$ab413c2cb4a135d9);

var $bfiP6 = parcelRequire("bfiP6");
var $fEpEV = parcelRequire("fEpEV");

var $hXC67 = parcelRequire("hXC67");

var $kOfpC = parcelRequire("kOfpC");

var $b62N7 = parcelRequire("b62N7");

var $eAu1N = parcelRequire("eAu1N");






var $c3teP = parcelRequire("c3teP");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ec8c93d7f96724a1$var$refreshAuthTokensFunction = async ({ tokens: tokens, authConfig: authConfig, username: username, clientMetadata: clientMetadata })=>{
    (0, $bfiP6.assertTokenProviderConfig)(authConfig?.Cognito);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig.Cognito;
    const region = (0, $hXC67.getRegionFromUserPoolId)(userPoolId);
    (0, $kOfpC.assertAuthTokensWithRefreshToken)(tokens);
    const getTokensFromRefreshToken = (0, $c3teP.createGetTokensFromRefreshTokenClient)({
        endpointResolver: (0, $eAu1N.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult: AuthenticationResult } = await getTokensFromRefreshToken({
        region: region
    }, {
        ClientId: userPoolClientId,
        RefreshToken: tokens.refreshToken,
        DeviceKey: tokens.deviceMetadata?.deviceKey,
        ClientMetadata: clientMetadata
    });
    const accessToken = (0, $bfiP6.decodeJWT)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $bfiP6.decodeJWT)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $b62N7.AuthError)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: AuthenticationResult?.RefreshToken ?? tokens.refreshToken,
        username: username
    };
};
const $ec8c93d7f96724a1$export$ab413c2cb4a135d9 = (0, $fEpEV.deDupeAsyncFunction)($ec8c93d7f96724a1$var$refreshAuthTokensFunction);
const $ec8c93d7f96724a1$export$d5c14381105da273 = $ec8c93d7f96724a1$var$refreshAuthTokensFunction;

});
parcelRegister("fEpEV", function(module, exports) {

$parcel$export(module.exports, "deDupeAsyncFunction", () => $f03ecb0e97a4a66d$export$cd8d22e3dc00ae5a);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $f03ecb0e97a4a66d$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};

});

parcelRegister("eAu1N", function(module, exports) {

$parcel$export(module.exports, "createCognitoUserPoolEndpointResolver", () => $f24e571831226942$export$9fc8f7dceefe00a6);

var $7Ar4G = parcelRequire("7Ar4G");

var $Reymm = parcelRequire("Reymm");
const $f24e571831226942$export$9fc8f7dceefe00a6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $7Ar4G.AmplifyUrl)(endpointOverride)
        };
        return (0, $Reymm.cognitoUserPoolEndpointResolver)(input);
    };

});
parcelRegister("Reymm", function(module, exports) {

$parcel$export(module.exports, "cognitoUserPoolEndpointResolver", () => $0c02ab99f864ae06$export$54dd9d9496cb66b9);

var $fqhqt = parcelRequire("fqhqt");

var $7Ar4G = parcelRequire("7Ar4G");

var $5l8w8 = parcelRequire("5l8w8");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0c02ab99f864ae06$export$54dd9d9496cb66b9 = ({ region: region })=>({
        url: new (0, $7Ar4G.AmplifyUrl)(`https://${(0, $5l8w8.COGNITO_IDP_SERVICE_NAME)}.${region}.${(0, $fqhqt.getDnsSuffix)(region)}`)
    });

});
parcelRegister("5l8w8", function(module, exports) {

$parcel$export(module.exports, "COGNITO_IDP_SERVICE_NAME", () => $87e7d4635adc81eb$export$a0efffb4b0c72e04);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $87e7d4635adc81eb$export$a0efffb4b0c72e04 = "cognito-idp";

});



parcelRegister("c3teP", function(module, exports) {

$parcel$export(module.exports, "createGetTokensFromRefreshTokenClient", () => $9036eb8130a83d66$export$fd10af15e909e7b5);

var $6vbP8 = parcelRequire("6vbP8");

var $2qp1o = parcelRequire("2qp1o");

var $7OD1Z = parcelRequire("7OD1Z");



var $bdRfK = parcelRequire("bdRfK");

var $luL8F = parcelRequire("luL8F");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9036eb8130a83d66$export$fd10af15e909e7b5 = (config)=>(0, $6vbP8.composeServiceApi)((0, $bdRfK.cognitoUserPoolTransferHandler), (0, $2qp1o.createUserPoolSerializer)("GetTokensFromRefreshToken"), (0, $7OD1Z.createUserPoolDeserializer)(), {
        ...(0, $luL8F.DEFAULT_SERVICE_CLIENT_API_CONFIG),
        ...config
    });

});
parcelRegister("2qp1o", function(module, exports) {

$parcel$export(module.exports, "createUserPoolSerializer", () => $55e831673135f9bc$export$1113413e6e842bef);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $55e831673135f9bc$export$1113413e6e842bef = (operation)=>(input, endpoint)=>{
        const headers = $55e831673135f9bc$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $55e831673135f9bc$var$buildHttpRpcRequest(endpoint, headers, body);
    };
const $55e831673135f9bc$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
const $55e831673135f9bc$var$buildHttpRpcRequest = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });

});

parcelRegister("7OD1Z", function(module, exports) {

$parcel$export(module.exports, "createUserPoolDeserializer", () => $c23928af209b7a43$export$8159795418a3e796);

var $bM38a = parcelRequire("bM38a");

var $iNzmv = parcelRequire("iNzmv");

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c23928af209b7a43$export$8159795418a3e796 = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $bM38a.parseJsonError)(response);
            (0, $iNzmv.assertServiceError)(error);
            throw new (0, $b62N7.AuthError)({
                name: error.name,
                message: error.message,
                metadata: error.$metadata
            });
        }
        return (0, $bM38a.parseJsonBody)(response);
    };

});

parcelRegister("bdRfK", function(module, exports) {

$parcel$export(module.exports, "cognitoUserPoolTransferHandler", () => $8adeed53cf0c96fd$export$10f11e95d7a96f7b);

var $1qbEC = parcelRequire("1qbEC");

var $8e8Xp = parcelRequire("8e8Xp");

var $4CfPS = parcelRequire("4CfPS");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $8adeed53cf0c96fd$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers = {
                ...request.headers,
                "cache-control": "no-store",
                ...await (0, $1qbEC.Amplify).libraryOptions?.Auth?.headers?.()
            };
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $8adeed53cf0c96fd$export$10f11e95d7a96f7b = (0, $8e8Xp.composeTransferHandler)((0, $4CfPS.unauthenticatedHandler), [
    $8adeed53cf0c96fd$var$disableCacheMiddlewareFactory
]);

});

parcelRegister("luL8F", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SERVICE_CLIENT_API_CONFIG", () => $7e2fded04fb92020$export$22a3716e7860147a);

var $4ZD6k = parcelRequire("4ZD6k");
var $5D9nd = parcelRequire("5D9nd");
var $bM38a = parcelRequire("bM38a");

var $dj9FS = parcelRequire("dj9FS");

var $5l8w8 = parcelRequire("5l8w8");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7e2fded04fb92020$export$22a3716e7860147a = {
    service: (0, $5l8w8.COGNITO_IDP_SERVICE_NAME),
    retryDecider: (0, $4ZD6k.getRetryDecider)((0, $bM38a.parseJsonError)),
    computeDelay: (0, $5D9nd.jitteredBackoff),
    get userAgentValue () {
        return (0, $dj9FS.getAmplifyUserAgent)();
    },
    cache: "no-store"
};

});



parcelRegister("8sJng", function(module, exports) {

$parcel$export(module.exports, "TokenOrchestrator", () => $67be88f695aa02a6$export$ba2f3fbc8979d2e6);

var $5RCQ5 = parcelRequire("5RCQ5");

var $5RCQ5 = parcelRequire("5RCQ5");
var $bfiP6 = parcelRequire("bfiP6");
var $a93i9 = parcelRequire("a93i9");
var $5ZJQw = parcelRequire("5ZJQw");

var $iNzmv = parcelRequire("iNzmv");

var $b62N7 = parcelRequire("b62N7");

var $hHV4w = parcelRequire("hHV4w");

var $gwp96 = parcelRequire("gwp96");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $67be88f695aa02a6$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $a93i9.isBrowser)() ? async ()=>{
            if (!await (0, $hHV4w.oAuthStore).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $gwp96.addInflightPromise)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $hHV4w.oAuthStore).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $b62N7.AuthError)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $b62N7.AuthError)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.clientMetadataProvider = clientMetadataProvider;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $5ZJQw.isTokenExpired)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $5ZJQw.isTokenExpired)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username,
                clientMetadata: options?.clientMetadata ?? await this.clientMetadataProvider?.()
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username, clientMetadata: clientMetadata }) {
        try {
            const { signInDetails: signInDetails } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username,
                clientMetadata: clientMetadata
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $5RCQ5.Hub).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $5RCQ5.AMPLIFY_SYMBOL));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $iNzmv.assertServiceError)(err);
        // Only clear tokens for definitive authentication failures
        // Do NOT clear tokens for transient errors like service issues, rate limits, etc.
        const shouldClearTokens = this.isAuthenticationError(err);
        if (shouldClearTokens) this.clearTokens();
        (0, $5RCQ5.Hub).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $5RCQ5.AMPLIFY_SYMBOL));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    isAuthenticationError(err) {
        // Only clear tokens for errors that definitively indicate the tokens are invalid
        // and re-authentication is required. All other errors (service errors, rate limits, etc.)
        // should preserve the tokens to allow for retry.
        // See: https://github.com/aws-amplify/amplify-js/issues/14534
        const authErrorNames = [
            "NotAuthorizedException",
            "TokenRevokedException",
            "UserNotFoundException",
            "PasswordResetRequiredException",
            "UserNotConfirmedException",
            "RefreshTokenReuseException"
        ];
        return authErrorNames.some((errorName)=>err?.name?.startsWith?.(errorName));
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
}

});
parcelRegister("a93i9", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $138054732e02d887$export$4e09c449d6c407f7);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $138054732e02d887$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";

});

parcelRegister("5ZJQw", function(module, exports) {

$parcel$export(module.exports, "isTokenExpired", () => $3ec585405a56a5d2$export$b007d77a962aa175);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3ec585405a56a5d2$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift, tolerance: tolerance = 5000 }) {
    const currentTime = Date.now();
    return currentTime + clockDrift + tolerance > expiresAt;
}

});

parcelRegister("hHV4w", function(module, exports) {

$parcel$export(module.exports, "oAuthStore", () => $a07429c4e1a8223f$export$2ed0ec267eb6cb1c);

var $57Of0 = parcelRequire("57Of0");

var $DNF8t = parcelRequire("DNF8t");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a07429c4e1a8223f$export$2ed0ec267eb6cb1c = new (0, $DNF8t.DefaultOAuthStore)((0, $57Of0.defaultStorage));

});
parcelRegister("DNF8t", function(module, exports) {

$parcel$export(module.exports, "DefaultOAuthStore", () => $c561250709ea1156$export$9b2cef5d94f9b6e8);

var $bfiP6 = parcelRequire("bfiP6");

var $029ov = parcelRequire("029ov");

var $kOfpC = parcelRequire("kOfpC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c561250709ea1156$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $c561250709ea1156$var$name = "CognitoIdentityServiceProvider";
class $c561250709ea1156$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($c561250709ea1156$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($c561250709ea1156$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $bfiP6.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = $c561250709ea1156$var$createKeysForAuthStorage($c561250709ea1156$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $c561250709ea1156$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $029ov.getAuthStorageKeys)((0, $kOfpC.OAuthStorageKeys))(provider, identifier);
};

});


parcelRegister("gwp96", function(module, exports) {

$parcel$export(module.exports, "addInflightPromise", () => $7b9efa68fb4ba4e8$export$c55b09e0e9be0d04);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7b9efa68fb4ba4e8$var$inflightPromises = [];
const $7b9efa68fb4ba4e8$export$c55b09e0e9be0d04 = (resolver)=>{
    $7b9efa68fb4ba4e8$var$inflightPromises.push(resolver);
};
const $7b9efa68fb4ba4e8$export$bcb0b7a105a5df59 = ()=>{
    while($7b9efa68fb4ba4e8$var$inflightPromises.length)$7b9efa68fb4ba4e8$var$inflightPromises.pop()?.();
};

});





parcelRegister("l8biK", function(module, exports) {

$parcel$export(module.exports, "generateClient", () => $f4242ff18250f860$export$46dced0a73bfb171);

var $f979g = parcelRequire("f979g");

var $1qbEC = parcelRequire("1qbEC");
/**
 * Generates an API client that can work with models or raw GraphQL
 *
 * @returns {@link V6Client}
 * @throws {@link Error} - Throws error when client cannot be generated due to configuration issues.
 */ function $f4242ff18250f860$export$46dced0a73bfb171(options) {
    return (0, $f979g.generateClient)({
        ...options || {},
        amplify: (0, $1qbEC.Amplify)
    });
}

});
parcelRegister("f979g", function(module, exports) {

$parcel$export(module.exports, "generateClient", () => $d8005fae3431ff04$export$46dced0a73bfb171);

var $5RCQ5 = parcelRequire("5RCQ5");
parcelRequire("T4Q7j");
var $868fu = parcelRequire("868fu");

var $lvJDy = parcelRequire("lvJDy");

var $4OgCt = parcelRequire("4OgCt");

var $lSN55 = parcelRequire("lSN55");

var $yL58Q = parcelRequire("yL58Q");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 *
 * Creates a client that can be used to make GraphQL requests, using a provided `AmplifyClassV6`
 * compatible context object for config and auth fetching.
 *
 * @param params
 * @returns
 */ function $d8005fae3431ff04$export$46dced0a73bfb171(params) {
    const client = {
        [(0, $lvJDy.__amplify)]: params.amplify,
        [(0, $lvJDy.__authMode)]: params.authMode,
        [(0, $lvJDy.__authToken)]: params.authToken,
        [(0, $lvJDy.__apiKey)]: "apiKey" in params ? params.apiKey : undefined,
        [(0, $lvJDy.__endpoint)]: "endpoint" in params ? params.endpoint : undefined,
        [(0, $lvJDy.__headers)]: params.headers,
        graphql: $yL58Q.graphql,
        cancel: $yL58Q.cancel,
        isCancelError: $yL58Q.isCancelError,
        models: $d8005fae3431ff04$var$emptyProperty,
        enums: $d8005fae3431ff04$var$emptyProperty,
        queries: $d8005fae3431ff04$var$emptyProperty,
        mutations: $d8005fae3431ff04$var$emptyProperty,
        subscriptions: $d8005fae3431ff04$var$emptyProperty
    };
    const apiGraphqlConfig = params.amplify.getConfig().API?.GraphQL;
    if (client[0, $lvJDy.__endpoint]) {
        if (!client[0, $lvJDy.__authMode]) throw new Error("generateClient() requires an explicit `authMode` when `endpoint` is provided.");
        if (client[0, $lvJDy.__authMode] === "apiKey" && !client[0, $lvJDy.__apiKey]) throw new Error("generateClient() requires an explicit `apiKey` when `endpoint` is provided and `authMode = 'apiKey'`.");
    }
    if (!client[0, $lvJDy.__endpoint]) {
        if ((0, $4OgCt.isApiGraphQLConfig)(apiGraphqlConfig)) (0, $868fu.addSchemaToClient)(client, apiGraphqlConfig, (0, $lvJDy.getInternals));
        else // This happens when the `Amplify.configure()` call gets evaluated after the `generateClient()` call.
        //
        // Cause: when the `generateClient()` and the `Amplify.configure()` calls are located in
        // different source files, script bundlers may randomly arrange their orders in the production
        // bundle.
        //
        // With the current implementation, the `client.models` instance created by `generateClient()`
        // will be rebuilt on every `Amplify.configure()` call that's provided with a valid GraphQL
        // provider configuration.
        //
        // TODO: revisit, and reverify this approach when enabling multiple clients for multi-endpoints
        // configuration.
        $d8005fae3431ff04$var$generateModelsPropertyOnAmplifyConfigure(client);
    }
    return client;
}
const $d8005fae3431ff04$var$generateModelsPropertyOnAmplifyConfigure = (clientRef)=>{
    (0, $5RCQ5.Hub).listen("core", (coreEvent)=>{
        if (!(0, $lSN55.isConfigureEventWithResourceConfig)(coreEvent.payload)) return;
        const apiGraphQLConfig = coreEvent.payload.data.API?.GraphQL;
        if ((0, $4OgCt.isApiGraphQLConfig)(apiGraphQLConfig)) (0, $868fu.addSchemaToClient)(clientRef, apiGraphQLConfig, (0, $lvJDy.getInternals));
    });
};
const $d8005fae3431ff04$var$emptyProperty = new Proxy({}, {
    get () {
        throw new Error("Client could not be generated. This is likely due to `Amplify.configure()` not being called prior to `generateClient()` or because the configuration passed to `Amplify.configure()` is missing GraphQL provider configuration.");
    }
});

});
parcelRegister("T4Q7j", function(module, exports) {

$parcel$export(module.exports, "addSchemaToClient", () => (parcelRequire("868fu")).addSchemaToClient);
$parcel$export(module.exports, "INTERNAL_USER_AGENT_OVERRIDE", () => (parcelRequire("6yFdo")).INTERNAL_USER_AGENT_OVERRIDE);
parcelRequire("kldD5");
var $iB0vS = parcelRequire("iB0vS");

var $868fu = parcelRequire("868fu");

var $kqDuS = parcelRequire("kqDuS");

var $6yFdo = parcelRequire("6yFdo");

});
parcelRegister("kldD5", function(module, exports) {

var $iB0vS = parcelRequire("iB0vS");

});
parcelRegister("iB0vS", function(module, exports) {
const $94ddf087d6d465ea$export$46ae62414808e169 = Symbol();

});


parcelRegister("868fu", function(module, exports) {

$parcel$export(module.exports, "addSchemaToClient", () => $769f1fb48d2d125f$export$7b6ce137510d6eea);

var $7uTmY = parcelRequire("7uTmY");

var $dcKA0 = parcelRequire("dcKA0");

var $8NA3L = parcelRequire("8NA3L");

var $4lQbP = parcelRequire("4lQbP");

var $43AGO = parcelRequire("43AGO");

var $4vIv1 = parcelRequire("4vIv1");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $769f1fb48d2d125f$export$7b6ce137510d6eea(client, apiGraphqlConfig, getInternals) {
    (0, $4vIv1.upgradeClientCancellation)(client);
    client.models = (0, $43AGO.generateModelsProperty)(client, apiGraphqlConfig, getInternals);
    client.enums = (0, $4lQbP.generateEnumsProperty)(apiGraphqlConfig);
    client.queries = (0, $7uTmY.generateCustomQueriesProperty)(client, apiGraphqlConfig, getInternals);
    client.mutations = (0, $7uTmY.generateCustomMutationsProperty)(client, apiGraphqlConfig, getInternals);
    client.subscriptions = (0, $7uTmY.generateCustomSubscriptionsProperty)(client, apiGraphqlConfig, getInternals);
    client.conversations = (0, $dcKA0.generateConversationsProperty)(client, apiGraphqlConfig, getInternals);
    client.generations = (0, $8NA3L.generateGenerationsProperty)(client, apiGraphqlConfig, getInternals);
    return client;
}

});
parcelRegister("7uTmY", function(module, exports) {

$parcel$export(module.exports, "generateCustomMutationsProperty", () => $384fd313d6d81b8e$export$4cfb295468e38bf8);
$parcel$export(module.exports, "generateCustomQueriesProperty", () => $384fd313d6d81b8e$export$db1f08e6cb9c83c8);
$parcel$export(module.exports, "generateCustomSubscriptionsProperty", () => $384fd313d6d81b8e$export$1da3b8c669e8defb);

var $aDcpw = parcelRequire("aDcpw");
const $384fd313d6d81b8e$var$operationTypeMap = {
    queries: "query",
    mutations: "mutation",
    subscriptions: "subscription"
};
function $384fd313d6d81b8e$export$74caac47d0aa1c04(client, config, operationsType, getInternals) {
    // some bundlers end up with `Amplify.configure` being called *after* generate client.
    // if that occurs, we need to *not error* while we wait. handling for late configuration
    // occurs in `generateClient()`. we do not need to subscribe to Hub events here.
    if (!config) return {};
    const modelIntrospection = config.modelIntrospection;
    // model intro schema might be absent if there's not actually a configured GraphQL API
    if (!modelIntrospection) return {};
    // custom operations will be absent from model intro schema if no custom ops
    // are present on the source schema.
    const operations = modelIntrospection[operationsType];
    if (!operations) return {};
    const ops = {};
    const useContext = getInternals(client).amplify === null;
    for (const operation of Object.values(operations))ops[operation.name] = (0, $aDcpw.customOpFactory)(client, modelIntrospection, $384fd313d6d81b8e$var$operationTypeMap[operationsType], operation, useContext, getInternals);
    return ops;
}
function $384fd313d6d81b8e$export$4cfb295468e38bf8(client, config, getInternals) {
    return $384fd313d6d81b8e$export$74caac47d0aa1c04(client, config, "mutations", getInternals);
}
function $384fd313d6d81b8e$export$db1f08e6cb9c83c8(client, config, getInternals) {
    return $384fd313d6d81b8e$export$74caac47d0aa1c04(client, config, "queries", getInternals);
}
function $384fd313d6d81b8e$export$1da3b8c669e8defb(client, config, getInternals) {
    return $384fd313d6d81b8e$export$74caac47d0aa1c04(client, config, "subscriptions", getInternals);
}

});
parcelRegister("aDcpw", function(module, exports) {

$parcel$export(module.exports, "customOpFactory", () => $e0562116a3824935$export$d16bcce9536223e0);

var $d4PzE = parcelRequire("d4PzE");

var $lmrPf = parcelRequire("lmrPf");

var $kffnY = parcelRequire("kffnY");

var $2DZ3G = parcelRequire("2DZ3G");

var $4vIv1 = parcelRequire("4vIv1");

var $6yFdo = parcelRequire("6yFdo");
/**
 * Type guard for checking whether a Custom Operation argument is a contextSpec object
 */ const $e0562116a3824935$var$argIsContextSpec = (arg)=>{
    return typeof arg?.token?.value === "symbol";
};
/**
 * Builds an operation function, embedded with all client and context data, that
 * can be attached to a client as a custom query or mutation.
 *
 * If we have this source schema:
 *
 * ```typescript
 * a.schema({
 *   echo: a.query()
 *     .arguments({input: a.string().required()})
 *     .returns(a.string())
 * })
 * ```
 *
 * Our model intro schema will contain an entry like this:
 *
 * ```ts
 * {
 *   queries: {
 *     echo: {
 *       name: "echo",
 *       isArray: false,
 *       type: 'String',
 *       isRequired: false,
 *       arguments: {
 *         input: {
 *           name: 'input',
 *           isArray: false,
 *           type: String,
 *           isRequired: true
 *         }
 *       }
 *     }
 *   }
 * }
 * ```
 *
 * The `echo` object is used to build the `echo' method that goes here:
 *
 * ```typescript
 * const client = generateClent()
 * const { data } = await client.queries.echo({input: 'a string'});
 * //                                    ^
 * //                                    |
 * //                                    +-- This one right here.
 * //
 * ```
 *
 *
 * @param client The client to run graphql queries through.
 * @param modelIntrospection The model introspection schema the op comes from.
 * @param operationType The broad category of graphql operation.
 * @param operation The operation definition from the introspection schema.
 * @param useContext Whether the function needs to accept an SSR context.
 * @returns The operation function to attach to query, mutations, etc.
 */ function $e0562116a3824935$export$d16bcce9536223e0(client, modelIntrospection, operationType, operation, useContext, getInternals, customUserAgentDetails) {
    // .arguments() are defined for the custom operation in the schema builder
    // and are present in the model introspection schema
    const argsDefined = operation.arguments !== undefined;
    const op = (...args)=>{
        // options is always the last argument
        const options = args[args.length - 1];
        let contextSpec;
        let arg;
        if (useContext) {
            if ($e0562116a3824935$var$argIsContextSpec(args[0])) contextSpec = args[0];
            else throw new Error(`Invalid first argument passed to ${operation.name}. Expected contextSpec`);
        }
        if (argsDefined) {
            if (useContext) arg = args[1];
            else arg = args[0];
        }
        if (operationType === "subscription") return $e0562116a3824935$var$_opSubscription(// subscriptions are only enabled on the clientside
        client, modelIntrospection, operation, getInternals, arg, options, customUserAgentDetails);
        return $e0562116a3824935$var$_op(client, modelIntrospection, operationType, operation, getInternals, arg, options, contextSpec, customUserAgentDetails);
    };
    return op;
}
/**
 * Runtime test and type guard to check whether `o[field]` is a `String`.
 *
 * ```typescript
 * if (hasStringField(o, 'prop')) {
 *   const s = o.prop;
 *   //    ^? const s: string
 * }
 * ```
 *
 * @param o Object to inspect
 * @param field Field to look for
 * @returns Boolean: `true` if the `o[field]` is a `string`
 */ function $e0562116a3824935$var$hasStringField(o, field) {
    return typeof o[field] === "string";
}
function $e0562116a3824935$var$isEnumType(type) {
    return type instanceof Object && "enum" in type;
}
function $e0562116a3824935$var$isInputType(type) {
    return type instanceof Object && "input" in type;
}
/**
 * For a list argument this is the *element* type, so `isRequired` — which is
 * element-level for lists — is the correct source for the `!`. The list's own
 * nullability is applied by the caller. See {@link isArgumentRequired}.
 *
 * @param argDef A single argument definition from a custom operation
 * @returns A string naming the base type including the `!` if that type is non-null.
 */ function $e0562116a3824935$var$argumentBaseTypeString({ type: type, isRequired: isRequired }) {
    const requiredFlag = isRequired ? "!" : "";
    if ($e0562116a3824935$var$isEnumType(type)) return `${type.enum}${requiredFlag}`;
    if ($e0562116a3824935$var$isInputType(type)) return `${type.input}${requiredFlag}`;
    return `${type}${requiredFlag}`;
}
/**
 * Determines whether a value must be provided for a custom operation argument,
 * i.e. whether the argument itself is non-null in the GraphQL schema.
 *
 * For list arguments, the model introspection schema encodes *element* nullability
 * in `isRequired` and *list* nullability in `isArrayNullable`. For example, an
 * argument declared as `a.ref('Color').required().array()` is emitted as `[Color!]`
 * and introspected as `{ isArray: true, isRequired: true, isArrayNullable: true }`
 * — a nullable list of non-null elements, so the argument itself is optional. Only
 * the outermost nullability determines whether the caller has to supply a value.
 *
 * `isArrayNullable` is optional in the introspection schema. The generator we
 * build against always emits it for list arguments (`getTypeInfo()` sets
 * `isListNullable` on every list branch), but when it is absent we treat the list
 * as non-null to stay consistent with the `[T]!` that `outerArguments()` renders
 * for the same input — a request declaring a non-null variable with no value
 * would be rejected by the server anyway.
 *
 * @param argDef A single argument definition from a custom operation
 * @returns Boolean: `true` if the argument itself is non-null
 */ function $e0562116a3824935$var$isArgumentRequired({ isArray: isArray, isRequired: isRequired, isArrayNullable: isArrayNullable }) {
    return isArray ? !isArrayNullable : isRequired;
}
/**
 * Generates "outer" arguments string for a custom operation. For example,
 * in this operation:
 *
 * ```graphql
 * query MyQuery(InputString: String!) {
 *   echoString(InputString: $InputString)
 * }
 * ```
 *
 * This function returns the top/outer level arguments as a string:
 *
 * ```json
 * "InputString: String!"
 * ```
 *
 * @param operation Operation object from model introspection schema.
 * @returns "outer" arguments string
 */ function $e0562116a3824935$var$outerArguments(operation) {
    if (operation.arguments === undefined) return "";
    const args = Object.entries(operation.arguments).map(([k, argument])=>{
        const baseType = $e0562116a3824935$var$argumentBaseTypeString(argument);
        const finalType = argument.isArray ? `[${baseType}]${$e0562116a3824935$var$isArgumentRequired(argument) ? "!" : ""}` : baseType;
        return `$${k}: ${finalType}`;
    }).join(", ");
    return args.length > 0 ? `(${args})` : "";
}
/**
 * Generates "inner" arguments string for a custom operation. For example,
 * in this operation:
 *
 * ```graphql
 * query MyQuery(InputString: String!) {
 *   echoString(InputString: $InputString)
 * }
 * ```
 *
 * This function returns the inner arguments as a string:
 *
 * ```json
 * "InputString: $InputString"
 * ```
 *
 * @param operation Operation object from model introspection schema.
 * @returns "outer" arguments string
 */ function $e0562116a3824935$var$innerArguments(operation) {
    if (operation.arguments === undefined) return "";
    const args = Object.keys(operation.arguments).map((k)=>`${k}: $${k}`).join(", ");
    return args.length > 0 ? `(${args})` : "";
}
/**
 * Generates the selection set string for a custom operation. This is slightly
 * different than the selection set generation for models. If the custom op returns
 * a primitive or enum types, it doesn't require a selection set at all.
 *
 * E.g., the graphql might look like this:
 *
 * ```graphql
 * query MyQuery {
 *   echoString(inputString: "whatever")
 * }
 * #                                     ^
 * #                                     |
 * #                                     +-- no selection set
 * ```
 *
 * Non-primitive return type selection set generation will be similar to other
 * model operations.
 *
 * @param modelIntrospection The full code-generated introspection schema.
 * @param operation The operation object from the schema.
 * @returns The selection set as a string.
 */ function $e0562116a3824935$var$operationSelectionSet(modelIntrospection, operation) {
    if ($e0562116a3824935$var$hasStringField(operation, "type") || $e0562116a3824935$var$hasStringField(operation.type, "enum")) return "";
    else if ($e0562116a3824935$var$hasStringField(operation.type, "nonModel")) {
        const nonModel = modelIntrospection.nonModels[operation.type.nonModel];
        return `{${(0, $lmrPf.selectionSetIRToString)((0, $lmrPf.getDefaultSelectionSetForNonModelWithIR)(nonModel, modelIntrospection))}}`;
    } else if ($e0562116a3824935$var$hasStringField(operation.type, "model")) return `{${(0, $lmrPf.generateSelectionSet)(modelIntrospection, operation.type.model)}}`;
    else return "";
}
/**
 * Maps an arguments objec to graphql variables, removing superfluous args and
 * screaming loudly when required args are missing.
 *
 * @param operation The operation to construct graphql request variables for.
 * @param args The arguments to map variables from.
 * @returns The graphql variables object.
 */ function $e0562116a3824935$var$operationVariables(operation, args = {}) {
    const variables = {};
    if (operation.arguments === undefined) return variables;
    for (const argDef of Object.values(operation.arguments)){
        if (typeof args[argDef.name] !== "undefined") variables[argDef.name] = args[argDef.name];
        else if ($e0562116a3824935$var$isArgumentRequired(argDef)) // At this point, the variable is both required and missing: We don't need
        // to continue. The operation is expected to fail.
        throw new Error(`${operation.name} requires arguments '${argDef.name}'`);
    }
    return variables;
}
/**
 * Executes an operation from the given model intro schema against a client, returning
 * a fully instantiated model when relevant.
 *
 * @param client The client to operate `graphql()` calls through.
 * @param modelIntrospection The model intro schema to construct requests from.
 * @param operationType The high level graphql operation type.
 * @param operation The specific operation name, args, return type details.
 * @param args The arguments to provide to the operation as variables.
 * @param options Request options like headers, etc.
 * @param context SSR context if relevant.
 * @returns Result from the graphql request, model-instantiated when relevant.
 */ function $e0562116a3824935$var$_op(client, modelIntrospection, operationType, operation, getInternals, args, options, context, customUserAgentDetails) {
    return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
        const { name: operationName } = operation;
        const auth = (0, $lmrPf.authModeParams)(client, getInternals, options);
        const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, options?.headers);
        const outerArgsString = $e0562116a3824935$var$outerArguments(operation);
        const innerArgsString = $e0562116a3824935$var$innerArguments(operation);
        const selectionSet = $e0562116a3824935$var$operationSelectionSet(modelIntrospection, operation);
        const returnTypeModelName = $e0562116a3824935$var$hasStringField(operation.type, "model") ? operation.type.model : undefined;
        const query = `
    ${operationType.toLocaleLowerCase()}${outerArgsString} {
      ${operationName}${innerArgsString} ${selectionSet}
    }
  `;
        const variables = $e0562116a3824935$var$operationVariables(operation, args);
        const userAgentOverride = (0, $6yFdo.createUserAgentOverride)(customUserAgentDetails);
        try {
            const basePromise = context ? client.graphql(context, {
                ...auth,
                query: query,
                variables: variables
            }, headers) : client.graphql({
                ...auth,
                query: query,
                variables: variables,
                ...userAgentOverride
            }, headers);
            const extendedPromise = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
            const { data: data, extensions: extensions } = await extendedPromise;
            // flatten response
            if (data) {
                const [key] = Object.keys(data);
                const isArrayResult = Array.isArray(data[key]);
                // TODO: when adding support for custom selection set, flattening will need
                // to occur recursively. For now, it's expected that related models are not
                // present in the result. Only FK's are present. Any related model properties
                // should be replaced with lazy loaders under the current implementation.
                const flattenedResult = isArrayResult ? data[key].filter((x)=>x) : data[key];
                // TODO: custom selection set. current selection set is default selection set only
                // custom selection set requires data-schema-type + runtime updates above.
                const initialized = returnTypeModelName ? (0, $lmrPf.initializeModel)(client, returnTypeModelName, isArrayResult ? flattenedResult : [
                    flattenedResult
                ], modelIntrospection, auth.authMode, auth.authToken, !!context) : flattenedResult;
                return {
                    data: !isArrayResult && Array.isArray(initialized) ? initialized.shift() : initialized,
                    extensions: extensions
                };
            } else return {
                data: null,
                extensions: extensions
            };
        } catch (error) {
            /**
             * The `data` type returned by `error` here could be:
             * 1) `null`
             * 2) an empty object
             * 3) "populated" but with a `null` value `{ getPost: null }`
             * 4) an actual record `{ getPost: { id: '1', title: 'Hello, World!' } }`
             */ const { data: data, errors: errors } = error;
            /**
             * `data` is not `null`, and is not an empty object:
             */ if (data && Object.keys(data).length !== 0 && errors) {
                const [key] = Object.keys(data);
                const isArrayResult = Array.isArray(data[key]);
                // TODO: when adding support for custom selection set, flattening will need
                // to occur recursively. For now, it's expected that related models are not
                // present in the result. Only FK's are present. Any related model properties
                // should be replaced with lazy loaders under the current implementation.
                const flattenedResult = isArrayResult ? data[key].filter((x)=>x) : data[key];
                /**
                 * `flattenedResult` could be `null` here (e.g. `data: { getPost: null }`)
                 * if `flattenedResult`, result is an actual record:
                 */ if (flattenedResult) {
                    // TODO: custom selection set. current selection set is default selection set only
                    // custom selection set requires data-schema-type + runtime updates above.
                    const initialized = returnTypeModelName ? (0, $lmrPf.initializeModel)(client, returnTypeModelName, isArrayResult ? flattenedResult : [
                        flattenedResult
                    ], modelIntrospection, auth.authMode, auth.authToken, !!context) : flattenedResult;
                    return {
                        data: !isArrayResult && Array.isArray(initialized) ? initialized.shift() : initialized,
                        errors: errors
                    };
                } else // was `data: { getPost: null }`)
                return (0, $kffnY.handleSingularGraphQlError)(error);
            } else // `data` is `null`:
            return (0, $kffnY.handleSingularGraphQlError)(error);
        }
    });
}
/**
 * Executes an operation from the given model intro schema against a client, returning
 * a fully instantiated model when relevant.
 *
 * @param client The client to operate `graphql()` calls through.
 * @param modelIntrospection The model intro schema to construct requests from.
 * @param operation The specific operation name, args, return type details.
 * @param args The arguments to provide to the operation as variables.
 * @param options Request options like headers, etc.
 * @returns Result from the graphql request, model-instantiated when relevant.
 */ function $e0562116a3824935$var$_opSubscription(client, modelIntrospection, operation, getInternals, args, options, customUserAgentDetails) {
    const operationType = "subscription";
    const { name: operationName } = operation;
    const auth = (0, $lmrPf.authModeParams)(client, getInternals, options);
    const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, options?.headers);
    const outerArgsString = $e0562116a3824935$var$outerArguments(operation);
    const innerArgsString = $e0562116a3824935$var$innerArguments(operation);
    const selectionSet = $e0562116a3824935$var$operationSelectionSet(modelIntrospection, operation);
    const returnTypeModelName = $e0562116a3824935$var$hasStringField(operation.type, "model") ? operation.type.model : undefined;
    const query = `
    ${operationType.toLocaleLowerCase()}${outerArgsString} {
      ${operationName}${innerArgsString} ${selectionSet}
    }
  `;
    const variables = $e0562116a3824935$var$operationVariables(operation, args);
    const userAgentOverride = (0, $6yFdo.createUserAgentOverride)(customUserAgentDetails);
    const observable = client.graphql({
        ...auth,
        query: query,
        variables: variables,
        ...userAgentOverride
    }, headers);
    return observable.pipe((0, $d4PzE.map)((value)=>{
        const [key] = Object.keys(value.data);
        const data = value.data[key];
        const [initialized] = returnTypeModelName ? (0, $lmrPf.initializeModel)(client, returnTypeModelName, [
            data
        ], modelIntrospection, auth.authMode, auth.authToken) : [
            data
        ];
        return initialized;
    }));
}

});
parcelRegister("d4PzE", function(module, exports) {

$parcel$export(module.exports, "map", () => $9853a79d111e4e33$export$871de8747c9eaa88);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});
parcelRegister("d9kQQ", function(module, exports) {

$parcel$export(module.exports, "operate", () => $992c4a42843eb1d0$export$871731df685d7753);

var $gCSeg = parcelRequire("gCSeg");
function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $gCSeg.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

});
parcelRegister("gCSeg", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $c1aa42b0603892d6$export$f6e2535fb5126e54);
function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});


parcelRegister("4QgEI", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $3868f035248205c1$export$b9e075132cc6937f);

var $7WQrb = parcelRequire("7WQrb");

var $hOMJ7 = parcelRequire("hOMJ7");
function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $7WQrb.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $hOMJ7.Subscriber));

});
parcelRegister("hOMJ7", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $cf8ce74b80455e9f$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $cf8ce74b80455e9f$export$94eeb6a328cab6c7);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $bgI6x = parcelRequire("bgI6x");

var $hmjgn = parcelRequire("hmjgn");

var $28DKm = parcelRequire("28DKm");

var $75rFk = parcelRequire("75rFk");

var $ZT8xQ = parcelRequire("ZT8xQ");

var $gwzK1 = parcelRequire("gwzK1");

var $cxQqV = parcelRequire("cxQqV");
var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $7WQrb.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $bgI6x.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $bgI6x.Subscription));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $7WQrb.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $gCSeg.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $hmjgn.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) (0, $cxQqV.captureError)(error);
    else (0, $28DKm.reportUnhandledError)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $hmjgn.config).onStoppedNotification;
    onStoppedNotification && (0, $gwzK1.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $75rFk.noop),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $75rFk.noop)
};

});
parcelRegister("bgI6x", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $8343668acd7c4a9b$export$f55210826850c514);
$parcel$export(module.exports, "isSubscription", () => $8343668acd7c4a9b$export$4f9221cbada3c4fc);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $l4W4q = parcelRequire("l4W4q");

var $3JYOM = parcelRequire("3JYOM");
var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $7WQrb.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $gCSeg.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $l4W4q.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $7WQrb.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $l4W4q.UnsubscriptionError)) errors = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(errors)), (0, $7WQrb.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $l4W4q.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $3JYOM.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $3JYOM.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $gCSeg.isFunction)(value.remove) && (0, $gCSeg.isFunction)(value.add) && (0, $gCSeg.isFunction)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $gCSeg.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("l4W4q", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $f587043ffd615a90$export$c9648b76fd580c34);

var $kfFvr = parcelRequire("kfFvr");
var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

});
parcelRegister("kfFvr", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $ebe567a061bc80f6$export$128a15b65d1b6041);
function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("3JYOM", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $2b94c03d07e501cc$export$dae3f38077fc36c0);
function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("hmjgn", function(module, exports) {

$parcel$export(module.exports, "config", () => $ca336efb1b4fb564$export$e506a1d27d1eaa20);
var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("28DKm", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $18eb28ff53cc4943$export$ebf645db02d3e99f);

var $hmjgn = parcelRequire("hmjgn");

var $gwzK1 = parcelRequire("gwzK1");
function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $gwzK1.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $hmjgn.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("gwzK1", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $c07b5bfa3b9d4401$export$365aa6bd3c788e3d);

var $7WQrb = parcelRequire("7WQrb");
var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
        return setTimeout.apply(void 0, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("75rFk", function(module, exports) {

$parcel$export(module.exports, "noop", () => $528e75db69787807$export$8793edee2d425525);
function $528e75db69787807$export$8793edee2d425525() {}

});

parcelRegister("ZT8xQ", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $0ba077a4cdfd9739$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $0ba077a4cdfd9739$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $0ba077a4cdfd9739$export$ff9346b0d1d30313);
var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("cxQqV", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $92213d3dd6a83b5d$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $92213d3dd6a83b5d$export$3e205fbb5df021e0);

var $hmjgn = parcelRequire("hmjgn");
var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}

});




parcelRegister("lmrPf", function(module, exports) {

$parcel$export(module.exports, "flattenItems", () => $b2a5cd0e0e5a415d$export$a1df7bca853facc8);
$parcel$export(module.exports, "initializeModel", () => $b2a5cd0e0e5a415d$export$2dab78d5abd0247d);
$parcel$export(module.exports, "graphQLOperationsInfo", () => $b2a5cd0e0e5a415d$export$c2d7461810dc0165);
$parcel$export(module.exports, "getDefaultSelectionSetForNonModelWithIR", () => $b2a5cd0e0e5a415d$export$772c4672e1d1c501);
$parcel$export(module.exports, "selectionSetIRToString", () => $b2a5cd0e0e5a415d$export$c9a913a0e0b06132);
$parcel$export(module.exports, "generateSelectionSet", () => $b2a5cd0e0e5a415d$export$f1b80cae6b6c9807);
$parcel$export(module.exports, "generateGraphQLDocument", () => $b2a5cd0e0e5a415d$export$d6645ba197f595e0);
$parcel$export(module.exports, "buildGraphQLVariables", () => $b2a5cd0e0e5a415d$export$95bea254c9042858);
$parcel$export(module.exports, "authModeParams", () => $b2a5cd0e0e5a415d$export$f5679e96571d0641);
$parcel$export(module.exports, "getCustomHeaders", () => $b2a5cd0e0e5a415d$export$3fc25db7b420c1a4);

var $9QBef = parcelRequire("9QBef");

var $5f5iX = parcelRequire("5f5iX");

var $2DZ3G = parcelRequire("2DZ3G");

var $4vIv1 = parcelRequire("4vIv1");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
const $b2a5cd0e0e5a415d$var$connectionType = {
    HAS_ONE: "HAS_ONE",
    HAS_MANY: "HAS_MANY",
    BELONGS_TO: "BELONGS_TO"
};
// When generating an SK's KeyConditionInput name, string-like types map to String
const $b2a5cd0e0e5a415d$var$skGraphQlFieldTypeMap = {
    ID: "ID",
    String: "String",
    AWSDate: "String",
    AWSTime: "String",
    AWSDateTime: "String",
    AWSTimestamp: "Int",
    AWSEmail: "String",
    AWSPhone: "String",
    AWSURL: "String",
    AWSIPAddress: "String",
    AWSJSON: "String",
    Boolean: "Boolean",
    Int: "Int",
    Float: "Float"
};
// move to util
const $b2a5cd0e0e5a415d$var$resolvedSkName = (sk)=>{
    if (sk.length === 1) return sk[0];
    else return sk.reduce((acc, curr, idx)=>{
        if (idx === 0) return curr;
        else return acc + (0, $5f5iX.capitalize)(curr);
    }, "");
};
/**
 * Crawls a model tree, starting with a given **individual** model instance record, looking
 * for related hasMany children to extract from their `items` containers.
 *
 * E.g., if we have a record like this:
 *
 * ```js
 * {
 *   id: 'some-id',
 *   children: {
 *     items: [
 *       { name: 'a' }
 *       { name: 'b' }
 *       { name: 'c' }
 *     ]
 *   }
 * }
 * ```
 *
 * And if `children` refers to *an array of another model* (as opposed to a custom type),
 * the `items` will be extracted. We do this because `items` is just the mechanism for nesting
 * child records -- we don't want customers to have to dig the items out in application code.
 * Ultimately, we return this "flattened" structure:
 *
 * ```js
 * {
 *   id: 'some-id',
 *   children: [
 *     { name: 'a' }
 *     { name: 'b' }
 *     { name: 'c' }
 *   ]
 * }
 * ```
 *
 * Notably, an identical record could be the result of a nested custom type that contains an
 * `items` property. This will *not* be flattened, because in that case the `items` property is
 * actually part of the customer's schema. Similarly if a model contains an explicit `items` field.
 *
 * @param modelIntrospection Top-level model introspection schema.
 * @param modelName The name of the model. Can be `undefined`. E.g., for customOperation return types.
 * @param modelRecord The individual "model instance record" to normalize.
 */ const $b2a5cd0e0e5a415d$export$a1df7bca853facc8 = (modelIntrospection, modelName, modelRecord)=>{
    if (!modelRecord) return null;
    const mapped = {};
    for (const [fieldName, value] of Object.entries(modelRecord)){
        const fieldDef = modelName ? modelIntrospection.models[modelName]?.fields[fieldName] : undefined;
        const dvPair = {
            fieldDef: fieldDef,
            value: value
        };
        if ($b2a5cd0e0e5a415d$var$isRelatedModelItemsArrayPair(dvPair)) mapped[fieldName] = dvPair.value.items.map((itemValue)=>$b2a5cd0e0e5a415d$export$a1df7bca853facc8(modelIntrospection, dvPair.fieldDef.type.model, itemValue));
        else if ($b2a5cd0e0e5a415d$var$isRelatedModelProperty(fieldDef)) mapped[fieldName] = $b2a5cd0e0e5a415d$export$a1df7bca853facc8(modelIntrospection, fieldDef.type.model, value);
        else mapped[fieldName] = value;
    }
    return mapped;
};
/**
 * Determines whether the given field definition and associated result value
 * represent a related model array from a HasMany-type relationship.
 *
 * @param dv Pair of field definition and associated result value
 * @returns
 */ function $b2a5cd0e0e5a415d$var$isRelatedModelItemsArrayPair(dv) {
    return typeof dv.fieldDef?.type === "object" && "model" in dv.fieldDef.type && typeof dv.fieldDef.type.model === "string" && dv.fieldDef.isArray && Array.isArray(dv.value?.items);
}
/**
 * Determines whether the given field definition represents a relationship
 * to another model.
 *
 * @param fieldDef
 * @returns
 */ function $b2a5cd0e0e5a415d$var$isRelatedModelProperty(fieldDef) {
    return typeof fieldDef?.type === "object" && "model" in fieldDef.type && typeof fieldDef.type.model === "string";
}
// TODO: this should accept single result to support CRUD methods; create helper for array/list
function $b2a5cd0e0e5a415d$export$2dab78d5abd0247d(client, modelName, result, modelIntrospection, authMode, authToken, context = false) {
    const introModel = modelIntrospection.models[modelName];
    const introModelFields = introModel.fields;
    const modelFields = Object.entries(introModelFields).filter(([_, field])=>field?.type?.model !== undefined).map(([fieldName])=>fieldName);
    return result.map((record)=>{
        if (record === null || record === undefined) return record;
        const initializedRelationshipFields = {};
        for (const fieldName of modelFields){
            const modelField = introModelFields[fieldName];
            const modelFieldType = modelField?.type;
            const relatedModelName = modelFieldType.model;
            const relatedModel = modelIntrospection.models[relatedModelName];
            const relatedModelPKFieldName = relatedModel.primaryKeyInfo.primaryKeyFieldName;
            const relatedModelSKFieldNames = relatedModel.primaryKeyInfo.sortKeyFieldNames;
            const relationType = modelField.association?.connectionType;
            let connectionFields = [];
            if (modelField.association && "associatedWith" in modelField.association) connectionFields = modelField.association.associatedWith;
            const targetNames = [];
            if (modelField.association && "targetNames" in modelField.association) targetNames.push(...modelField.association.targetNames);
            switch(relationType){
                case $b2a5cd0e0e5a415d$var$connectionType.BELONGS_TO:
                    {
                        const sortKeyValues = relatedModelSKFieldNames.reduce(// TODO(Eslint): is this implementation correct?
                        (acc, curVal)=>{
                            if (record[curVal]) acc[curVal] = record[curVal];
                            return acc;
                        }, {});
                        // if get is disabled on the related model
                        if (client.models[relatedModelName]?.get === undefined) break;
                        if (context) initializedRelationshipFields[fieldName] = (contextSpec, options)=>{
                            if (record[targetNames[0]]) return client.models[relatedModelName].get(contextSpec, {
                                [relatedModelPKFieldName]: record[targetNames[0]],
                                ...sortKeyValues
                            }, {
                                authMode: options?.authMode || authMode,
                                authToken: options?.authToken || authToken
                            });
                            return {
                                data: null
                            };
                        };
                        else initializedRelationshipFields[fieldName] = (options)=>{
                            if (record[targetNames[0]]) return client.models[relatedModelName].get({
                                [relatedModelPKFieldName]: record[targetNames[0]],
                                ...sortKeyValues
                            }, {
                                authMode: options?.authMode || authMode,
                                authToken: options?.authToken || authToken
                            });
                            return {
                                data: null
                            };
                        };
                        break;
                    }
                case $b2a5cd0e0e5a415d$var$connectionType.HAS_ONE:
                case $b2a5cd0e0e5a415d$var$connectionType.HAS_MANY:
                    {
                        /**
                     * If the loader is a HAS_ONE, we just need to attempt to grab the first item
                     * from the result.
                     */ const mapResult = relationType === $b2a5cd0e0e5a415d$var$connectionType.HAS_ONE ? (result)=>{
                            return {
                                data: result?.data.shift() || null,
                                errors: result.errors,
                                extensions: result.extensions
                            };
                        } : (result)=>result;
                        const parentPk = introModel.primaryKeyInfo.primaryKeyFieldName;
                        const parentSK = introModel.primaryKeyInfo.sortKeyFieldNames;
                        // M:N check - TODO: refactor
                        const relatedModelField = relatedModel.fields[connectionFields[0]];
                        const relatedModelFieldType = relatedModelField.type;
                        if (relatedModelFieldType.model) {
                            let relatedTargetNames = [];
                            if (relatedModelField.association && "targetNames" in relatedModelField.association) relatedTargetNames = relatedModelField.association?.targetNames;
                            const hasManyFilter = relatedTargetNames.map((field, idx)=>{
                                if (idx === 0) return {
                                    [field]: {
                                        eq: record[parentPk]
                                    }
                                };
                                return {
                                    [field]: {
                                        eq: record[parentSK[idx - 1]]
                                    }
                                };
                            });
                            // if list is disabled on the related model
                            if (client.models[relatedModelName]?.list === undefined) break;
                            if (context) initializedRelationshipFields[fieldName] = (contextSpec, options)=>{
                                if (record[parentPk]) return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
                                    const basePromise = client.models[relatedModelName].list(contextSpec, {
                                        filter: {
                                            and: hasManyFilter
                                        },
                                        limit: options?.limit,
                                        nextToken: options?.nextToken,
                                        authMode: options?.authMode || authMode,
                                        authToken: options?.authToken || authToken
                                    });
                                    const extendedBase = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
                                    return mapResult(await extendedBase);
                                });
                                return [];
                            };
                            else initializedRelationshipFields[fieldName] = (options)=>{
                                if (record[parentPk]) return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
                                    const basePromise = client.models[relatedModelName].list({
                                        filter: {
                                            and: hasManyFilter
                                        },
                                        limit: options?.limit,
                                        nextToken: options?.nextToken,
                                        authMode: options?.authMode || authMode,
                                        authToken: options?.authToken || authToken
                                    });
                                    const extendedBase = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
                                    return mapResult(await extendedBase);
                                });
                                return [];
                            };
                            break;
                        }
                        const hasManyFilter = connectionFields.map((field, idx)=>{
                            if (idx === 0) return {
                                [field]: {
                                    eq: record[parentPk]
                                }
                            };
                            return {
                                [field]: {
                                    eq: record[parentSK[idx - 1]]
                                }
                            };
                        });
                        // if list is disabled on the related model
                        if (client.models[relatedModelName]?.list === undefined) break;
                        if (context) initializedRelationshipFields[fieldName] = (contextSpec, options)=>{
                            if (record[parentPk]) return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
                                const basePromise = client.models[relatedModelName].list(contextSpec, {
                                    filter: {
                                        and: hasManyFilter
                                    },
                                    limit: options?.limit,
                                    nextToken: options?.nextToken,
                                    authMode: options?.authMode || authMode,
                                    authToken: options?.authToken || authToken
                                });
                                const extendedBase = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
                                return mapResult(await extendedBase);
                            });
                            return [];
                        };
                        else initializedRelationshipFields[fieldName] = (options)=>{
                            if (record[parentPk]) return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
                                const basePromise = client.models[relatedModelName].list({
                                    filter: {
                                        and: hasManyFilter
                                    },
                                    limit: options?.limit,
                                    nextToken: options?.nextToken,
                                    authMode: options?.authMode || authMode,
                                    authToken: options?.authToken || authToken
                                });
                                const extendedBase = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
                                return mapResult(await extendedBase);
                            });
                            return [];
                        };
                        break;
                    }
            }
        }
        return {
            ...record,
            ...initializedRelationshipFields
        };
    });
}
const $b2a5cd0e0e5a415d$export$c2d7461810dc0165 = {
    CREATE: {
        operationPrefix: "create",
        usePlural: false
    },
    GET: {
        operationPrefix: "get",
        usePlural: false
    },
    UPDATE: {
        operationPrefix: "update",
        usePlural: false
    },
    DELETE: {
        operationPrefix: "delete",
        usePlural: false
    },
    LIST: {
        operationPrefix: "list",
        usePlural: true
    },
    INDEX_QUERY: {
        operationPrefix: "",
        usePlural: false
    },
    ONCREATE: {
        operationPrefix: "onCreate",
        usePlural: false
    },
    ONUPDATE: {
        operationPrefix: "onUpdate",
        usePlural: false
    },
    ONDELETE: {
        operationPrefix: "onDelete",
        usePlural: false
    },
    OBSERVEQUERY: {
        operationPrefix: "observeQuery",
        usePlural: false
    }
};
const $b2a5cd0e0e5a415d$var$SELECTION_SET_WILDCARD = "*";
const $b2a5cd0e0e5a415d$export$772c4672e1d1c501 = (nonModelDefinition, modelIntrospection)=>{
    const { fields: fields } = nonModelDefinition;
    const mappedFields = Object.values(fields).map(({ type: type, name: name })=>{
        if (typeof type.enum === "string") return [
            name,
            $b2a5cd0e0e5a415d$var$FIELD_IR
        ];
        if (typeof type.nonModel === "string") return [
            name,
            $b2a5cd0e0e5a415d$export$772c4672e1d1c501(modelIntrospection.nonModels[type.nonModel], modelIntrospection)
        ];
        if (typeof type === "string") return [
            name,
            $b2a5cd0e0e5a415d$var$FIELD_IR
        ];
        return undefined;
    }).filter((pair)=>pair !== undefined);
    return Object.fromEntries(mappedFields);
};
const $b2a5cd0e0e5a415d$var$getDefaultSelectionSetForModelWithIR = (modelDefinition, modelIntrospection)=>{
    const { fields: fields } = modelDefinition;
    const mappedFields = Object.values(fields).map(({ type: type, name: name })=>{
        if (typeof type.enum === "string" || typeof type === "string") return [
            name,
            $b2a5cd0e0e5a415d$var$FIELD_IR
        ];
        if (typeof type.nonModel === "string") return [
            name,
            $b2a5cd0e0e5a415d$export$772c4672e1d1c501(modelIntrospection.nonModels[type.nonModel], modelIntrospection)
        ];
        return undefined;
    }).filter((pair)=>pair !== undefined);
    const ownerFields = (0, $9QBef.resolveOwnerFields)(modelDefinition).map((field)=>[
            field,
            $b2a5cd0e0e5a415d$var$FIELD_IR
        ]);
    return Object.fromEntries(mappedFields.concat(ownerFields));
};
function $b2a5cd0e0e5a415d$var$defaultSelectionSetForModel(modelDefinition) {
    // fields that are explicitly part of the graphql schema; not
    // inferred from owner auth rules.
    const { fields: fields } = modelDefinition;
    const explicitFields = Object.values(fields)// Default selection set omits model fields
    .map(({ type: type, name: name })=>{
        if (typeof type === "string") return name;
        if (typeof type === "object") {
            if (typeof type?.enum === "string") return name;
            else if (typeof type?.nonModel === "string") return `${name}.${$b2a5cd0e0e5a415d$var$SELECTION_SET_WILDCARD}`;
        }
        return undefined;
    }).filter(Boolean);
    // fields used for owner auth rules that may or may not also
    // be explicit on the model.
    const ownerFields = (0, $9QBef.resolveOwnerFields)(modelDefinition);
    return Array.from(new Set(explicitFields.concat(ownerFields)));
}
const $b2a5cd0e0e5a415d$var$FIELD_IR = "";
/**
 * Generates nested Custom Selection Set IR from path
 *
 * @param modelDefinitions
 * @param modelName
 * @param selectionSet - array of object paths
 * @example
 * ### Given
 * `selectionSet = ['id', 'comments.post.id']`
 * ### Returns
 * ```ts
 * {
 *   id: '',
 *   comments: {
 *     items: { post: { id: '' } }
 *   }
 * }
 * ```
 */ function $b2a5cd0e0e5a415d$export$be1dc2e500ab0740(modelIntrospection, modelName, selectionSet) {
    const dotNotationToObject = (path, modelOrNonModelName)=>{
        const [fieldName, ...rest] = path.split(".");
        const nested = rest[0];
        const modelOrNonModelDefinition = modelIntrospection.models[modelOrNonModelName] ?? modelIntrospection.nonModels[modelOrNonModelName];
        const modelOrNonModelFields = modelOrNonModelDefinition?.fields;
        const relatedModel = modelOrNonModelFields?.[fieldName]?.type?.model;
        const relatedModelDefinition = modelIntrospection.models[relatedModel];
        const relatedNonModel = modelOrNonModelFields?.[fieldName]?.type?.nonModel;
        const relatedNonModelDefinition = modelIntrospection.nonModels[relatedNonModel];
        const isModelOrNonModelOrFieldType = relatedModelDefinition ? "model" : relatedNonModelDefinition ? "nonModel" : "field";
        if (isModelOrNonModelOrFieldType === "nonModel") {
            let result = {};
            if (!nested) throw Error(`${fieldName} must declare a wildcard (*) or a field of custom type ${relatedNonModel}`);
            if (nested === $b2a5cd0e0e5a415d$var$SELECTION_SET_WILDCARD) result = {
                [fieldName]: $b2a5cd0e0e5a415d$export$772c4672e1d1c501(relatedNonModelDefinition, modelIntrospection)
            };
            else result = {
                [fieldName]: dotNotationToObject(rest.join("."), relatedNonModel)
            };
            return result;
        } else if (isModelOrNonModelOrFieldType === "model") {
            let result = {};
            if (!nested) throw Error(`${fieldName} must declare a wildcard (*) or a field of model ${relatedModel}`);
            if (nested === $b2a5cd0e0e5a415d$var$SELECTION_SET_WILDCARD) {
                const nestedRelatedModelDefinition = modelIntrospection.models[relatedModel];
                result = {
                    [fieldName]: $b2a5cd0e0e5a415d$var$getDefaultSelectionSetForModelWithIR(nestedRelatedModelDefinition, modelIntrospection)
                };
            } else result = {
                [fieldName]: dotNotationToObject(rest.join("."), relatedModel)
            };
            if (modelOrNonModelFields[fieldName]?.isArray) result = {
                [fieldName]: {
                    items: result[fieldName]
                }
            };
            return result;
        } else {
            const modelField = modelOrNonModelFields?.[fieldName];
            const nonModelDefinition = modelIntrospection.nonModels[modelOrNonModelName];
            const nonModelField = nonModelDefinition?.fields?.[fieldName];
            if (!nonModelDefinition) {
                const isOwnerField = (0, $9QBef.resolveOwnerFields)(modelOrNonModelDefinition).includes(fieldName);
                if (!modelField && !isOwnerField) throw Error(`${fieldName} is not a field of model ${modelOrNonModelName}`);
            } else {
                if (!nonModelField) throw Error(`${fieldName} is not a field of custom type ${modelOrNonModelName}`);
            }
            return {
                [fieldName]: $b2a5cd0e0e5a415d$var$FIELD_IR
            };
        }
    };
    return selectionSet.reduce((resultObj, path)=>$b2a5cd0e0e5a415d$var$deepMergeSelectionSetObjects(dotNotationToObject(path, modelName), resultObj), {});
}
/**
 * Stringifies selection set IR
 * * @example
 * ### Given
 * ```ts
 * {
 *   id: '',
 *   comments: {
 *     items: { post: { id: '' } }
 *   }
 * }
 * ```
 * ### Returns
 * `'id comments { items { post { id } } }'`
 */ function $b2a5cd0e0e5a415d$export$c9a913a0e0b06132(obj) {
    const res = [];
    Object.entries(obj).forEach(([fieldName, value])=>{
        if (value === $b2a5cd0e0e5a415d$var$FIELD_IR) res.push(fieldName);
        else if (typeof value === "object" && value !== null) {
            if (value?.items) res.push(fieldName, "{", "items", "{", $b2a5cd0e0e5a415d$export$c9a913a0e0b06132(value.items), "}", "}");
            else res.push(fieldName, "{", $b2a5cd0e0e5a415d$export$c9a913a0e0b06132(value), "}");
        }
    });
    return res.join(" ");
}
/**
 * Recursively merges selection set objects from `source` onto `target`.
 *
 * `target` will be updated. `source` will be left alone.
 *
 * @param source The object to merge into target.
 * @param target The object to be mutated.
 */ function $b2a5cd0e0e5a415d$var$deepMergeSelectionSetObjects(source, target) {
    const isObject = (obj)=>obj && typeof obj === "object";
    for(const key in source){
        // This verification avoids 'Prototype Pollution' issue
        if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
        if (Object.prototype.hasOwnProperty.call(target, key) && isObject(target[key])) $b2a5cd0e0e5a415d$var$deepMergeSelectionSetObjects(source[key], target[key]);
        else target[key] = source[key];
    }
    return target;
}
function $b2a5cd0e0e5a415d$export$f1b80cae6b6c9807(modelIntrospection, modelName, selectionSet) {
    const modelDefinition = modelIntrospection.models[modelName];
    const selSetIr = $b2a5cd0e0e5a415d$export$be1dc2e500ab0740(modelIntrospection, modelName, selectionSet ?? $b2a5cd0e0e5a415d$var$defaultSelectionSetForModel(modelDefinition));
    const selSetString = $b2a5cd0e0e5a415d$export$c9a913a0e0b06132(selSetIr);
    return selSetString;
}
function $b2a5cd0e0e5a415d$export$d6645ba197f595e0(modelIntrospection, modelDefinition, modelOperation, listArgs, indexMeta) {
    const { name: name, pluralName: pluralName, fields: fields, primaryKeyInfo: { isCustomPrimaryKey: isCustomPrimaryKey, primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames }, attributes: attributes } = modelDefinition;
    // Use pascal case of the model name to generate the operations and the arguments.
    // This is required to be in sync with the resources generated by the GraphQL transformers.
    const namePascalCase = name.charAt(0).toUpperCase() + name.slice(1);
    const pluralNamePascalCase = pluralName.charAt(0).toUpperCase() + pluralName.slice(1);
    const { operationPrefix: operationPrefix, usePlural: usePlural } = $b2a5cd0e0e5a415d$export$c2d7461810dc0165[modelOperation];
    const { selectionSet: selectionSet } = listArgs || {};
    let graphQLFieldName;
    let indexQueryArgs;
    if (operationPrefix) graphQLFieldName = `${operationPrefix}${usePlural ? pluralNamePascalCase : namePascalCase}`;
    else if (indexMeta) {
        const { queryField: queryField, pk: pk, sk: sk = [] } = indexMeta;
        graphQLFieldName = queryField;
        /**
         * **a. Single field SK** -> single arg where name is the field name and the type is `Model${gqlFieldType}KeyConditionInput` (nullable)
         *  Note: string-like data types e.g.,  AWSDateTime, AWSEmail, AWSPhone, etc. should map to String. See `skGraphQlFieldTypeMap` above
         * @example
         * ```
         * sk1: ModelStringKeyConditionInput
         * ```
         *
         * **b. Composite SK** -> single arg where the name is camelCase concatenation of all the field names that comprise the SK
         *  and the type is `Model${modelName}${keyAttributeName}CompositeKeyConditionInput` (nullable)
         * @example
         * ```
         * sk1Sk2: ModelMyModelMyModelByPkAndSk1AndSk2CompositeKeyConditionInput
         */ let skQueryArgs = {};
        if (sk.length === 1) {
            const [skField] = sk;
            const type = typeof fields[skField].type === "string" ? fields[skField].type : "String";
            const normalizedType = $b2a5cd0e0e5a415d$var$skGraphQlFieldTypeMap[type];
            skQueryArgs = {
                [skField]: `Model${normalizedType}KeyConditionInput`
            };
        } else if (sk.length > 1) {
            const compositeSkArgName = $b2a5cd0e0e5a415d$var$resolvedSkName(sk);
            const keyName = attributes?.find((attr)=>attr?.properties?.queryField === queryField)?.properties?.name;
            skQueryArgs = {
                [compositeSkArgName]: `Model${(0, $5f5iX.capitalize)(name)}${(0, $5f5iX.capitalize)(keyName)}CompositeKeyConditionInput`
            };
        }
        indexQueryArgs = {
            [pk]: `${Object.prototype.hasOwnProperty.call(fields[pk].type, "enum") ? fields[pk].type.enum // AppSync schema sets enum type as the type of the enum fields that's used as PK
             : fields[pk].type}!`,
            ...skQueryArgs
        };
    } else throw new Error("Error generating GraphQL Document - invalid operation name");
    let graphQLOperationType;
    let graphQLSelectionSet;
    let graphQLArguments;
    const selectionSetFields = $b2a5cd0e0e5a415d$export$f1b80cae6b6c9807(modelIntrospection, name, selectionSet);
    // default PK args for get and list operations
    // modified below for CPK
    const getPkArgs = {
        [primaryKeyFieldName]: `${fields[primaryKeyFieldName].type}!`
    };
    const listPkArgs = {};
    /**
     * Generate query field args for the SK if it's defined
     *
     * **1. Get queries** require each SK field to be present as a separate arg where the type is the field's GraphQL scalar type (non-nullable)
     * @example
     * ```
     * sk1: String!, sk2: Int!
     * ```
     *
     * **2. List queries**
     *
     * **a. Single field SK** -> single arg where name is the field name and the type is `Model${gqlFieldType}KeyConditionInput` (nullable)
     *      Note: string-like data types e.g.,  AWSDateTime, AWSEmail, AWSPhone, etc. should map to String. See `skGraphQlFieldTypeMap` above
     * @example
     * ```
     * sk1: ModelStringKeyConditionInput
     * ```
     *
     * **b. Composite SK** -> single arg where the name is camelCase concatenation of all the field names that comprise the SK
     *  and the type is `Model${modelName}PrimaryCompositeKeyConditionInput` (nullable)
     * @example
     * ```
     * sk1Sk2: ModelMyModelPrimaryCompositeKeyConditionInput
     * ```
     */ const generateSkArgs = (op)=>{
        if (sortKeyFieldNames.length === 0) return {};
        if (op === "get") return sortKeyFieldNames.reduce((acc, fieldName)=>{
            const fieldType = fields[fieldName].type;
            if (op === "get") acc[fieldName] = `${fieldType}!`; // ! - SK args are non-nullable in Get queries
            return acc;
        }, {});
        else // list SK
        if (sortKeyFieldNames.length === 1) {
            // Single SK
            const [sk] = sortKeyFieldNames;
            const type = typeof fields[sk].type === "string" ? fields[sk].type : "String";
            const normalizedType = $b2a5cd0e0e5a415d$var$skGraphQlFieldTypeMap[type];
            return {
                [sk]: `Model${normalizedType}KeyConditionInput`
            };
        } else {
            // Composite SK
            const compositeSkArgName = $b2a5cd0e0e5a415d$var$resolvedSkName(sortKeyFieldNames);
            return {
                [compositeSkArgName]: `Model${(0, $5f5iX.capitalize)(name)}PrimaryCompositeKeyConditionInput`
            };
        }
    };
    if (isCustomPrimaryKey) {
        Object.assign(getPkArgs, generateSkArgs("get"));
        Object.assign(listPkArgs, {
            // PK is only included in list query field args in the generated GQL
            // when explicitly specifying PK with .identifier(['fieldName']) or @primaryKey in the schema definition
            [primaryKeyFieldName]: `${fields[primaryKeyFieldName].type}`,
            sortDirection: "ModelSortDirection"
        }, generateSkArgs("list"));
    }
    switch(modelOperation){
        case "CREATE":
        case "UPDATE":
        case "DELETE":
            graphQLArguments ?? (graphQLArguments = {
                input: `${operationPrefix.charAt(0).toLocaleUpperCase() + operationPrefix.slice(1)}${namePascalCase}Input!`
            });
            graphQLOperationType ?? (graphQLOperationType = "mutation");
        // TODO(Eslint): this this case clause correct without the break statement?
        case "GET":
            graphQLArguments ?? (graphQLArguments = getPkArgs);
            graphQLSelectionSet ?? (graphQLSelectionSet = selectionSetFields);
        // TODO(Eslint): this this case clause correct without the break statement?
        case "LIST":
            graphQLArguments ?? (graphQLArguments = {
                ...listPkArgs,
                // eslint doesn't like the ts-ignore, because it thinks it's unnecessary.
                // But TS doesn't like the `filter: ...` because it think it will always be
                // overwritten. (it won't be.) so, we need to ignore the TS error and then
                // ignore the eslint error on the ts-ignore.
                // eslint-disable-next-line
                // @ts-ignore
                filter: `Model${namePascalCase}FilterInput`,
                limit: "Int",
                nextToken: "String"
            });
            graphQLOperationType ?? (graphQLOperationType = "query");
            graphQLSelectionSet ?? (graphQLSelectionSet = `items { ${selectionSetFields} } nextToken __typename`);
        // TODO(Eslint): this this case clause correct without the break statement?
        case "INDEX_QUERY":
            graphQLArguments ?? (graphQLArguments = {
                ...indexQueryArgs,
                filter: `Model${namePascalCase}FilterInput`,
                sortDirection: "ModelSortDirection",
                limit: "Int",
                nextToken: "String"
            });
            graphQLOperationType ?? (graphQLOperationType = "query");
            graphQLSelectionSet ?? (graphQLSelectionSet = `items { ${selectionSetFields} } nextToken __typename`);
        // TODO(Eslint): this this case clause correct without the break statement?
        case "ONCREATE":
        case "ONUPDATE":
        case "ONDELETE":
            graphQLArguments ?? (graphQLArguments = {
                filter: `ModelSubscription${namePascalCase}FilterInput`
            });
            graphQLOperationType ?? (graphQLOperationType = "subscription");
            graphQLSelectionSet ?? (graphQLSelectionSet = selectionSetFields);
            break;
        case "OBSERVEQUERY":
        default:
            throw new Error("Internal error: Attempted to generate graphql document for observeQuery. Please report this error.");
    }
    const graphQLDocument = `${graphQLOperationType}${graphQLArguments ? `(${Object.entries(graphQLArguments).map(([fieldName, type])=>`$${fieldName}: ${type}`)})` : ""} { ${graphQLFieldName}${graphQLArguments ? `(${Object.keys(graphQLArguments).map((fieldName)=>`${fieldName}: $${fieldName}`)})` : ""} { ${graphQLSelectionSet} } }`;
    return graphQLDocument;
}
function $b2a5cd0e0e5a415d$export$95bea254c9042858(modelDefinition, operation, arg, modelIntrospection, indexMeta) {
    const { fields: fields, primaryKeyInfo: { isCustomPrimaryKey: isCustomPrimaryKey, primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames } } = modelDefinition;
    const skName = sortKeyFieldNames?.length && $b2a5cd0e0e5a415d$var$resolvedSkName(sortKeyFieldNames);
    let variables = {};
    // TODO: process input
    switch(operation){
        case "CREATE":
            variables = {
                input: arg ? $b2a5cd0e0e5a415d$export$ab9adbcee87919b5(arg, modelDefinition, modelIntrospection) : {}
            };
            break;
        case "UPDATE":
            // readonly fields are not  updated
            variables = {
                input: arg ? Object.fromEntries(Object.entries($b2a5cd0e0e5a415d$export$ab9adbcee87919b5(arg, modelDefinition, modelIntrospection)).filter(([fieldName])=>{
                    // omit field from update input
                    // if exists in fields and marked read only
                    // if does not exist in fields but implicitly added to schema via ownership
                    return fields[fieldName] ? !fields[fieldName].isReadOnly : !(0, $9QBef.resolveOwnerFields)(modelDefinition).includes(fieldName);
                })) : {}
            };
            break;
        case "GET":
        case "DELETE":
            // only identifiers are sent
            if (arg) variables = isCustomPrimaryKey ? [
                primaryKeyFieldName,
                ...sortKeyFieldNames
            ].reduce((acc, fieldName)=>{
                acc[fieldName] = arg[fieldName];
                return acc;
            }, {}) : {
                [primaryKeyFieldName]: arg[primaryKeyFieldName]
            };
            if (operation === "DELETE") variables = {
                input: variables
            };
            break;
        case "LIST":
            if (arg?.filter) variables.filter = arg.filter;
            if (arg?.sortDirection) variables.sortDirection = arg.sortDirection;
            if (arg && arg[primaryKeyFieldName]) variables[primaryKeyFieldName] = arg[primaryKeyFieldName];
            if (skName && arg && arg[skName]) variables[skName] = arg[skName];
            if (arg?.nextToken) variables.nextToken = arg.nextToken;
            if (arg?.limit) variables.limit = arg.limit;
            break;
        case "INDEX_QUERY":
            {
                const { pk: pk, sk: sk = [] } = indexMeta;
                const indexQuerySkName = sk?.length && $b2a5cd0e0e5a415d$var$resolvedSkName(sk);
                variables[pk] = arg[pk];
                if (indexQuerySkName && arg && arg[indexQuerySkName]) variables[indexQuerySkName] = arg[indexQuerySkName];
                if (arg?.filter) variables.filter = arg.filter;
                if (arg?.sortDirection) variables.sortDirection = arg.sortDirection;
                if (arg?.nextToken) variables.nextToken = arg.nextToken;
                if (arg?.limit) variables.limit = arg.limit;
                break;
            }
        case "ONCREATE":
        case "ONUPDATE":
        case "ONDELETE":
            if (arg?.filter) variables = {
                filter: arg.filter
            };
            break;
        case "OBSERVEQUERY":
            throw new Error("Internal error: Attempted to build variables for observeQuery. Please report this error.");
        default:
            {
                const exhaustiveCheck = operation;
                throw new Error(`Unhandled operation case: ${exhaustiveCheck}`);
            }
    }
    return variables;
}
/**
 * Iterates over mutation input values and resolves any model inputs to their corresponding join fields/values
 *
 * @example
 * ### Usage
 * ```ts
 * const result = normalizeMutationInput({ post: post }, model, modelDefinition);
 * ```
 * ### Result
 * ```ts
 * { postId: "abc123" }
 * ```
 *
 */ function $b2a5cd0e0e5a415d$export$ab9adbcee87919b5(mutationInput, model, modelIntrospection) {
    const { fields: fields } = model;
    const normalized = {};
    Object.entries(mutationInput).forEach(([inputFieldName, inputValue])=>{
        const fieldType = fields[inputFieldName]?.type;
        const relatedModelName = fieldType?.model;
        if (relatedModelName) {
            const association = fields[inputFieldName]?.association;
            const relatedModelDef = modelIntrospection.models[relatedModelName];
            const relatedModelPkInfo = relatedModelDef.primaryKeyInfo;
            if (association?.connectionType === $b2a5cd0e0e5a415d$var$connectionType.HAS_ONE) {
                const associationHasOne = association;
                associationHasOne.targetNames.forEach((targetName, idx)=>{
                    const associatedFieldName = associationHasOne.associatedWith[idx];
                    normalized[targetName] = inputValue[associatedFieldName];
                });
            }
            if (association?.connectionType === $b2a5cd0e0e5a415d$var$connectionType.BELONGS_TO) {
                const associationBelongsTo = association;
                associationBelongsTo.targetNames.forEach((targetName, idx)=>{
                    if (idx === 0) {
                        const associatedFieldName = relatedModelPkInfo.primaryKeyFieldName;
                        normalized[targetName] = inputValue[associatedFieldName];
                    } else {
                        const associatedFieldName = relatedModelPkInfo.sortKeyFieldNames[idx - 1];
                        normalized[targetName] = inputValue[associatedFieldName];
                    }
                });
            }
        } else normalized[inputFieldName] = inputValue;
    });
    return normalized;
}
/**
 * Produces a parameter object that can contains auth mode/token overrides
 * only if present in either `options` (first) or configured on the `client`
 * as a fallback.
 *
 * @param client Configured client from `generateClient`
 * @param options Args/Options object from call site.
 * @returns
 */ function $b2a5cd0e0e5a415d$export$f5679e96571d0641(client, getInternals, options = {}) {
    const internals = getInternals(client);
    return {
        authMode: options.authMode || internals.authMode,
        authToken: options.authToken || internals.authToken
    };
}
/**
 * Retrieves custom headers from either the client or request options.
 * @param client V6Client | V6ClientSSRRequest | V6ClientSSRCookies - for extracting client headers
 * @param requestHeaders {@link CustomHeaders} - request headers
 * @returns custom headers as {@link CustomHeaders}
 */ function $b2a5cd0e0e5a415d$export$3fc25db7b420c1a4(client, getInternals, requestHeaders) {
    let headers = getInternals(client).headers || {};
    // Individual request headers will take precedence over client headers.
    // We intentionally do *not* merge client and request headers.
    if (requestHeaders) headers = requestHeaders;
    return headers;
}

});
parcelRegister("9QBef", function(module, exports) {

$parcel$export(module.exports, "resolveOwnerFields", () => $b9ce5ab58c372e24$export$597cd394a923f2bd);
/**
 * Given an introspection schema model, returns all owner fields.
 *
 * @param model Model from an introspection schema
 * @returns List of owner field names
 */ function $b9ce5ab58c372e24$export$597cd394a923f2bd(model) {
    const ownerFields = new Set();
    for (const attr of model.attributes || []){
        if ($b9ce5ab58c372e24$var$isAuthAttribute(attr)) for (const rule of attr.properties.rules){
            if (rule.allow === "owner") ownerFields.add(rule.ownerField || "owner");
            else if (rule.allow === "groups" && rule.groupsField !== undefined) // only valid for dynamic group(s)
            // static group auth will have an array of predefined groups in the attribute, groups: string[]
            // but `groupsField` will be undefined
            ownerFields.add(rule.groupsField);
        }
    }
    return Array.from(ownerFields);
}
/**
 * Type guard that identifies an auth attribute with an attached rules list that
 * specifies an `allow` attribute at a minimum.
 *
 * @param attribute Any object. Ideally a model introspection schema model attribute
 * @returns True if given object is an auth attribute
 */ function $b9ce5ab58c372e24$var$isAuthAttribute(attribute) {
    if (attribute?.type === "auth") {
        if (typeof attribute?.properties === "object") {
            if (Array.isArray(attribute?.properties?.rules)) return attribute?.properties?.rules.every((rule)=>!!rule.allow);
        }
    }
    return false;
}

});

parcelRegister("5f5iX", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $0fbbac2db215067c$export$9a00dee1beb8f576);
/**
 * @param s string to capitalize
 * @returns capitalized string
 */ function $0fbbac2db215067c$export$9a00dee1beb8f576(s) {
    return `${s[0].toUpperCase()}${s.slice(1)}`;
}

});

parcelRegister("2DZ3G", function(module, exports) {

$parcel$export(module.exports, "selfAwareAsync", () => $b3be8e16d0490f8c$export$4d2a678382e411de);
/**
 * Executes an `async` resolver function, providing the `Promise`-to-be-returned as the
 * first argument to the resolver so that the resolver can refer to the `Promise` that
 * external callers will see.
 *
 * ```ts
 * const outer = selfAwareAsync(async inner => {
 *  console.log(outer === inner); // true
 * });
 * ```
 *
 * This utility exists to reduce boilerplate in cases where promise resolving code needs
 * to track or register its "own" `Promise` *as seen by the caller* in some way. E.g.,
 * when mapping `Promise` chains for `client.cancel()`.
 *
 * @param resolver
 * @returns
 */ function $b3be8e16d0490f8c$export$4d2a678382e411de(resolver) {
    let resolve;
    let reject;
    const resultPromise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    resolver(resultPromise).then((result)=>{
        resolve(result);
    }).catch((error)=>{
        reject(error);
    });
    return resultPromise;
}

});

parcelRegister("4vIv1", function(module, exports) {

$parcel$export(module.exports, "extendCancellability", () => $7edbd231fcefa6b0$export$bc61956a3f1f7b63);
$parcel$export(module.exports, "upgradeClientCancellation", () => $7edbd231fcefa6b0$export$8e8167e4816d4e40);
/**
 * A map of cancellable promise "extensions".
 *
 * Each entry value must either be a directly `cancel()`-able promise, or must
 * refer to another entry.
 *
 * When cancellation of a promise is requested, cancel
 * will check to see if the promise exists in the map. If it does, it pulls
 * the value and repeats the check. If not, it will perform the underlying
 * cancel operation.
 */ const $7edbd231fcefa6b0$var$promiseMap = new WeakMap();
function $7edbd231fcefa6b0$export$bc61956a3f1f7b63(existingCancellablePromise, newPromiseToRegister) {
    $7edbd231fcefa6b0$var$promiseMap.set(newPromiseToRegister, existingCancellablePromise);
    return existingCancellablePromise.finally(()=>{
        $7edbd231fcefa6b0$var$promiseMap.delete(newPromiseToRegister);
    });
}
/**
 * Wraps the existing `cancel()` method with logic to iteratively search for
 * the corresponding base level promise, if needed, that the core graphql client
 * knows how to cancel.
 *
 * @param client
 */ function $7edbd231fcefa6b0$export$8e8167e4816d4e40(client) {
    const innerCancel = client.cancel.bind(client);
    client.cancel = function(promise, message) {
        const visited = new Set();
        let targetPromise = promise;
        while(targetPromise && $7edbd231fcefa6b0$var$promiseMap.has(targetPromise)){
            if (visited.has(targetPromise)) throw new Error("A cycle was detected in the modeled graphql cancellation chain. This is a bug. Please report it!");
            visited.add(targetPromise);
            targetPromise = $7edbd231fcefa6b0$var$promiseMap.get(targetPromise);
        }
        // call `innerCancel` with `targetPromise!` to defer to existing implementation
        // on how to handle `null | undefined` or otherwise "non-cancellable" objects.
        return innerCancel(targetPromise, message);
    };
}

});


parcelRegister("kffnY", function(module, exports) {

$parcel$export(module.exports, "handleListGraphQlError", () => $455a08f4f6096c10$export$e8a8fbbe81664f9a);
$parcel$export(module.exports, "handleSingularGraphQlError", () => $455a08f4f6096c10$export$97f0f9e69eac9f87);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// import { GraphQLFormattedError } from '@aws-amplify/data-schema-types';
/**
 * Handle errors for list return types (list and index query operations)
 */ function $455a08f4f6096c10$export$e8a8fbbe81664f9a(error) {
    if (error?.errors) // graphql errors pass through
    return {
        ...error,
        data: []
    };
    else // non-graphql errors are re-thrown
    throw error;
}
/**
 * Handle errors for singular return types (create, get, update, delete operations)
 */ function $455a08f4f6096c10$export$97f0f9e69eac9f87(error) {
    if (error.errors) // graphql errors pass through
    return {
        ...error,
        data: null
    };
    else // non-graphql errors are re-thrown
    throw error;
}

});

parcelRegister("6yFdo", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_USER_AGENT_OVERRIDE", () => $a064e4ef15bb3116$export$a8a16d3c2cd490ea);
$parcel$export(module.exports, "AiAction", () => $a064e4ef15bb3116$export$89656a7f296a8665);
$parcel$export(module.exports, "getCustomUserAgentDetails", () => $a064e4ef15bb3116$export$9b73512869173252);
$parcel$export(module.exports, "createUserAgentOverride", () => $a064e4ef15bb3116$export$b9ea2ab1a36ae648);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Symbol used for internal user agent overrides.
 *
 * @internal
 * This symbol is intended for internal use within the Amplify library.
 * It may change or be removed in future versions without notice.
 * External usage of this symbol is discouraged and may lead to unexpected behavior.
 */ const $a064e4ef15bb3116$export$a8a16d3c2cd490ea = Symbol("INTERNAL_USER_AGENT_OVERRIDE");
var $a064e4ef15bb3116$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnStreamEvent"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($a064e4ef15bb3116$export$89656a7f296a8665 || ($a064e4ef15bb3116$export$89656a7f296a8665 = {}));
const $a064e4ef15bb3116$export$9b73512869173252 = (action)=>({
        category: "ai",
        action: action
    });
/**
 * Creates a user agent override object based on custom details.
 *
 * @internal
 * This function is intended for internal use within the Amplify library.
 * It may change or be removed in future versions without notice.
 *
 * @param customUserAgentDetails - Optional custom user agent details
 * @returns An object with INTERNAL_USER_AGENT_OVERRIDE symbol as key and customUserAgentDetails as value, or undefined if no details provided
 */ function $a064e4ef15bb3116$export$b9ea2ab1a36ae648(customUserAgentDetails) {
    return customUserAgentDetails ? {
        [$a064e4ef15bb3116$export$a8a16d3c2cd490ea]: customUserAgentDetails
    } : undefined;
}

});



parcelRegister("dcKA0", function(module, exports) {

$parcel$export(module.exports, "generateConversationsProperty", () => $159de59d00723397$export$7025b27ae1a2bc0c);

var $f9JBS = parcelRequire("f9JBS");

var $482Qs = parcelRequire("482Qs");

var $aeLOG = parcelRequire("aeLOG");

var $6btDu = parcelRequire("6btDu");

var $eBDw9 = parcelRequire("eBDw9");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $159de59d00723397$export$7025b27ae1a2bc0c(client, apiGraphQLConfig, getInternals) {
    const modelIntrospection = apiGraphQLConfig?.modelIntrospection;
    // conversations will be absent from model intro schema if no conversation routes
    // are present on the source schema.
    if (!modelIntrospection?.conversations) return {};
    const conversations = {};
    for (const { name: name, conversation: conversation, message: message, models: models, nonModels: nonModels, enums: enums } of Object.values(modelIntrospection.conversations)){
        const conversationModel = models[conversation.modelName];
        const conversationMessageModel = models[message.modelName];
        if (!conversationModel || !conversationMessageModel) return {};
        const conversationModelIntrospection = {
            ...modelIntrospection,
            models: {
                ...modelIntrospection.models,
                ...models
            },
            nonModels: {
                ...modelIntrospection.nonModels,
                ...nonModels
            },
            enums: {
                ...modelIntrospection.enums,
                ...enums
            }
        };
        conversations[name] = {
            update: (0, $eBDw9.createUpdateConversationFunction)(client, conversationModelIntrospection, name, conversationModel, conversationMessageModel, getInternals),
            create: (0, $f9JBS.createCreateConversationFunction)(client, conversationModelIntrospection, name, conversationModel, conversationMessageModel, getInternals),
            get: (0, $482Qs.createGetConversationFunction)(client, conversationModelIntrospection, name, conversationModel, conversationMessageModel, getInternals),
            delete: (0, $6btDu.createDeleteConversationFunction)(client, conversationModelIntrospection, name, conversationModel, conversationMessageModel, getInternals),
            list: (0, $aeLOG.createListConversationsFunction)(client, conversationModelIntrospection, name, conversationModel, conversationMessageModel, getInternals)
        };
    }
    return conversations;
}

});
parcelRegister("f9JBS", function(module, exports) {

$parcel$export(module.exports, "createCreateConversationFunction", () => $7e46ce339c193ba1$export$a76e16a38c366de0);

var $kJQHC = parcelRequire("kJQHC");

var $bd4Mv = parcelRequire("bd4Mv");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7e46ce339c193ba1$export$a76e16a38c366de0 = (client, modelIntrospection, conversationRouteName, conversationModel, conversationMessageModel, getInternals)=>async (input)=>{
        const { name: name, metadata: metadataObject } = input ?? {};
        const metadata = JSON.stringify(metadataObject);
        const createOperation = (0, $kJQHC.getFactory)(client, modelIntrospection, conversationModel, "CREATE", getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).CreateConversation));
        const { data: data, errors: errors } = await createOperation({
            name: name,
            metadata: metadata
        });
        return {
            data: (0, $bd4Mv.convertItemToConversation)(client, modelIntrospection, data?.id, data?.createdAt, data?.updatedAt, conversationRouteName, conversationMessageModel, getInternals, data?.metadata, data?.name),
            errors: errors
        };
    };

});
parcelRegister("kJQHC", function(module, exports) {

$parcel$export(module.exports, "getFactory", () => $d31d4e5c917521bf$export$4dc777407e7dc1ac);

var $lmrPf = parcelRequire("lmrPf");

var $kffnY = parcelRequire("kffnY");

var $2DZ3G = parcelRequire("2DZ3G");

var $4vIv1 = parcelRequire("4vIv1");

var $6yFdo = parcelRequire("6yFdo");
function $d31d4e5c917521bf$export$4dc777407e7dc1ac(client, modelIntrospection, model, operation, getInternals, useContext = false, customUserAgentDetails) {
    const getWithContext = (contextSpec, arg, options)=>{
        return $d31d4e5c917521bf$var$_get(client, modelIntrospection, model, arg, options, operation, getInternals, contextSpec, customUserAgentDetails);
    };
    const get = (arg, options)=>{
        return $d31d4e5c917521bf$var$_get(client, modelIntrospection, model, arg, options, operation, getInternals, undefined, customUserAgentDetails);
    };
    return useContext ? getWithContext : get;
}
function $d31d4e5c917521bf$var$_get(client, modelIntrospection, model, arg, options, operation, getInternals, context, customUserAgentDetails) {
    return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
        const { name: name } = model;
        const query = (0, $lmrPf.generateGraphQLDocument)(modelIntrospection, model, operation, options);
        const variables = (0, $lmrPf.buildGraphQLVariables)(model, operation, arg, modelIntrospection);
        const auth = (0, $lmrPf.authModeParams)(client, getInternals, options);
        const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, options?.headers);
        const userAgentOverride = (0, $6yFdo.createUserAgentOverride)(customUserAgentDetails);
        try {
            const basePromise = context ? client.graphql(context, {
                ...auth,
                query: query,
                variables: variables
            }, headers) : client.graphql({
                ...auth,
                query: query,
                variables: variables,
                ...userAgentOverride
            }, headers);
            const extendedPromise = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
            const { data: data, extensions: extensions } = await extendedPromise;
            // flatten response
            if (data) {
                const [key] = Object.keys(data);
                const flattenedResult = (0, $lmrPf.flattenItems)(modelIntrospection, name, data[key]);
                if (flattenedResult === null) return {
                    data: null,
                    extensions: extensions
                };
                else if (options?.selectionSet) return {
                    data: flattenedResult,
                    extensions: extensions
                };
                else {
                    // TODO: refactor to avoid destructuring here
                    const [initialized] = (0, $lmrPf.initializeModel)(client, name, [
                        flattenedResult
                    ], modelIntrospection, auth.authMode, auth.authToken, !!context);
                    return {
                        data: initialized,
                        extensions: extensions
                    };
                }
            } else return {
                data: null,
                extensions: extensions
            };
        } catch (error) {
            /**
             * The `data` type returned by `error` here could be:
             * 1) `null`
             * 2) an empty object
             * 3) "populated" but with a `null` value `{ getPost: null }`
             * 4) an actual record `{ getPost: { id: '1', title: 'Hello, World!' } }`
             */ const { data: data, errors: errors } = error;
            /**
             * `data` is not `null`, and is not an empty object:
             */ if (data && Object.keys(data).length !== 0 && errors) {
                const [key] = Object.keys(data);
                const flattenedResult = (0, $lmrPf.flattenItems)(modelIntrospection, name, data[key]);
                /**
                 * `flattenedResult` could be `null` here (e.g. `data: { getPost: null }`)
                 * if `flattenedResult`, result is an actual record:
                 */ if (flattenedResult) {
                    if (options?.selectionSet) return {
                        data: flattenedResult,
                        errors: errors
                    };
                    else {
                        // TODO: refactor to avoid destructuring here
                        const [initialized] = (0, $lmrPf.initializeModel)(client, name, [
                            flattenedResult
                        ], modelIntrospection, auth.authMode, auth.authToken, !!context);
                        return {
                            data: initialized,
                            errors: errors
                        };
                    }
                } else // was `data: { getPost: null }`)
                return (0, $kffnY.handleSingularGraphQlError)(error);
            } else // `data` is `null`:
            return (0, $kffnY.handleSingularGraphQlError)(error);
        }
    });
}

});

parcelRegister("bd4Mv", function(module, exports) {

$parcel$export(module.exports, "convertItemToConversation", () => $c5d60cd3c4fa8e53$export$2e90f7c7547f29ba);

var $02B11 = parcelRequire("02B11");

var $2EfSM = parcelRequire("2EfSM");

var $9Gr7W = parcelRequire("9Gr7W");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c5d60cd3c4fa8e53$export$2e90f7c7547f29ba = (client, modelIntrospection, conversationId, conversationCreatedAt, conversationUpdatedAt, conversationRouteName, conversationMessageModel, getInternals, conversationMetadata, conversationName)=>{
    if (!conversationId) throw new Error(`An error occurred converting a ${conversationRouteName} conversation: Missing ID`);
    return {
        id: conversationId,
        createdAt: conversationCreatedAt,
        updatedAt: conversationUpdatedAt,
        metadata: conversationMetadata,
        name: conversationName,
        onStreamEvent: (0, $2EfSM.createOnStreamEventFunction)(client, modelIntrospection, conversationId, conversationRouteName, getInternals),
        sendMessage: (0, $9Gr7W.createSendMessageFunction)(client, modelIntrospection, conversationId, conversationRouteName, getInternals),
        listMessages: (0, $02B11.createListMessagesFunction)(client, modelIntrospection, conversationId, conversationMessageModel, getInternals)
    };
};

});
parcelRegister("02B11", function(module, exports) {

$parcel$export(module.exports, "createListMessagesFunction", () => $9bb73ed2f4c34560$export$3acf755aeca3e9af);

var $blCgB = parcelRequire("blCgB");

var $ff10y = parcelRequire("ff10y");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9bb73ed2f4c34560$export$3acf755aeca3e9af = (client, modelIntrospection, conversationId, conversationMessageModel, getInternals)=>async (input)=>{
        const list = (0, $blCgB.listFactory)(client, modelIntrospection, conversationMessageModel, getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).ListMessages));
        const { data: data, nextToken: nextToken, errors: errors } = await list({
            ...input,
            filter: {
                conversationId: {
                    eq: conversationId
                }
            }
        });
        return {
            data: data.map((item)=>(0, $ff10y.convertItemToConversationMessage)(item)),
            nextToken: nextToken,
            errors: errors
        };
    };

});
parcelRegister("blCgB", function(module, exports) {

$parcel$export(module.exports, "listFactory", () => $56806e4f3eef8e98$export$b6e08b958e381d1b);

var $lmrPf = parcelRequire("lmrPf");

var $kffnY = parcelRequire("kffnY");

var $2DZ3G = parcelRequire("2DZ3G");

var $4vIv1 = parcelRequire("4vIv1");

var $6yFdo = parcelRequire("6yFdo");
function $56806e4f3eef8e98$export$b6e08b958e381d1b(client, modelIntrospection, model, getInternals, context = false, customUserAgentDetails) {
    const listWithContext = (contextSpec, args)=>{
        return $56806e4f3eef8e98$var$_list(client, modelIntrospection, model, getInternals, args, contextSpec, customUserAgentDetails);
    };
    const list = (args)=>{
        return $56806e4f3eef8e98$var$_list(client, modelIntrospection, model, getInternals, args, undefined, customUserAgentDetails);
    };
    return context ? listWithContext : list;
}
function $56806e4f3eef8e98$var$_list(client, modelIntrospection, model, getInternals, args, contextSpec, customUserAgentDetails) {
    return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
        const { name: name } = model;
        const query = (0, $lmrPf.generateGraphQLDocument)(modelIntrospection, model, "LIST", args);
        const variables = (0, $lmrPf.buildGraphQLVariables)(model, "LIST", args, modelIntrospection);
        const auth = (0, $lmrPf.authModeParams)(client, getInternals, args);
        const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, args?.headers);
        const userAgentOverride = (0, $6yFdo.createUserAgentOverride)(customUserAgentDetails);
        try {
            const basePromise = contextSpec ? client.graphql(contextSpec, {
                ...auth,
                query: query,
                variables: variables
            }, headers) : client.graphql({
                ...auth,
                query: query,
                variables: variables,
                ...userAgentOverride
            }, headers);
            const extendedPromise = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
            const { data: data, extensions: extensions } = await extendedPromise;
            // flatten response
            if (data !== undefined) {
                const [key] = Object.keys(data);
                if (data[key].items) {
                    const flattenedResult = data[key].items.map((value)=>(0, $lmrPf.flattenItems)(modelIntrospection, name, value));
                    // don't init if custom selection set
                    if (args?.selectionSet) return {
                        data: flattenedResult,
                        nextToken: data[key].nextToken,
                        extensions: extensions
                    };
                    else {
                        const initialized = (0, $lmrPf.initializeModel)(client, name, flattenedResult, modelIntrospection, auth.authMode, auth.authToken, !!contextSpec);
                        return {
                            data: initialized,
                            nextToken: data[key].nextToken,
                            extensions: extensions
                        };
                    }
                }
                return {
                    data: data[key],
                    nextToken: data[key].nextToken,
                    extensions: extensions
                };
            }
        } catch (error) {
            /**
             * The `data` type returned by `error` here could be:
             * 1) `null`
             * 2) an empty object
             * 3) "populated" but with a `null` value `data: { listPosts: null }`
             * 4) actual records `data: { listPosts: items: [{ id: '1', ...etc }] }`
             */ const { data: data, errors: errors } = error;
            // `data` is not `null`, and is not an empty object:
            if (data !== undefined && data !== null && Object.keys(data).length !== 0 && errors) {
                const [key] = Object.keys(data);
                if (data[key]?.items) {
                    const flattenedResult = data[key].items.map((value)=>(0, $lmrPf.flattenItems)(modelIntrospection, name, value));
                    /**
                     * Check exists since `flattenedResult` could be `null`.
                     * if `flattenedResult` exists, result is an actual record.
                     */ if (flattenedResult) {
                        // don't init if custom selection set
                        if (args?.selectionSet) return {
                            data: flattenedResult,
                            nextToken: data[key]?.nextToken,
                            errors: errors
                        };
                        else {
                            const initialized = (0, $lmrPf.initializeModel)(client, name, flattenedResult, modelIntrospection, auth.authMode, auth.authToken, !!contextSpec);
                            // data is full record w/out selection set:
                            return {
                                data: initialized,
                                nextToken: data[key]?.nextToken,
                                errors: errors
                            };
                        }
                    }
                    return {
                        data: data[key],
                        nextToken: data[key]?.nextToken,
                        errors: errors
                    };
                } else // response is of type `data: { getPost: null }`)
                return (0, $kffnY.handleListGraphQlError)(error);
            } else // `data` is `null` or an empty object:
            return (0, $kffnY.handleListGraphQlError)(error);
        }
    });
}

});

parcelRegister("ff10y", function(module, exports) {

$parcel$export(module.exports, "convertItemToConversationMessage", () => $569d6463ea998390$export$b152493ad9c3851);

var $dGkhU = parcelRequire("dGkhU");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $569d6463ea998390$export$b152493ad9c3851 = ({ content: content, createdAt: createdAt, id: id, conversationId: conversationId, role: role })=>({
        content: (0, $dGkhU.deserializeContent)(content ?? []),
        conversationId: conversationId,
        createdAt: createdAt,
        id: id,
        role: role
    });

});
parcelRegister("dGkhU", function(module, exports) {

$parcel$export(module.exports, "deserializeContent", () => $4fb959e07f78145d$export$4eab5ab56adaef3);
parcelRequire("sAmZU");
var $3kZdG = parcelRequire("3kZdG");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4fb959e07f78145d$export$4eab5ab56adaef3 = (content)=>content.map((block)=>{
        if (block.image) return $4fb959e07f78145d$var$deserializeImageBlock(block);
        if (block.document) return $4fb959e07f78145d$var$deserializeDocumentBlock(block);
        if (block.toolUse) return $4fb959e07f78145d$var$deserializeToolUseBlock(block);
        if (block.toolResult) return $4fb959e07f78145d$var$deserializeToolResultBlock(block);
        return $4fb959e07f78145d$var$removeNullsFromBlock(block);
    });
const $4fb959e07f78145d$var$deserializeImageBlock = ({ image: image })=>({
        image: {
            ...image,
            source: {
                ...image.source,
                bytes: (0, $3kZdG.fromBase64)(image.source.bytes)
            }
        }
    });
const $4fb959e07f78145d$var$deserializeDocumentBlock = ({ document: document })=>({
        document: {
            ...document,
            source: {
                ...document.source,
                bytes: (0, $3kZdG.fromBase64)(document.source.bytes)
            }
        }
    });
const $4fb959e07f78145d$var$deserializeJsonBlock = ({ json: json })=>({
        json: JSON.parse(json)
    });
const $4fb959e07f78145d$var$deserializeToolUseBlock = ({ toolUse: toolUse })=>({
        toolUse: {
            ...toolUse,
            input: JSON.parse(toolUse.input)
        }
    });
const $4fb959e07f78145d$var$deserializeToolResultBlock = ({ toolResult: toolResult })=>({
        toolResult: {
            toolUseId: toolResult.toolUseId,
            content: toolResult.content.map((toolResultBlock)=>{
                if (toolResultBlock.image) return $4fb959e07f78145d$var$deserializeImageBlock(toolResultBlock);
                if (toolResultBlock.json) return $4fb959e07f78145d$var$deserializeJsonBlock(toolResultBlock);
                return $4fb959e07f78145d$var$removeNullsFromBlock(toolResultBlock);
            })
        }
    });
const $4fb959e07f78145d$var$removeNullsFromBlock = (block)=>Object.fromEntries(Object.entries(block).filter(([_, v])=>v !== null));

});
parcelRegister("sAmZU", function(module, exports) {
$parcel$export(module.exports, "fromBase64", () => (parcelRequire("3kZdG")).fromBase64);
$parcel$export(module.exports, "toBase64", () => (parcelRequire("fSi4d")).toBase64);
parcelRequire("3kZdG");
parcelRequire("fSi4d");

});
parcelRegister("3kZdG", function(module, exports) {

$parcel$export(module.exports, "fromBase64", () => $26e2ba55729a8e75$export$c537b38001c583b7);

var $dU9VN = parcelRequire("dU9VN");
const $26e2ba55729a8e75$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $dU9VN.alphabetByEncoding))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $dU9VN.alphabetByEncoding)[input[j]] << (limit - j) * (0, $dU9VN.bitsPerLetter);
            bitLength += (0, $dU9VN.bitsPerLetter);
        } else bits >>= (0, $dU9VN.bitsPerLetter);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $dU9VN.bitsPerByte);
        const byteLength = Math.floor(bitLength / (0, $dU9VN.bitsPerByte));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $dU9VN.bitsPerByte);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};

});
parcelRegister("dU9VN", function(module, exports) {

$parcel$export(module.exports, "alphabetByEncoding", () => $a1f83572e1efebc8$export$7753813254d72972);
$parcel$export(module.exports, "alphabetByValue", () => $a1f83572e1efebc8$export$8f4022378ddff4c7);
$parcel$export(module.exports, "bitsPerLetter", () => $a1f83572e1efebc8$export$1c5cfd5e95b84581);
$parcel$export(module.exports, "bitsPerByte", () => $a1f83572e1efebc8$export$79b97ac4c24c9385);
$parcel$export(module.exports, "maxLetterValue", () => $a1f83572e1efebc8$export$43e943b030ae3d73);
const $a1f83572e1efebc8$export$7753813254d72972 = {};
const $a1f83572e1efebc8$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $a1f83572e1efebc8$export$7753813254d72972[char] = i;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $a1f83572e1efebc8$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
$a1f83572e1efebc8$export$7753813254d72972["+"] = 62;
$a1f83572e1efebc8$export$8f4022378ddff4c7[62] = "+";
$a1f83572e1efebc8$export$7753813254d72972["/"] = 63;
$a1f83572e1efebc8$export$8f4022378ddff4c7[63] = "/";
const $a1f83572e1efebc8$export$1c5cfd5e95b84581 = 6;
const $a1f83572e1efebc8$export$79b97ac4c24c9385 = 8;
const $a1f83572e1efebc8$export$43e943b030ae3d73 = 63;

});


parcelRegister("fSi4d", function(module, exports) {

$parcel$export(module.exports, "toBase64", () => $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462);
parcelRequire("cmKsm");
var $8YtQk = parcelRequire("8YtQk");

var $dU9VN = parcelRequire("dU9VN");
function $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $8YtQk.fromUtf8)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $dU9VN.bitsPerByte);
            bitLength += (0, $dU9VN.bitsPerByte);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $dU9VN.bitsPerLetter));
        bits <<= bitClusterCount * (0, $dU9VN.bitsPerLetter) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $dU9VN.bitsPerLetter);
            str += (0, $dU9VN.alphabetByValue)[(bits & (0, $dU9VN.maxLetterValue) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});
parcelRegister("cmKsm", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("8YtQk")).fromUtf8);
parcelRequire("8YtQk");
parcelRequire("76ED5");
parcelRequire("hoQFu");

});
parcelRegister("8YtQk", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $688b138af1cbd321$export$c7c5cef950a4d2fc);
const $688b138af1cbd321$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("76ED5", function(module, exports) {

var $8YtQk = parcelRequire("8YtQk");
const $52c89c1e5f6e91a3$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $8YtQk.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("hoQFu", function(module, exports) {
const $caad885bdc488ab0$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});







parcelRegister("2EfSM", function(module, exports) {

$parcel$export(module.exports, "createOnStreamEventFunction", () => $ec39d4348470ee34$export$9446eb3a26de9524);

var $aDcpw = parcelRequire("aDcpw");

var $6yFdo = parcelRequire("6yFdo");

var $k459p = parcelRequire("k459p");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ec39d4348470ee34$export$9446eb3a26de9524 = (client, modelIntrospection, conversationId, conversationRouteName, getInternals)=>(handler)=>{
        const { conversations: conversations } = modelIntrospection;
        // Safe guard for standalone function. When called as part of client generation, this should never be falsy.
        if (!conversations) return {};
        const subscribeSchema = conversations[conversationRouteName].message.subscribe;
        const subscribeOperation = (0, $aDcpw.customOpFactory)(client, modelIntrospection, "subscription", subscribeSchema, false, getInternals, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).OnStreamEvent));
        return subscribeOperation({
            conversationId: conversationId
        }).subscribe((data)=>{
            const { next: next, error: error } = (0, $k459p.convertItemToConversationStreamEvent)(data);
            if (error) handler.error(error);
            if (next) handler.next(next);
        });
    };

});
parcelRegister("k459p", function(module, exports) {

$parcel$export(module.exports, "convertItemToConversationStreamEvent", () => $81d4477d0d74495d$export$f786b3422c827749);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $81d4477d0d74495d$export$f786b3422c827749 = ({ id: id, conversationId: conversationId, associatedUserMessageId: associatedUserMessageId, contentBlockIndex: contentBlockIndex, contentBlockDoneAtIndex: contentBlockDoneAtIndex, contentBlockDeltaIndex: contentBlockDeltaIndex, contentBlockText: contentBlockText, contentBlockToolUse: contentBlockToolUse, stopReason: stopReason, errors: errors })=>{
    if (errors) {
        const error = {
            id: id,
            conversationId: conversationId,
            associatedUserMessageId: associatedUserMessageId,
            errors: errors
        };
        return {
            error: error
        };
    }
    const next = $81d4477d0d74495d$var$removeNullsFromConversationStreamEvent({
        id: id,
        conversationId: conversationId,
        associatedUserMessageId: associatedUserMessageId,
        contentBlockIndex: contentBlockIndex,
        contentBlockDoneAtIndex: contentBlockDoneAtIndex,
        contentBlockDeltaIndex: contentBlockDeltaIndex,
        text: contentBlockText,
        toolUse: $81d4477d0d74495d$var$deserializeToolUseBlock(contentBlockToolUse),
        stopReason: stopReason
    });
    return {
        next: next
    };
};
const $81d4477d0d74495d$var$deserializeToolUseBlock = (contentBlockToolUse)=>{
    if (contentBlockToolUse) {
        const toolUseBlock = {
            ...contentBlockToolUse,
            input: JSON.parse(contentBlockToolUse.input)
        };
        return toolUseBlock;
    }
};
const $81d4477d0d74495d$var$removeNullsFromConversationStreamEvent = (block)=>Object.fromEntries(Object.entries(block).filter(([_, v])=>v !== null));

});


parcelRegister("9Gr7W", function(module, exports) {

$parcel$export(module.exports, "createSendMessageFunction", () => $ee75ce417c5dfd35$export$a882e6f42371c26d);

var $aDcpw = parcelRequire("aDcpw");

var $ff10y = parcelRequire("ff10y");

var $0OBQS = parcelRequire("0OBQS");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ee75ce417c5dfd35$export$a882e6f42371c26d = (client, modelIntrospection, conversationId, conversationRouteName, getInternals)=>async (input)=>{
        const { conversations: conversations } = modelIntrospection;
        // Safe guard for standalone function. When called as part of client generation, this should never be falsy.
        if (!conversations) return {};
        const processedInput = typeof input === "string" ? {
            content: [
                {
                    text: input
                }
            ]
        } : input;
        const { content: content, aiContext: aiContext, toolConfiguration: toolConfiguration } = processedInput;
        const sendSchema = conversations[conversationRouteName].message.send;
        const sendOperation = (0, $aDcpw.customOpFactory)(client, modelIntrospection, "mutation", sendSchema, false, getInternals, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).SendMessage));
        const { data: data, errors: errors } = await sendOperation({
            conversationId: conversationId,
            content: (0, $0OBQS.serializeContent)(content),
            ...aiContext && {
                aiContext: (0, $0OBQS.serializeAiContext)(aiContext)
            },
            ...toolConfiguration && {
                toolConfiguration: (0, $0OBQS.serializeToolConfiguration)(toolConfiguration)
            }
        });
        return {
            data: data ? (0, $ff10y.convertItemToConversationMessage)(data) : data,
            errors: errors
        };
    };

});
parcelRegister("0OBQS", function(module, exports) {

$parcel$export(module.exports, "serializeAiContext", () => $830c7be27ec06457$export$6cab6c920f9519d4);
$parcel$export(module.exports, "serializeContent", () => $830c7be27ec06457$export$3dc7b315881a047c);
$parcel$export(module.exports, "serializeToolConfiguration", () => $830c7be27ec06457$export$af5677580964703b);
parcelRequire("sAmZU");
var $fSi4d = parcelRequire("fSi4d");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $830c7be27ec06457$export$6cab6c920f9519d4 = (aiContext)=>JSON.stringify(aiContext);
const $830c7be27ec06457$export$3dc7b315881a047c = (content)=>content.map((block)=>{
        if (block.image) return $830c7be27ec06457$var$serializeImageBlock(block);
        if (block.document) return $830c7be27ec06457$var$serializeDocumentBlock(block);
        if (block.toolResult) return $830c7be27ec06457$var$serializeToolResultBlock(block);
        return block;
    });
const $830c7be27ec06457$export$af5677580964703b = ({ tools: tools })=>({
        tools: Object.entries(tools).map(([name, tool])=>({
                toolSpec: {
                    name: name,
                    description: tool.description,
                    inputSchema: {
                        json: JSON.stringify(tool.inputSchema.json)
                    }
                }
            }))
    });
const $830c7be27ec06457$var$serializeImageBlock = ({ image: image })=>({
        image: {
            ...image,
            source: {
                ...image.source,
                bytes: (0, $fSi4d.toBase64)(image.source.bytes)
            }
        }
    });
const $830c7be27ec06457$var$serializeDocumentBlock = ({ document: document })=>({
        document: {
            ...document,
            source: {
                ...document.source,
                bytes: (0, $fSi4d.toBase64)(document.source.bytes)
            }
        }
    });
const $830c7be27ec06457$var$serializeJsonBlock = ({ json: json })=>({
        json: JSON.stringify(json)
    });
const $830c7be27ec06457$var$serializeToolResultBlock = ({ toolResult: toolResult })=>({
        toolResult: {
            ...toolResult,
            content: toolResult.content.map((toolResultBlock)=>{
                if (toolResultBlock.image) return $830c7be27ec06457$var$serializeImageBlock(toolResultBlock);
                if (toolResultBlock.json) return $830c7be27ec06457$var$serializeJsonBlock(toolResultBlock);
                return toolResultBlock;
            })
        }
    });

});




parcelRegister("482Qs", function(module, exports) {

$parcel$export(module.exports, "createGetConversationFunction", () => $039e62a413b65f18$export$449478531ad8534e);

var $kJQHC = parcelRequire("kJQHC");

var $bd4Mv = parcelRequire("bd4Mv");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $039e62a413b65f18$export$449478531ad8534e = (client, modelIntrospection, conversationRouteName, conversationModel, conversationMessageModel, getInternals)=>async ({ id: id })=>{
        const get = (0, $kJQHC.getFactory)(client, modelIntrospection, conversationModel, "GET", getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).GetConversation));
        const { data: data, errors: errors } = await get({
            id: id
        });
        return {
            data: data ? (0, $bd4Mv.convertItemToConversation)(client, modelIntrospection, data.id, data.createdAt, data.updatedAt, conversationRouteName, conversationMessageModel, getInternals, data?.metadata, data?.name) : data,
            errors: errors
        };
    };

});

parcelRegister("aeLOG", function(module, exports) {

$parcel$export(module.exports, "createListConversationsFunction", () => $af43b12298898701$export$314f7799f8ab3053);

var $blCgB = parcelRequire("blCgB");

var $bd4Mv = parcelRequire("bd4Mv");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $af43b12298898701$export$314f7799f8ab3053 = (client, modelIntrospection, conversationRouteName, conversationModel, conversationMessageModel, getInternals)=>async (input)=>{
        const list = (0, $blCgB.listFactory)(client, modelIntrospection, conversationModel, getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).ListConversations));
        const { data: data, nextToken: nextToken, errors: errors } = await list(input);
        return {
            data: data.map((datum)=>{
                return (0, $bd4Mv.convertItemToConversation)(client, modelIntrospection, datum.id, datum.createdAt, datum.updatedAt, conversationRouteName, conversationMessageModel, getInternals, datum?.metadata, datum?.name);
            }),
            nextToken: nextToken,
            errors: errors
        };
    };

});

parcelRegister("6btDu", function(module, exports) {

$parcel$export(module.exports, "createDeleteConversationFunction", () => $f9e0ff64450a0a86$export$3addfc15ba4af3af);

var $kJQHC = parcelRequire("kJQHC");

var $bd4Mv = parcelRequire("bd4Mv");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f9e0ff64450a0a86$export$3addfc15ba4af3af = (client, modelIntrospection, conversationRouteName, conversationModel, conversationMessageModel, getInternals)=>async ({ id: id })=>{
        const deleteOperation = (0, $kJQHC.getFactory)(client, modelIntrospection, conversationModel, "DELETE", getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).DeleteConversation));
        const { data: data, errors: errors } = await deleteOperation({
            id: id
        });
        return {
            data: data ? (0, $bd4Mv.convertItemToConversation)(client, modelIntrospection, data?.id, data?.createdAt, data?.updatedAt, conversationRouteName, conversationMessageModel, getInternals, data?.metadata, data?.name) : data,
            errors: errors
        };
    };

});

parcelRegister("eBDw9", function(module, exports) {

$parcel$export(module.exports, "createUpdateConversationFunction", () => $1c19daaffa8f3cf0$export$7dc2e92c971771ec);

var $kJQHC = parcelRequire("kJQHC");

var $bd4Mv = parcelRequire("bd4Mv");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1c19daaffa8f3cf0$export$7dc2e92c971771ec = (client, modelIntrospection, conversationRouteName, conversationModel, conversationMessageModel, getInternals)=>async ({ id: id, metadata: metadataObject, name: name })=>{
        const metadata = JSON.stringify(metadataObject);
        const updateOperation = (0, $kJQHC.getFactory)(client, modelIntrospection, conversationModel, "UPDATE", getInternals, false, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).UpdateConversation));
        const { data: data, errors: errors } = await updateOperation({
            id: id,
            metadata: metadata,
            name: name
        });
        return {
            data: data ? (0, $bd4Mv.convertItemToConversation)(client, modelIntrospection, data?.id, data?.createdAt, data?.updatedAt, conversationRouteName, conversationMessageModel, getInternals, data?.metadata, data?.name) : data,
            errors: errors
        };
    };

});


parcelRegister("8NA3L", function(module, exports) {

$parcel$export(module.exports, "generateGenerationsProperty", () => $8559c3fa1df18393$export$1499cce784412e6);

var $aDcpw = parcelRequire("aDcpw");

var $6yFdo = parcelRequire("6yFdo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8559c3fa1df18393$export$1499cce784412e6(client, apiGraphQLConfig, getInternals) {
    const modelIntrospection = apiGraphQLConfig?.modelIntrospection;
    // generations will be absent from model intro schema if no generation routes
    // are present on the source schema.
    if (!modelIntrospection?.generations) return {};
    const generations = {};
    for (const generation of Object.values(modelIntrospection.generations))generations[generation.name] = (0, $aDcpw.customOpFactory)(client, modelIntrospection, "query", generation, false, getInternals, (0, $6yFdo.getCustomUserAgentDetails)((0, $6yFdo.AiAction).Generation));
    return generations;
}

});

parcelRegister("4lQbP", function(module, exports) {

$parcel$export(module.exports, "generateEnumsProperty", () => $2c1118d97bf7e90c$export$79dd583f4b719897);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c1118d97bf7e90c$export$79dd583f4b719897 = (graphqlConfig)=>{
    const modelIntrospection = graphqlConfig.modelIntrospection;
    if (!modelIntrospection) return {};
    const enums = {};
    for (const [_, enumData] of Object.entries(modelIntrospection.enums))enums[enumData.name] = {
        values: ()=>enumData.values
    };
    return enums;
};

});

parcelRegister("43AGO", function(module, exports) {

$parcel$export(module.exports, "generateModelsProperty", () => $53cdf752a1b0b9ab$export$7aa40502ac76885f);

var $blCgB = parcelRequire("blCgB");

var $9rV2E = parcelRequire("9rV2E");

var $kJQHC = parcelRequire("kJQHC");

var $bUHRh = parcelRequire("bUHRh");

var $crKdm = parcelRequire("crKdm");

var $jWnAM = parcelRequire("jWnAM");
function $53cdf752a1b0b9ab$export$7aa40502ac76885f(client, apiGraphQLConfig, getInternals) {
    const models = {};
    const modelIntrospection = apiGraphQLConfig.modelIntrospection;
    if (!modelIntrospection) return {};
    const SUBSCRIPTION_OPS = [
        "ONCREATE",
        "ONUPDATE",
        "ONDELETE"
    ];
    for (const model of Object.values(modelIntrospection.models)){
        const { name: name } = model;
        models[name] = {};
        const enabledModelOps = (0, $jWnAM.excludeDisabledOps)(modelIntrospection, name);
        Object.entries(enabledModelOps).forEach(([key, { operationPrefix: operationPrefix }])=>{
            const operation = key;
            if (operation === "LIST") models[name][operationPrefix] = (0, $blCgB.listFactory)(client, modelIntrospection, model, getInternals);
            else if (SUBSCRIPTION_OPS.includes(operation)) models[name][operationPrefix] = (0, $bUHRh.subscriptionFactory)(client, modelIntrospection, model, operation, getInternals);
            else if (operation === "OBSERVEQUERY") models[name][operationPrefix] = (0, $crKdm.observeQueryFactory)(models, model);
            else models[name][operationPrefix] = (0, $kJQHC.getFactory)(client, modelIntrospection, model, operation, getInternals);
        });
        const secondaryIdxs = (0, $jWnAM.getSecondaryIndexesFromSchemaModel)(model);
        for (const idx of secondaryIdxs)models[name][idx.queryField] = (0, $9rV2E.indexQueryFactory)(client, modelIntrospection, model, idx, getInternals);
    }
    return models;
}

});
parcelRegister("9rV2E", function(module, exports) {

$parcel$export(module.exports, "indexQueryFactory", () => $7c02e074941e4ec7$export$2b22e8eab48dcd65);

var $lmrPf = parcelRequire("lmrPf");

var $kffnY = parcelRequire("kffnY");

var $2DZ3G = parcelRequire("2DZ3G");

var $4vIv1 = parcelRequire("4vIv1");
function $7c02e074941e4ec7$export$2b22e8eab48dcd65(client, modelIntrospection, model, indexMeta, getInternals, context = false) {
    const indexQueryWithContext = (contextSpec, args, options)=>{
        return $7c02e074941e4ec7$var$_indexQuery(client, modelIntrospection, model, indexMeta, getInternals, {
            ...args,
            ...options
        }, contextSpec);
    };
    const indexQuery = (args, options)=>{
        return $7c02e074941e4ec7$var$_indexQuery(client, modelIntrospection, model, indexMeta, getInternals, {
            ...args,
            ...options
        });
    };
    return context ? indexQueryWithContext : indexQuery;
}
function $7c02e074941e4ec7$var$processGraphQlResponse(modelIntroSchema, modelName, result, selectionSet, modelInitializer) {
    const { data: data, extensions: extensions } = result;
    const [key] = Object.keys(data);
    if (data[key].items) {
        const flattenedResult = data[key].items.map((value)=>(0, $lmrPf.flattenItems)(modelIntroSchema, modelName, value));
        return {
            data: selectionSet ? flattenedResult : modelInitializer(flattenedResult),
            nextToken: data[key].nextToken,
            extensions: extensions
        };
    }
    // Index queries are always list queries. No `items`? No flattening needed.
    return {
        data: data[key],
        nextToken: data[key].nextToken,
        extensions: extensions
    };
}
function $7c02e074941e4ec7$var$_indexQuery(client, modelIntrospection, model, indexMeta, getInternals, args, contextSpec) {
    return (0, $2DZ3G.selfAwareAsync)(async (resultPromise)=>{
        const { name: name } = model;
        const query = (0, $lmrPf.generateGraphQLDocument)(modelIntrospection, model, "INDEX_QUERY", args, indexMeta);
        const variables = (0, $lmrPf.buildGraphQLVariables)(model, "INDEX_QUERY", args, modelIntrospection, indexMeta);
        const auth = (0, $lmrPf.authModeParams)(client, getInternals, args);
        const modelInitializer = (flattenedResult)=>(0, $lmrPf.initializeModel)(client, name, flattenedResult, modelIntrospection, auth.authMode, auth.authToken, !!contextSpec);
        try {
            const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, args?.headers);
            const graphQlParams = {
                ...auth,
                query: query,
                variables: variables
            };
            const requestArgs = [
                graphQlParams,
                headers
            ];
            if (contextSpec !== undefined) requestArgs.unshift(contextSpec);
            const basePromise = client.graphql(...requestArgs);
            const extendedPromise = (0, $4vIv1.extendCancellability)(basePromise, resultPromise);
            const response = await extendedPromise;
            if (response.data !== undefined) return $7c02e074941e4ec7$var$processGraphQlResponse(modelIntrospection, name, response, args?.selectionSet, modelInitializer);
        } catch (error) {
            /**
             * The `data` type returned by `error` here could be:
             * 1) `null`
             * 2) an empty object
             * 3) "populated" but with a `null` value:
             *   `data: { listByExampleId: null }`
             * 4) an actual record:
             *   `data: { listByExampleId: items: [{ id: '1', ...etc } }]`
             */ const { data: data, errors: errors } = error;
            // `data` is not `null`, and is not an empty object:
            if (data !== undefined && data !== null && Object.keys(data).length !== 0 && errors) {
                const [key] = Object.keys(data);
                if (data[key]?.items) {
                    const flattenedResult = data[key]?.items.map((value)=>(0, $lmrPf.flattenItems)(modelIntrospection, name, value));
                    /**
                     * Check exists since `flattenedResult` could be `null`.
                     * if `flattenedResult` exists, result is an actual record.
                     */ if (flattenedResult) return {
                        data: args?.selectionSet ? flattenedResult : modelInitializer(flattenedResult),
                        nextToken: data[key]?.nextToken,
                        errors: errors
                    };
                }
                // response is of type `data: { listByExampleId: null }`
                return {
                    data: data[key],
                    nextToken: data[key]?.nextToken,
                    errors: errors
                };
            } else // `data` is `null` or an empty object:
            return (0, $kffnY.handleListGraphQlError)(error);
        }
    });
}

});

parcelRegister("bUHRh", function(module, exports) {

$parcel$export(module.exports, "subscriptionFactory", () => $b91ee0b8f805d3bc$export$90a8a93856dc32cc);

var $d4PzE = parcelRequire("d4PzE");

var $lmrPf = parcelRequire("lmrPf");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $b91ee0b8f805d3bc$export$90a8a93856dc32cc(client, modelIntrospection, model, operation, getInternals) {
    const { name: name } = model;
    const subscription = (args)=>{
        const query = (0, $lmrPf.generateGraphQLDocument)(modelIntrospection, model, operation, args);
        const variables = (0, $lmrPf.buildGraphQLVariables)(model, operation, args, modelIntrospection);
        const auth = (0, $lmrPf.authModeParams)(client, getInternals, args);
        const headers = (0, $lmrPf.getCustomHeaders)(client, getInternals, args?.headers);
        const observable = client.graphql({
            ...auth,
            query: query,
            variables: variables
        }, headers);
        return observable.pipe((0, $d4PzE.map)((value)=>{
            const [key] = Object.keys(value.data);
            const data = value.data[key];
            const flattenedResult = (0, $lmrPf.flattenItems)(modelIntrospection, name, data);
            if (flattenedResult === null) return null;
            else if (args?.selectionSet) return flattenedResult;
            else {
                const [initialized] = (0, $lmrPf.initializeModel)(client, name, [
                    flattenedResult
                ], modelIntrospection, auth.authMode, auth.authToken);
                return initialized;
            }
        }));
    };
    return subscription;
}

});

parcelRegister("crKdm", function(module, exports) {

$parcel$export(module.exports, "observeQueryFactory", () => $b34d1af9377c3cc0$export$9cf24fed4882559a);

var $6OiYn = parcelRequire("6OiYn");

var $9dBNH = parcelRequire("9dBNH");

var $687To = parcelRequire("687To");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $b34d1af9377c3cc0$export$9cf24fed4882559a(models, model) {
    const { name: name } = model;
    const observeQuery = (arg)=>new (0, $6OiYn.Observable)((subscriber)=>{
            // what we'll be sending to our subscribers
            const items = [];
            // To enqueue subscription messages while we collect our initial
            // result set.
            const messageQueue = [];
            // operation to take when message(s) arrive.
            // this operation will be swapped out once initial "sync" is complete
            // to immediately ingest messsages.
            let receiveMessages = (...messages)=>{
                return messageQueue.push(...messages);
            };
            // start subscriptions
            const onCreateSub = models[name].onCreate(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "create"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onCreate",
                        error: error
                    });
                }
            });
            const onUpdateSub = models[name].onUpdate(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "update"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onUpdate",
                        error: error
                    });
                }
            });
            const onDeleteSub = models[name].onDelete(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "delete"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onDelete",
                        error: error
                    });
                }
            });
            // consumes a list of messages and sends a snapshot
            function ingestMessages(messages) {
                for (const message of messages){
                    const idx = (0, $687To.findIndexByFields)(message.item, items, pkFields);
                    switch(message.type){
                        case "create":
                            if (idx < 0) items.push(message.item);
                            break;
                        case "update":
                            if (idx >= 0) items[idx] = message.item;
                            break;
                        case "delete":
                            if (idx >= 0) items.splice(idx, 1);
                            break;
                        default:
                            console.error("Unrecognized message in observeQuery.", message);
                    }
                }
                subscriber.next({
                    items: items,
                    isSynced: true
                });
            }
            const pkFields = (0, $9dBNH.resolvePKFields)(model);
            // initial results
            (async ()=>{
                let firstPage = true;
                let nextToken = null;
                while(!subscriber.closed && (firstPage || nextToken)){
                    firstPage = false;
                    const { data: page, errors: errors, nextToken: _nextToken } = await models[name].list({
                        ...arg,
                        nextToken: nextToken
                    });
                    nextToken = _nextToken;
                    items.push(...page);
                    // if there are no more pages and no items we already know about
                    // that need to be merged in from sub, we're "synced"
                    const isSynced = messageQueue.length === 0 && (nextToken === null || nextToken === undefined);
                    subscriber.next({
                        items: items,
                        isSynced: isSynced
                    });
                    if (Array.isArray(errors)) for (const error of errors)subscriber.error(error);
                }
                // play through the queue
                if (messageQueue.length > 0) ingestMessages(messageQueue);
                // switch the queue to write directly to the items collection
                receiveMessages = (...messages)=>{
                    ingestMessages(messages);
                    return items.length;
                };
            })();
            // when subscriber unsubscribes, tear down internal subs
            return ()=>{
                // 1. tear down internal subs
                onCreateSub.unsubscribe();
                onUpdateSub.unsubscribe();
                onDeleteSub.unsubscribe();
            // 2. there is no need to explicitly stop paging. instead, we
            // just check `subscriber.closed` above before fetching each page.
            };
        });
    return observeQuery;
}

});
parcelRegister("6OiYn", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $4f562137a990678a$export$77cea355fa80b5f4);

var $hOMJ7 = parcelRequire("hOMJ7");

var $bgI6x = parcelRequire("bgI6x");

var $kaCww = parcelRequire("kaCww");

var $1itL3 = parcelRequire("1itL3");

var $hmjgn = parcelRequire("hmjgn");

var $gCSeg = parcelRequire("gCSeg");

var $cxQqV = parcelRequire("cxQqV");
var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $hOMJ7.SafeSubscriber)(observerOrNext, error, complete);
        (0, $cxQqV.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $hOMJ7.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $kaCww.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $1itL3.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $hmjgn.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $gCSeg.isFunction)(value.next) && (0, $gCSeg.isFunction)(value.error) && (0, $gCSeg.isFunction)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $hOMJ7.Subscriber) || $4f562137a990678a$var$isObserver(value) && (0, $bgI6x.isSubscription)(value);
}

});
parcelRegister("kaCww", function(module, exports) {

$parcel$export(module.exports, "observable", () => $eaf29fccbded6ed3$export$5ab46cbf6120b33a);
var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("1itL3", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $0f1e8e2d1fe93adf$export$71f88a61afaa14d7);

var $a4Ze1 = parcelRequire("a4Ze1");
function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $a4Ze1.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("a4Ze1", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7569c528cdd9d182$export$f0954fd7d5368655);
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("9dBNH", function(module, exports) {

$parcel$export(module.exports, "resolvePKFields", () => $6ca20b9680a74578$export$b46c507f59d0394c);
/**
 * Given a SchemaModel from a ModelIntrospectionSchema, returns the primary key
 * as an array of field names.
 *
 * @param model The model object
 * @returns Array of field names
 */ function $6ca20b9680a74578$export$b46c507f59d0394c(model) {
    const { primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames } = model.primaryKeyInfo;
    return [
        primaryKeyFieldName,
        ...sortKeyFieldNames
    ];
}

});

parcelRegister("687To", function(module, exports) {

$parcel$export(module.exports, "findIndexByFields", () => $e635ed9f2b2435b2$export$dc565815e1b88e94);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Iterates through a collection to find a matching item and returns the index.
 *
 * @param needle The item to search for
 * @param haystack The collection to search
 * @param keyFields The fields used to indicate a match
 * @returns Index of `needle` in `haystack`, otherwise -1 if not found.
 */ function $e635ed9f2b2435b2$export$dc565815e1b88e94(needle, haystack, keyFields) {
    const searchObject = Object.fromEntries(keyFields.map((fieldName)=>[
            fieldName,
            needle[fieldName]
        ]));
    for(let i = 0; i < haystack.length; i++){
        if (Object.keys(searchObject).every((k)=>searchObject[k] === haystack[i][k])) return i;
    }
    return -1;
}

});


parcelRegister("jWnAM", function(module, exports) {

$parcel$export(module.exports, "getSecondaryIndexesFromSchemaModel", () => $dd4aea0b388c097e$export$f528cf56306669ee);
$parcel$export(module.exports, "excludeDisabledOps", () => $dd4aea0b388c097e$export$e56dc24769cb6554);

var $lmrPf = parcelRequire("lmrPf");
const $dd4aea0b388c097e$var$attributeIsSecondaryIndex = (attr)=>{
    return attr.type === "key" && // presence of `name` property distinguishes GSI from primary index
    attr.properties?.name && attr.properties?.queryField && attr.properties?.fields.length > 0;
};
const $dd4aea0b388c097e$export$f528cf56306669ee = (model)=>{
    const idxs = model.attributes?.filter($dd4aea0b388c097e$var$attributeIsSecondaryIndex).map((attr)=>{
        const queryField = attr.properties.queryField;
        const [pk, ...sk] = attr.properties.fields;
        return {
            queryField: queryField,
            pk: pk,
            sk: sk
        };
    });
    return idxs || [];
};
/**
 * returns graphQLOperationsInfo, but filters out operations that were disabled via model().disableOperations([...])
 */ const $dd4aea0b388c097e$export$e56dc24769cb6554 = (mis, modelName)=>{
    /* Example model attributes in MIS {
      "type": "model",
      "properties": {
        "subscriptions": null,
        "mutations": { "delete": null }
        "timestamps": null
      } }*/ const modelAttrs = mis.models[modelName].attributes?.find((attr)=>attr.type === "model");
    const coarseToFineDict = {
        queries: [
            "list",
            "get",
            "observeQuery"
        ],
        mutations: [
            "create",
            "update",
            "delete"
        ],
        subscriptions: [
            "onCreate",
            "onUpdate",
            "onDelete"
        ]
    };
    const disabledOps = [];
    if (!modelAttrs) return 0, $lmrPf.graphQLOperationsInfo;
    if (modelAttrs.properties) for (const [key, value] of Object.entries(modelAttrs.properties)){
        // model.properties can contain other values that are not relevant to disabling ops, e.g. timestamps
        if (!(key in coarseToFineDict)) continue;
        if (value === null) // coarse-grained disable, e.g. "subscriptions": null,
        disabledOps.push(...coarseToFineDict[key]);
        else if (value instanceof Object) // fine-grained, e.g. "mutations": { "delete": null }
        disabledOps.push(...Object.keys(value));
    }
    // observeQuery only exists on the client side, so can't be explicitly disabled via schema builder.
    // It's unusable without `list`
    if (disabledOps.includes("list")) disabledOps.push("observeQuery");
    // graphQLOperationsInfo keys are in caps
    const disabledOpsUpper = disabledOps.map((op)=>op.toUpperCase());
    const filteredGraphQLOperations = Object.fromEntries(Object.entries((0, $lmrPf.graphQLOperationsInfo)).filter(([key])=>!disabledOpsUpper.includes(key)));
    return filteredGraphQLOperations;
};

});



parcelRegister("kqDuS", function(module, exports) {

var $f10G7 = parcelRequire("f10G7");

var $7uTmY = parcelRequire("7uTmY");

var $4vIv1 = parcelRequire("4vIv1");
parcelRequire("6yFdo");
parcelRequire("sAmZU");


var $4lQbP = parcelRequire("4lQbP");

var $9JSlo = parcelRequire("9JSlo");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: separate import path
function $3102e144215c6794$export$58ca180b08e7a7ba(client, params, getInternals) {
    const apiGraphqlConfig = params.config?.API?.GraphQL;
    if ((0, $f10G7.isApiGraphQLConfig)(apiGraphqlConfig)) {
        (0, $4vIv1.upgradeClientCancellation)(client);
        client.models = (0, $9JSlo.generateModelsProperty)(client, params, getInternals);
        client.enums = (0, $4lQbP.generateEnumsProperty)(apiGraphqlConfig);
        client.queries = (0, $7uTmY.generateCustomQueriesProperty)(client, apiGraphqlConfig, getInternals);
        client.mutations = (0, $7uTmY.generateCustomMutationsProperty)(client, apiGraphqlConfig, getInternals);
    }
    return client;
}

});
parcelRegister("f10G7", function(module, exports) {

$parcel$export(module.exports, "isApiGraphQLConfig", () => $47b9044165809c03$export$4985df5713b1117);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $47b9044165809c03$export$4985df5713b1117(apiGraphQLConfig) {
    return apiGraphQLConfig !== undefined;
}

});

parcelRegister("9JSlo", function(module, exports) {

$parcel$export(module.exports, "generateModelsProperty", () => $d864774eb0ed84f3$export$7aa40502ac76885f);

var $blCgB = parcelRequire("blCgB");

var $9rV2E = parcelRequire("9rV2E");

var $kJQHC = parcelRequire("kJQHC");

var $jWnAM = parcelRequire("jWnAM");
function $d864774eb0ed84f3$export$7aa40502ac76885f(client, params, getInternals) {
    const models = {};
    const { config: config } = params;
    const useContext = params.amplify === null;
    if (!config) throw new Error("generateModelsProperty cannot retrieve Amplify config");
    if (!config.API?.GraphQL) return {};
    const modelIntrospection = config.API.GraphQL.modelIntrospection;
    if (!modelIntrospection) return {};
    const SSR_UNSUPORTED_OPS = [
        "ONCREATE",
        "ONUPDATE",
        "ONDELETE",
        "OBSERVEQUERY"
    ];
    for (const model of Object.values(modelIntrospection.models)){
        const { name: name } = model;
        models[name] = {};
        const enabledModelOps = (0, $jWnAM.excludeDisabledOps)(modelIntrospection, name);
        Object.entries(enabledModelOps).forEach(([key, { operationPrefix: operationPrefix }])=>{
            const operation = key;
            // subscriptions are not supported in SSR
            if (SSR_UNSUPORTED_OPS.includes(operation)) return;
            if (operation === "LIST") models[name][operationPrefix] = (0, $blCgB.listFactory)(client, modelIntrospection, model, getInternals, useContext);
            else models[name][operationPrefix] = (0, $kJQHC.getFactory)(client, modelIntrospection, model, operation, getInternals, useContext);
        });
        const secondaryIdxs = (0, $jWnAM.getSecondaryIndexesFromSchemaModel)(model);
        for (const idx of secondaryIdxs)models[name][idx.queryField] = (0, $9rV2E.indexQueryFactory)(client, modelIntrospection, model, idx, getInternals, useContext);
    }
    return models;
}

});



parcelRegister("lvJDy", function(module, exports) {

$parcel$export(module.exports, "GraphQLAuthError", () => $5d69ad309249365b$export$b77ee9d1a91b5bd);
$parcel$export(module.exports, "__amplify", () => $5d69ad309249365b$export$87dc5468d5b26aba);
$parcel$export(module.exports, "__authMode", () => $5d69ad309249365b$export$593785724ae3fc20);
$parcel$export(module.exports, "__authToken", () => $5d69ad309249365b$export$8a1470dae10dd715);
$parcel$export(module.exports, "__apiKey", () => $5d69ad309249365b$export$ca8d54bd766f9df8);
$parcel$export(module.exports, "__headers", () => $5d69ad309249365b$export$2625404bf7c4f53c);
$parcel$export(module.exports, "__endpoint", () => $5d69ad309249365b$export$6448a6ebc82b3f8a);
$parcel$export(module.exports, "getInternals", () => $5d69ad309249365b$export$a31ef37901f5fd74);

var $5d69ad309249365b$export$b77ee9d1a91b5bd;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})($5d69ad309249365b$export$b77ee9d1a91b5bd || ($5d69ad309249365b$export$b77ee9d1a91b5bd = {}));
const $5d69ad309249365b$export$87dc5468d5b26aba = Symbol("amplify");
const $5d69ad309249365b$export$593785724ae3fc20 = Symbol("authMode");
const $5d69ad309249365b$export$8a1470dae10dd715 = Symbol("authToken");
const $5d69ad309249365b$export$ca8d54bd766f9df8 = Symbol("apiKey");
const $5d69ad309249365b$export$2625404bf7c4f53c = Symbol("headers");
const $5d69ad309249365b$export$6448a6ebc82b3f8a = Symbol("endpoint");
function $5d69ad309249365b$export$a31ef37901f5fd74(client) {
    const c = client;
    return {
        amplify: c[$5d69ad309249365b$export$87dc5468d5b26aba],
        apiKey: c[$5d69ad309249365b$export$ca8d54bd766f9df8],
        authMode: c[$5d69ad309249365b$export$593785724ae3fc20],
        authToken: c[$5d69ad309249365b$export$8a1470dae10dd715],
        endpoint: c[$5d69ad309249365b$export$6448a6ebc82b3f8a],
        headers: c[$5d69ad309249365b$export$2625404bf7c4f53c]
    };
}

});

parcelRegister("4OgCt", function(module, exports) {

$parcel$export(module.exports, "isApiGraphQLConfig", () => $34831e681396c4ee$export$4985df5713b1117);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $34831e681396c4ee$export$4985df5713b1117(apiGraphQLConfig) {
    return apiGraphQLConfig !== undefined;
}

});

parcelRegister("lSN55", function(module, exports) {

$parcel$export(module.exports, "isConfigureEventWithResourceConfig", () => $25f50f184828d0d6$export$ecfa4ec9c8db7a34);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $25f50f184828d0d6$export$ecfa4ec9c8db7a34(payload) {
    return payload.event === "configure";
}

});

parcelRegister("yL58Q", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $df8eeec06c50fd24$export$1eb4e7c0ed67b035);
$parcel$export(module.exports, "cancel", () => $df8eeec06c50fd24$export$70b61ad426ddbe54);
$parcel$export(module.exports, "isCancelError", () => $df8eeec06c50fd24$export$a88a1555052550c7);

var $jmbrF = parcelRequire("jmbrF");

var $lvJDy = parcelRequire("lvJDy");
/**
 * Invokes graphql operations against a graphql service, providing correct input and
 * output types if Amplify-generated graphql from a recent version of the CLI/codegen
 * are used *or* correct typing is provided via the type argument.
 *
 * Amplify-generated "branded" graphql queries will look similar to this:
 *
 * ```ts
 *                               //
 *                               // |-- branding
 *                               // v
 * export const getModel = `...` as GeneratedQuery<
 * 	GetModelQueryVariables,
 * 	GetModelQuery
 * >;
 * ```
 *
 * If this branding is not in your generated graphql, update to a newer version of
 * CLI/codegen and regenerate your graphql using `amplify codegen`.
 *
 * ## Using Amplify-generated graphql
 *
 * ```ts
 * import * as queries from './graphql/queries';
 *
 * //
 * //    |-- correctly typed graphql response containing a Widget
 * //    v
 * const queryResult = await graphql({
 * 	query: queries.getWidget,
 * 	variables: {
 * 		id: "abc", // <-- type hinted/enforced
 * 	},
 * });
 *
 * //
 * //    |-- a correctly typed Widget
 * //    v
 * const fetchedWidget = queryResult.data?.getWidget!;
 * ```
 *
 * ## Custom input + result types
 *
 * To provide input types (`variables`) and result types:
 *
 * ```ts
 * type GetById_NameOnly = {
 * 	variables: {
 * 		id: string
 * 	},
 * 	result: Promise<{
 * 		data: { getWidget: { name: string } }
 * 	}>
 * }
 *
 * //
 * //    |-- type is GetById_NameOnly["result"]
 * //    v
 * const result = graphql<GetById_NameOnly>({
 * 	query: "...",
 * 	variables: { id: "abc" }  // <-- type of GetById_NameOnly["variables"]
 * });
 * ```
 *
 * ## Custom result type only
 *
 * To specify result types only, use a type that is *not* in the `{variables, result}` shape:
 *
 * ```ts
 * type MyResultType = Promise<{
 * 	data: {
 * 		getWidget: { name: string }
 * 	}
 * }>
 *
 * //
 * //    |-- type is MyResultType
 * //    v
 * const result = graphql<MyResultType>({query: "..."});
 * ```
 *
 * @param options
 * @param additionalHeaders
 */ function $df8eeec06c50fd24$export$1eb4e7c0ed67b035(options, additionalHeaders) {
    // inject client-level auth
    const internals = (0, $lvJDy.getInternals)(this);
    /**
     * The custom `endpoint` specific to the client
     */ const clientEndpoint = internals.endpoint;
    /**
     * The `authMode` specific to the client.
     */ const clientAuthMode = internals.authMode;
    /**
     * The `apiKey` specific to the client.
     */ const clientApiKey = internals.apiKey;
    /**
     * The most specific `authMode` wins. Setting an `endpoint` value without also
     * setting an `authMode` value is invalid. This helps to prevent customers apps
     * from unexpectedly sending auth details to endpoints the auth details do not
     * belong to.
     *
     * This is especially pronounced for `apiKey`. When both an `endpoint` *and*
     * `authMode: 'apiKey'` are provided, an explicit `apiKey` override is required
     * to prevent inadvertent sending of an API's `apiKey` to an endpoint is does
     * not belong to.
     */ options.authMode = options.authMode || clientAuthMode;
    options.apiKey = options.apiKey ?? clientApiKey;
    options.authToken = options.authToken || internals.authToken;
    if (clientEndpoint && options.authMode === "apiKey" && !options.apiKey) throw new Error("graphql() requires an explicit `apiKey` for a custom `endpoint` when `authMode = 'apiKey'`.");
    const headers = additionalHeaders || internals.headers;
    /**
     * The correctness of these typings depends on correct string branding or overrides.
     * Neither of these can actually be validated at runtime. Hence, we don't perform
     * any validation or type-guarding here.
     */ const result = (0, $jmbrF.GraphQLAPI).graphql(// TODO: move V6Client back into this package?
    internals.amplify, {
        ...options,
        endpoint: clientEndpoint
    }, headers);
    return result;
}
/**
 * Cancels an inflight request. Only applicable for graphql queries and mutations
 * @param {any} request - request to cancel
 * @returns - A boolean indicating if the request was cancelled
 */ function $df8eeec06c50fd24$export$70b61ad426ddbe54(promise, message) {
    return (0, $jmbrF.GraphQLAPI).cancel(promise, message);
}
/**
 * Checks to see if an error thrown is from an api request cancellation
 * @param {any} error - Any error
 * @returns - A boolean indicating if the error was from an api request cancellation
 */ function $df8eeec06c50fd24$export$a88a1555052550c7(error) {
    return (0, $jmbrF.GraphQLAPI).isCancelError(error);
}

});
parcelRegister("jmbrF", function(module, exports) {

$parcel$export(module.exports, "GraphQLAPI", () => $e0980bc58fdd67fa$export$6572ab1b3fe6697f);

var $k2DuP = parcelRequire("k2DuP");
parcelRequire("T4Q7j");
var $6yFdo = parcelRequire("6yFdo");

var $cGZt7 = parcelRequire("cGZt7");
function $e0980bc58fdd67fa$var$isGraphQLOptionsWithOverride(options) {
    return (0, $6yFdo.INTERNAL_USER_AGENT_OVERRIDE) in options;
}
const $e0980bc58fdd67fa$export$78930a3b816845f9 = (query, variables = {}, authToken)=>({
        query: query,
        variables: variables,
        authToken: authToken
    });
/**
 * Export Cloud Logic APIs
 */ class $e0980bc58fdd67fa$export$e32503f9802a56ee extends (0, $cGZt7.InternalGraphQLAPIClass) {
    getModuleName() {
        return "GraphQLAPI";
    }
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ graphql(amplify, options, additionalHeaders) {
        const userAgentDetails = {
            category: (0, $k2DuP.Category).API,
            action: (0, $k2DuP.ApiAction).GraphQl
        };
        if ($e0980bc58fdd67fa$var$isGraphQLOptionsWithOverride(options)) {
            const { [(0, $6yFdo.INTERNAL_USER_AGENT_OVERRIDE)]: internalUserAgentOverride, ...cleanOptions } = options;
            return super.graphql(amplify, cleanOptions, additionalHeaders, {
                ...userAgentDetails,
                ...internalUserAgentOverride
            });
        }
        return super.graphql(amplify, options, additionalHeaders, {
            ...userAgentDetails
        });
    }
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @returns A boolean indicating if the error was from an api request cancellation
     */ isCancelError(error) {
        return super.isCancelError(error);
    }
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @returns A boolean indicating if the request was cancelled
     */ cancel(request, message) {
        return super.cancel(request, message);
    }
}
const $e0980bc58fdd67fa$export$6572ab1b3fe6697f = new $e0980bc58fdd67fa$export$e32503f9802a56ee();

});
parcelRegister("cGZt7", function(module, exports) {

$parcel$export(module.exports, "InternalGraphQLAPIClass", () => $417d5886f54fa8b9$export$c3e852ee609522ad);

var $8DJ2k = parcelRequire("8DJ2k");
var $3o9dz = parcelRequire("3o9dz");

var $fT695 = parcelRequire("fT695");

var $7Ar4G = parcelRequire("7Ar4G");
var $dj9FS = parcelRequire("dj9FS");
parcelRequire("LTBY8");
var $3Qiot = parcelRequire("3Qiot");
parcelRequire("dOmJe");
var $cfOsN = parcelRequire("cfOsN");

var $99ZQ7 = parcelRequire("99ZQ7");

var $4un4F = parcelRequire("4un4F");

var $2bSZt = parcelRequire("2bSZt");

var $027iw = parcelRequire("027iw");

var $d4tMy = parcelRequire("d4tMy");

var $aPZn6 = parcelRequire("aPZn6");


var $28CpK = parcelRequire("28CpK");

var $4eb9l = parcelRequire("4eb9l");

var $37s7d = parcelRequire("37s7d");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $417d5886f54fa8b9$var$USER_AGENT_HEADER = "x-amz-user-agent";
const $417d5886f54fa8b9$var$isAmplifyInstance = (amplify)=>{
    return typeof amplify !== "function";
};
/**
 * Export Cloud Logic APIs
 */ class $417d5886f54fa8b9$export$c3e852ee609522ad {
    constructor(){
        /**
         * @private
         */ this.appSyncRealTime = new Map();
        this._api = {
            post: $cfOsN.post,
            cancelREST: (0, $cfOsN.cancel),
            isCancelErrorREST: (0, $3Qiot.isCancelError),
            updateRequestToBeCancellable: $cfOsN.updateRequestToBeCancellable
        };
    }
    getModuleName() {
        return "InternalGraphQLAPI";
    }
    /**
     * to get the operation type
     * @param operation
     */ getGraphqlOperationType(operation) {
        const doc = (0, $8DJ2k.parse)(operation);
        const definitions = doc.definitions;
        const [{ operation: operationType }] = definitions;
        return operationType;
    }
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ graphql(amplify, { query: paramQuery, variables: variables = {}, authMode: authMode, authToken: authToken, endpoint: endpoint, apiKey: apiKey }, additionalHeaders, customUserAgentDetails) {
        const query = typeof paramQuery === "string" ? (0, $8DJ2k.parse)(paramQuery) : (0, $8DJ2k.parse)((0, $3o9dz.print)(paramQuery));
        const [operationDef = {}] = query.definitions.filter((def)=>def.kind === "OperationDefinition");
        const { operation: operationType } = operationDef;
        const headers = additionalHeaders || {};
        switch(operationType){
            case "query":
            case "mutation":
                {
                    const abortController = new AbortController();
                    let responsePromise;
                    if ($417d5886f54fa8b9$var$isAmplifyInstance(amplify)) responsePromise = this._graphql(amplify, {
                        query: query,
                        variables: variables,
                        authMode: authMode,
                        apiKey: apiKey,
                        endpoint: endpoint
                    }, headers, abortController, customUserAgentDetails, authToken);
                    else {
                        // NOTE: this wrapper function must be await-able so the Amplify server context manager can
                        // destroy the context only after it completes
                        const wrapper = async (amplifyInstance)=>{
                            const result = await this._graphql(amplifyInstance, {
                                query: query,
                                variables: variables,
                                authMode: authMode,
                                apiKey: apiKey,
                                endpoint: endpoint
                            }, headers, abortController, customUserAgentDetails, authToken);
                            return result;
                        };
                        responsePromise = amplify(wrapper);
                    }
                    this._api.updateRequestToBeCancellable(responsePromise, abortController);
                    return responsePromise;
                }
            case "subscription":
                return this._graphqlSubscribe(amplify, {
                    query: query,
                    variables: variables,
                    authMode: authMode,
                    apiKey: apiKey,
                    endpoint: endpoint
                }, headers, customUserAgentDetails, authToken);
            default:
                throw new Error(`invalid operation type: ${operationType}`);
        }
    }
    async _graphql(amplify, { query: query, variables: variables, authMode: authModeOverride, endpoint: endpointOverride, apiKey: apiKeyOverride }, additionalHeaders = {}, abortController, customUserAgentDetails, authToken) {
        const { apiKey: apiKey, region: region, endpoint: appSyncGraphqlEndpoint, customEndpoint: customEndpoint, customEndpointRegion: customEndpointRegion, defaultAuthMode: defaultAuthMode } = (0, $4un4F.resolveConfig)(amplify);
        const initialAuthMode = authModeOverride || defaultAuthMode || "iam";
        // identityPool is an alias for iam. TODO: remove 'iam' in v7
        const authMode = initialAuthMode === "identityPool" ? "iam" : initialAuthMode;
        /**
         * Retrieve library options from Amplify configuration.
         * `customHeaders` here are from the Amplify configuration options,
         * and are for non-AppSync endpoints only. These are *not* the same as
         * `additionalHeaders`, which are custom headers that are either 1)
         * included when configuring the API client or 2) passed along with
         * individual requests.
         */ const { headers: customHeaders, withCredentials: withCredentials } = (0, $2bSZt.resolveLibraryOptions)(amplify);
        /**
         * Client or request-specific custom headers that may or may not be
         * returned by a function:
         */ let additionalCustomHeaders;
        if (typeof additionalHeaders === "function") {
            const requestOptions = {
                method: "POST",
                url: new (0, $7Ar4G.AmplifyUrl)(endpointOverride || customEndpoint || appSyncGraphqlEndpoint || "").toString(),
                queryString: (0, $3o9dz.print)(query)
            };
            additionalCustomHeaders = await additionalHeaders(requestOptions);
        } else additionalCustomHeaders = additionalHeaders;
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) additionalCustomHeaders = {
            ...additionalCustomHeaders,
            Authorization: authToken
        };
        const authHeaders = await (0, $37s7d.headerBasedAuth)(amplify, authMode, apiKeyOverride ?? apiKey, additionalCustomHeaders);
        const headers = {
            ...!customEndpoint && authHeaders,
            /**
             * Custom endpoint headers.
             * If there is both a custom endpoint and custom region present, we get the headers.
             * If there is a custom endpoint but no region, we return an empty object.
             * If neither are present, we return an empty object.
             */ ...customEndpoint && (customEndpointRegion ? authHeaders : {}) || {},
            // Custom headers included in Amplify configuration options:
            ...customHeaders && await customHeaders({
                query: (0, $3o9dz.print)(query),
                variables: variables
            }),
            // Custom headers from individual requests or API client configuration:
            ...additionalCustomHeaders,
            // User agent headers:
            ...!customEndpoint && {
                [$417d5886f54fa8b9$var$USER_AGENT_HEADER]: (0, $dj9FS.getAmplifyUserAgent)(customUserAgentDetails)
            }
        };
        const body = {
            query: (0, $3o9dz.print)(query),
            variables: variables || null
        };
        let signingServiceInfo;
        /**
         * We do not send the signing service info to the REST API under the
         * following conditions (i.e. it will not sign the request):
         *   - there is a custom endpoint but no region
         *   - the auth mode is `none`, or `apiKey`
         *   - the auth mode is a type other than the types listed below
         */ if (customEndpoint && !customEndpointRegion || authMode !== "oidc" && authMode !== "userPool" && authMode !== "iam" && authMode !== "lambda") signingServiceInfo = undefined;
        else signingServiceInfo = {
            service: !customEndpointRegion ? "appsync" : "execute-api",
            region: !customEndpointRegion ? region : customEndpointRegion
        };
        const endpoint = endpointOverride || customEndpoint || appSyncGraphqlEndpoint;
        if (!endpoint) throw (0, $28CpK.createGraphQLResultWithError)(new (0, $aPZn6.GraphQLApiError)((0, $d4tMy.NO_ENDPOINT)));
        let response;
        try {
            // 	// // See the inline doc of the REST `post()` API for possible errors to be thrown.
            // 	// // As these errors are catastrophic they should be caught and handled by GraphQL
            // 	// // API consumers.
            const { body: responseBody } = await this._api.post(amplify, {
                url: new (0, $7Ar4G.AmplifyUrl)(endpoint),
                options: {
                    headers: headers,
                    body: body,
                    signingServiceInfo: signingServiceInfo,
                    withCredentials: withCredentials
                },
                abortController: abortController
            });
            response = await responseBody.json();
        } catch (error) {
            if (this.isCancelError(error)) throw error;
            response = (0, $28CpK.createGraphQLResultWithError)(error);
        }
        if ((0, $4eb9l.isGraphQLResponseWithErrors)(response)) throw (0, $027iw.repackageUnauthorizedError)(response);
        return response;
    }
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ isCancelError(error) {
        return this._api.isCancelErrorREST(error);
    }
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @returns - A boolean indicating if the request was cancelled
     */ cancel(request, message) {
        return this._api.cancelREST(request, message);
    }
    _graphqlSubscribe(amplify, { query: query, variables: variables, authMode: authModeOverride, apiKey: apiKeyOverride, endpoint: endpoint }, additionalHeaders = {}, customUserAgentDetails, authToken) {
        const config = (0, $4un4F.resolveConfig)(amplify);
        const initialAuthMode = authModeOverride || config?.defaultAuthMode || "iam";
        // identityPool is an alias for iam. TODO: remove 'iam' in v7
        const authMode = initialAuthMode === "identityPool" ? "iam" : initialAuthMode;
        /**
         * Retrieve library options from Amplify configuration.
         * `libraryConfigHeaders` are from the Amplify configuration options,
         * and will not be overwritten by other custom headers. These are *not*
         * the same as `additionalHeaders`, which are custom headers that are
         * either 1)included when configuring the API client or 2) passed along
         * with individual requests.
         */ const { headers: libraryConfigHeaders } = (0, $2bSZt.resolveLibraryOptions)(amplify);
        const appSyncGraphqlEndpoint = endpoint ?? config?.endpoint;
        // TODO: This could probably be an exception. But, lots of tests rely on
        // attempting to connect to nowhere. So, I'm treating as the opposite of
        // a Chesterton's fence for now. (A fence I shouldn't build, because I don't
        // know why somethings depends on its absence!)
        const memoKey = appSyncGraphqlEndpoint ?? "none";
        const realtimeProvider = this.appSyncRealTime.get(memoKey) ?? new (0, $99ZQ7.AWSAppSyncRealTimeProvider)();
        this.appSyncRealTime.set(memoKey, realtimeProvider);
        return realtimeProvider.subscribe({
            query: (0, $3o9dz.print)(query),
            variables: variables,
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            region: config?.region,
            authenticationType: authMode,
            apiKey: apiKeyOverride ?? config?.apiKey,
            additionalHeaders: additionalHeaders,
            authToken: authToken,
            libraryConfigHeaders: libraryConfigHeaders
        }, customUserAgentDetails).pipe((0, $fT695.catchError)((e)=>{
            if (e.errors) throw (0, $027iw.repackageUnauthorizedError)(e);
            throw e;
        }));
    }
}
const $417d5886f54fa8b9$export$ed344e8d198d4142 = new $417d5886f54fa8b9$export$c3e852ee609522ad();

});
parcelRegister("8DJ2k", function(module, exports) {

$parcel$export(module.exports, "parse", () => $0013c7ab45cf197d$export$98e6a39c04603d36);

var $egTVJ = parcelRequire("egTVJ");

var $hu3w4 = parcelRequire("hu3w4");

var $8r1qs = parcelRequire("8r1qs");

var $bQgNI = parcelRequire("bQgNI");

var $1i7FZ = parcelRequire("1i7FZ");

var $5zW8K = parcelRequire("5zW8K");

var $dtMcr = parcelRequire("dtMcr");
function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return type;
}
var $0013c7ab45cf197d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $1i7FZ.isSource)(source) ? source : new (0, $1i7FZ.Source)(source);
        this._lexer = new (0, $dtMcr.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $bQgNI.TokenKind).NAME);
        return {
            kind: (0, $hu3w4.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).DOCUMENT,
            definitions: this.many((0, $bQgNI.TokenKind).SOF, this.parseDefinition, (0, $bQgNI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $bQgNI.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $bQgNI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $bQgNI.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $bQgNI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).DOLLAR);
        return {
            kind: (0, $hu3w4.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).SELECTION_SET,
            selections: this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseSelection, (0, $bQgNI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $bQgNI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $hu3w4.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $bQgNI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, item, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return {
            kind: (0, $hu3w4.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $bQgNI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $bQgNI.TokenKind).NAME)) return {
            kind: (0, $hu3w4.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $hu3w4.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $bQgNI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $bQgNI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $bQgNI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $hu3w4.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $bQgNI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $hu3w4.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $bQgNI.TokenKind).STRING:
            case (0, $bQgNI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $bQgNI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, $hu3w4.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $hu3w4.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $bQgNI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $hu3w4.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $bQgNI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $hu3w4.Kind).LIST,
            values: this.any((0, $bQgNI.TokenKind).BRACKET_L, item, (0, $bQgNI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $hu3w4.Kind).OBJECT,
            fields: this.any((0, $bQgNI.TokenKind).BRACE_L, item, (0, $bQgNI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return {
            kind: (0, $hu3w4.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $bQgNI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).AT);
        return {
            kind: (0, $hu3w4.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $bQgNI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $hu3w4.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BANG)) return {
            kind: (0, $hu3w4.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $bQgNI.TokenKind).STRING) || this.peek((0, $bQgNI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        return {
            kind: (0, $hu3w4.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $hu3w4.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $bQgNI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $bQgNI.TokenKind).AMP) || this.peek((0, $bQgNI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $bQgNI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $bQgNI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $bQgNI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $hu3w4.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $bQgNI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $hu3w4.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5zW8K.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $8r1qs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, "Expected ".concat($0013c7ab45cf197d$var$getTokenKindDesc(kind), ", found ").concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $egTVJ.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    var value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $dtMcr.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

});
parcelRegister("egTVJ", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $ddf6b9f696b0d6b2$export$bbee0c6176c019d4);

var $fHcz3 = parcelRequire("fHcz3");
function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $fHcz3.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("fHcz3", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $52f13d37c0305dc6$export$92d6ed0888e7cb7f);

var $cryJ5 = parcelRequire("cryJ5");

var $6Kxrr = parcelRequire("6Kxrr");

var $8hTIi = parcelRequire("8hTIi");

var $2snEf = parcelRequire("2snEf");
function $52f13d37c0305dc6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52f13d37c0305dc6$var$_typeof(obj);
}
function $52f13d37c0305dc6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52f13d37c0305dc6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $52f13d37c0305dc6$var$ownKeys(Object(source), true).forEach(function(key) {
            $52f13d37c0305dc6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $52f13d37c0305dc6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52f13d37c0305dc6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $52f13d37c0305dc6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52f13d37c0305dc6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52f13d37c0305dc6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52f13d37c0305dc6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52f13d37c0305dc6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52f13d37c0305dc6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52f13d37c0305dc6$var$_setPrototypeOf(subClass, superClass);
}
function $52f13d37c0305dc6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52f13d37c0305dc6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52f13d37c0305dc6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52f13d37c0305dc6$var$_possibleConstructorReturn(this, result);
    };
}
function $52f13d37c0305dc6$var$_possibleConstructorReturn(self, call) {
    if (call && ($52f13d37c0305dc6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $52f13d37c0305dc6$var$_assertThisInitialized(self);
}
function $52f13d37c0305dc6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52f13d37c0305dc6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $52f13d37c0305dc6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$52f13d37c0305dc6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $52f13d37c0305dc6$var$_construct(Class, arguments, $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $52f13d37c0305dc6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $52f13d37c0305dc6$var$_wrapNativeSuper(Class);
}
function $52f13d37c0305dc6$var$_construct(Parent, args, Class) {
    if ($52f13d37c0305dc6$var$_isNativeReflectConstruct()) $52f13d37c0305dc6$var$_construct = Reflect.construct;
    else $52f13d37c0305dc6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $52f13d37c0305dc6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $52f13d37c0305dc6$var$_construct.apply(null, arguments);
}
function $52f13d37c0305dc6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52f13d37c0305dc6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $52f13d37c0305dc6$var$_setPrototypeOf(o, p) {
    $52f13d37c0305dc6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52f13d37c0305dc6$var$_setPrototypeOf(o, p);
}
function $52f13d37c0305dc6$var$_getPrototypeOf(o) {
    $52f13d37c0305dc6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52f13d37c0305dc6$var$_getPrototypeOf(o);
}
var $52f13d37c0305dc6$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $52f13d37c0305dc6$var$_inherits(GraphQLError, _Error);
    var _super = $52f13d37c0305dc6$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $52f13d37c0305dc6$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $8hTIi.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $8hTIi.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cryJ5.default)(originalExtensions)) _this.extensions = $52f13d37c0305dc6$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($52f13d37c0305dc6$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $52f13d37c0305dc6$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($52f13d37c0305dc6$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $52f13d37c0305dc6$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $52f13d37c0305dc6$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6Kxrr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $52f13d37c0305dc6$var$_wrapNativeSuper(Error));
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, $2snEf.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, $2snEf.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("cryJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f419306d4be7fb23$export$2e2bcd8739ae039);
function $f419306d4be7fb23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f419306d4be7fb23$var$_typeof(obj);
}
function $f419306d4be7fb23$export$2e2bcd8739ae039(value) {
    return $f419306d4be7fb23$var$_typeof(value) == "object" && value !== null;
}

});

parcelRegister("6Kxrr", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $38898675a98013dc$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$f6cdee3c26d6da57 = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $38898675a98013dc$export$8d0083df0471478e = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$5deadc579ccc7c9c = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

});

parcelRegister("8hTIi", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $151337c9f32f7005$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("2snEf", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $a45c53fbf464b798$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $a45c53fbf464b798$export$867940333fd9f869);

var $8hTIi = parcelRequire("8hTIi");
function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $8hTIi.getLocation)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $a45c53fbf464b798$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                $a45c53fbf464b798$var$whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $a45c53fbf464b798$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $a45c53fbf464b798$var$leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $a45c53fbf464b798$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $a45c53fbf464b798$var$leftPad(len, str) {
    return $a45c53fbf464b798$var$whitespace(len - str.length) + str;
}

});



parcelRegister("hu3w4", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $b7b8db97a7d116fe$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("8r1qs", function(module, exports) {

$parcel$export(module.exports, "Location", () => $11b06753ce50693f$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $11b06753ce50693f$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $11b06753ce50693f$export$8ee0fc9ee280b4ee);

var $hnUO7 = parcelRequire("hnUO7");
var $11b06753ce50693f$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $hnUO7.default)($11b06753ce50693f$export$18a2be9195644f38);
var $11b06753ce50693f$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $hnUO7.default)($11b06753ce50693f$export$50792b0e93539fde);
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("hnUO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a8edb1a7f74fed$export$2e2bcd8739ae039);

var $l3zHt = parcelRequire("l3zHt");

var $7qP7Z = parcelRequire("7qP7Z");
function $79a8edb1a7f74fed$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $l3zHt.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7qP7Z.default) classObject.prototype[0, $7qP7Z.default] = fn;
}

});
parcelRegister("l3zHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0989dd6156f69013$export$2e2bcd8739ae039);
function $0989dd6156f69013$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});

parcelRegister("7qP7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a3e222a9fb30c4$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $d7a3e222a9fb30c4$export$2e2bcd8739ae039 = $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol;

});



parcelRegister("bQgNI", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $ac240aaa94caf15d$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("1i7FZ", function(module, exports) {

$parcel$export(module.exports, "Source", () => $1ff584847d3a412c$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $1ff584847d3a412c$export$75135ee9ed6e435b);

var $6Kxrr = parcelRequire("6Kxrr");

var $gHwk7 = parcelRequire("gHwk7");

var $lDltR = parcelRequire("lDltR");

var $7NKAi = parcelRequire("7NKAi");
function $1ff584847d3a412c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1ff584847d3a412c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1ff584847d3a412c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1ff584847d3a412c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1ff584847d3a412c$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, $lDltR.default)(0, "Body must be a string. Received: ".concat((0, $gHwk7.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $lDltR.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $lDltR.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $1ff584847d3a412c$var$_createClass(Source, [
        {
            key: (0, $6Kxrr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $7NKAi.default)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}

});
parcelRegister("gHwk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9541a54af6a37409$export$2e2bcd8739ae039);

var $7qP7Z = parcelRequire("7qP7Z");
function $9541a54af6a37409$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9541a54af6a37409$var$_typeof(obj);
}
var $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
var $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$2e2bcd8739ae039(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch($9541a54af6a37409$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $9541a54af6a37409$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $9541a54af6a37409$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[" + $9541a54af6a37409$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $9541a54af6a37409$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $9541a54af6a37409$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7qP7Z.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $9541a54af6a37409$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("lDltR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8beb5260c793fc92$export$2e2bcd8739ae039);
function $8beb5260c793fc92$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("7NKAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44107310810d751$export$2e2bcd8739ae039);

function $c44107310810d751$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c44107310810d751$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c44107310810d751$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c44107310810d751$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$c44107310810d751$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5zW8K", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $289bf729a82494c6$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("dtMcr", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $971bc50063303b32$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $971bc50063303b32$export$59ac0f4da287406a);

var $egTVJ = parcelRequire("egTVJ");

var $8r1qs = parcelRequire("8r1qs");

var $bQgNI = parcelRequire("bQgNI");

var $7tbLu = parcelRequire("7tbLu");
var $971bc50063303b32$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $bQgNI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $971bc50063303b32$var$readToken(this, token);
        }while (token.kind === (0, $bQgNI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $bQgNI.TokenKind).BANG || kind === (0, $bQgNI.TokenKind).DOLLAR || kind === (0, $bQgNI.TokenKind).AMP || kind === (0, $bQgNI.TokenKind).PAREN_L || kind === (0, $bQgNI.TokenKind).PAREN_R || kind === (0, $bQgNI.TokenKind).SPREAD || kind === (0, $bQgNI.TokenKind).COLON || kind === (0, $bQgNI.TokenKind).EQUALS || kind === (0, $bQgNI.TokenKind).AT || kind === (0, $bQgNI.TokenKind).BRACKET_L || kind === (0, $bQgNI.TokenKind).BRACKET_R || kind === (0, $bQgNI.TokenKind).BRACE_L || kind === (0, $bQgNI.TokenKind).PIPE || kind === (0, $bQgNI.TokenKind).BRACE_R;
}
function $971bc50063303b32$var$printCharCode(code) {
    return isNaN(code) ? (0, $bQgNI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $971bc50063303b32$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $971bc50063303b32$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $971bc50063303b32$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $971bc50063303b32$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $971bc50063303b32$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $egTVJ.syntaxError)(source, pos, $971bc50063303b32$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $971bc50063303b32$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($971bc50063303b32$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($971bc50063303b32$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $971bc50063303b32$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $971bc50063303b32$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    } else {
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $971bc50063303b32$var$isNameStart(code)) throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    return new (0, $8r1qs.Token)(isFloat ? (0, $bQgNI.TokenKind).FLOAT : (0, $bQgNI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $971bc50063303b32$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $971bc50063303b32$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $egTVJ.syntaxError)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $971bc50063303b32$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $egTVJ.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $egTVJ.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $971bc50063303b32$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $7tbLu.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $egTVJ.syntaxError)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $971bc50063303b32$var$uniCharCode(a, b, c, d) {
    return $971bc50063303b32$var$char2hex(a) << 12 | $971bc50063303b32$var$char2hex(b) << 8 | $971bc50063303b32$var$char2hex(c) << 4 | $971bc50063303b32$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $971bc50063303b32$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $971bc50063303b32$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $971bc50063303b32$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("7tbLu", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $a51b3e37e1f6e888$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $a51b3e37e1f6e888$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a51b3e37e1f6e888$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $a51b3e37e1f6e888$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $a51b3e37e1f6e888$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $a51b3e37e1f6e888$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function $a51b3e37e1f6e888$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function $a51b3e37e1f6e888$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});



parcelRegister("3o9dz", function(module, exports) {

$parcel$export(module.exports, "print", () => $e6602c9cee6df4a2$export$c2d084dc44961371);

var $9m7aI = parcelRequire("9m7aI");

var $7tbLu = parcelRequire("7tbLu");
function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $9m7aI.visit)(ast, {
        leave: $e6602c9cee6df4a2$var$printDocASTReducer
    });
}
var $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $e6602c9cee6df4a2$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(node.variableDefinitions, ", "), ")");
        var directives = $e6602c9cee6df4a2$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $e6602c9cee6df4a2$var$join([
            op,
            $e6602c9cee6df4a2$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $e6602c9cee6df4a2$var$wrap(" = ", defaultValue) + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $e6602c9cee6df4a2$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $e6602c9cee6df4a2$var$wrap("", alias, ": ") + name;
        var argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
        if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)");
        return $e6602c9cee6df4a2$var$join([
            argsLine,
            $e6602c9cee6df4a2$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $e6602c9cee6df4a2$var$join([
            "...",
            $e6602c9cee6df4a2$var$wrap("on ", typeCondition),
            $e6602c9cee6df4a2$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($e6602c9cee6df4a2$var$wrap("", $e6602c9cee6df4a2$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $7tbLu.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $e6602c9cee6df4a2$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $e6602c9cee6df4a2$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $e6602c9cee6df4a2$var$join([
            "schema",
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $e6602c9cee6df4a2$var$join([
            "scalar",
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $e6602c9cee6df4a2$var$join([
            "type",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + ": " + type + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    }),
    InputValueDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $e6602c9cee6df4a2$var$join([
            name + ": " + type,
            $e6602c9cee6df4a2$var$wrap("= ", defaultValue),
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $e6602c9cee6df4a2$var$join([
            "interface",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $e6602c9cee6df4a2$var$join([
            "union",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $e6602c9cee6df4a2$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $e6602c9cee6df4a2$var$join([
            "enum",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $e6602c9cee6df4a2$var$join([
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $e6602c9cee6df4a2$var$join([
            "input",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e6602c9cee6df4a2$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $e6602c9cee6df4a2$var$join([
            "extend schema",
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $e6602c9cee6df4a2$var$join([
            "extend scalar",
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend type",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend interface",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $e6602c9cee6df4a2$var$join([
            "extend union",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $e6602c9cee6df4a2$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $e6602c9cee6df4a2$var$join([
            "extend enum",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend input",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }
};
function $e6602c9cee6df4a2$var$addDescription(cb) {
    return function(node) {
        return $e6602c9cee6df4a2$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap("{\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e6602c9cee6df4a2$var$isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($e6602c9cee6df4a2$var$isMultiline);
}

});
parcelRegister("9m7aI", function(module, exports) {

$parcel$export(module.exports, "visit", () => $78b48476e314521e$export$bf638b60ea8b89b7);

var $gHwk7 = parcelRequire("gHwk7");

var $8r1qs = parcelRequire("8r1qs");
var $78b48476e314521e$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $78b48476e314521e$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $8r1qs.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $gHwk7.default)(node), "."));
            var visitFn = $78b48476e314521e$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $8r1qs.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $78b48476e314521e$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $78b48476e314521e$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRegister("fT695", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $b910c27483c6e6a0$export$3dede90624df3ba9);

var $2ypWW = parcelRequire("2ypWW");

var $4QgEI = parcelRequire("4QgEI");

var $d9kQQ = parcelRequire("d9kQQ");
function $b910c27483c6e6a0$export$3dede90624df3ba9(selector) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $2ypWW.innerFrom)(selector(err, $b910c27483c6e6a0$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

});
parcelRegister("2ypWW", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910);

var $7WQrb = parcelRequire("7WQrb");

var $bGCU7 = parcelRequire("bGCU7");

var $dy1jD = parcelRequire("dy1jD");

var $6OiYn = parcelRequire("6OiYn");

var $rOw2q = parcelRequire("rOw2q");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $fQMll = parcelRequire("fQMll");

var $7gZl2 = parcelRequire("7gZl2");

var $gCSeg = parcelRequire("gCSeg");

var $28DKm = parcelRequire("28DKm");

var $kaCww = parcelRequire("kaCww");
function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $6OiYn.Observable)) return input;
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $bGCU7.isArrayLike)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $dy1jD.isPromise)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $aGtFl.isAsyncIterable)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $fQMll.isIterable)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var obs = obj[0, $kaCww.observable]();
        if ((0, $gCSeg.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $28DKm.reportUnhandledError));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $7WQrb.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $7gZl2.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $7WQrb.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("bGCU7", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $8821cb8787de9fb5$export$1e2f57719e155213);
var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("dy1jD", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $9dcf7896928e75dd$export$4369c812aac99591);

var $gCSeg = parcelRequire("gCSeg");
function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $gCSeg.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("rOw2q", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $0539b51af1903d0a$export$48c0cddbc99c45c2);

var $kaCww = parcelRequire("kaCww");

var $gCSeg = parcelRequire("gCSeg");
function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $gCSeg.isFunction)(input[0, $kaCww.observable]);
}

});

parcelRegister("aGtFl", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $7c74d6a5e2273447$export$edb10ab8dd75a915);

var $gCSeg = parcelRequire("gCSeg");
function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("iolDb", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $d63b3f5b704e6de4$export$7cbe71b9fa263484);
function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("fQMll", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $b8a13650b96f19ab$export$9652023d9040757);

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");
function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $gCSeg.isFunction)(input === null || input === void 0 ? void 0 : input[0, $ZpNjd.iterator]);
}

});
parcelRegister("ZpNjd", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d);
function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();

});


parcelRegister("7gZl2", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $54b99b9095e84ce4$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $54b99b9095e84ce4$export$c088ffafdba7405f);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");
function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $7WQrb.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $7WQrb.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $7WQrb.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $7WQrb.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});



parcelRegister("LTBY8", function(module, exports) {

$parcel$export(module.exports, "isCancelError", () => (parcelRequire("3Qiot")).isCancelError);

var $3Qiot = parcelRequire("3Qiot");

var $4gdZ0 = parcelRequire("4gdZ0");

});
parcelRegister("3Qiot", function(module, exports) {

$parcel$export(module.exports, "CanceledError", () => $afc3a2575e3b5a06$export$1ab0c6b20d94fa14);
$parcel$export(module.exports, "isCancelError", () => $afc3a2575e3b5a06$export$a88a1555052550c7);

var $elLC1 = parcelRequire("elLC1");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Internal-only class for CanceledError.
 *
 * @internal
 */ class $afc3a2575e3b5a06$export$1ab0c6b20d94fa14 extends (0, $elLC1.RestApiError) {
    constructor(params = {}){
        super({
            name: "CanceledError",
            message: "Request is canceled by user",
            ...params
        });
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $afc3a2575e3b5a06$export$1ab0c6b20d94fa14;
        Object.setPrototypeOf(this, $afc3a2575e3b5a06$export$1ab0c6b20d94fa14.prototype);
    }
}
/**
 * Check if an error is caused by user calling `cancel()` in REST API.
 *
 * @note This function works **ONLY** for errors thrown by REST API. For GraphQL APIs, use `client.isCancelError(error)`
 *   instead. `client` is generated from  `generateClient()` API from `aws-amplify/api`.
 *
 * @param {unknown} error The unknown exception to be checked.
 * @returns - A boolean indicating if the error was from an upload cancellation
 */ const $afc3a2575e3b5a06$export$a88a1555052550c7 = (error)=>!!error && error instanceof $afc3a2575e3b5a06$export$1ab0c6b20d94fa14;

});
parcelRegister("elLC1", function(module, exports) {

$parcel$export(module.exports, "RestApiError", () => $0c25662755c5b83d$export$18e4f8e37ec3871f);

var $N4Cyz = parcelRequire("N4Cyz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $0c25662755c5b83d$export$18e4f8e37ec3871f extends (0, $N4Cyz.ApiError) {
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0c25662755c5b83d$export$18e4f8e37ec3871f;
        Object.setPrototypeOf(this, $0c25662755c5b83d$export$18e4f8e37ec3871f.prototype);
    }
}

});
parcelRegister("N4Cyz", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $886306d2222aa47d$export$f2e832acab1bdd79);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Error class for errors that associated with unsuccessful HTTP responses.
 * It's throw by API category REST API handlers and GraphQL query handlers for now.
 */ class $886306d2222aa47d$export$f2e832acab1bdd79 extends (0, $e0exy.AmplifyError) {
    /**
     * The unwrapped HTTP response causing the given API error.
     */ get response() {
        return this._response ? $886306d2222aa47d$var$replicateApiErrorResponse(this._response) : undefined;
    }
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $886306d2222aa47d$export$f2e832acab1bdd79;
        Object.setPrototypeOf(this, $886306d2222aa47d$export$f2e832acab1bdd79.prototype);
        if (params.response) this._response = params.response;
    }
}
const $886306d2222aa47d$var$replicateApiErrorResponse = (response)=>({
        ...response,
        headers: {
            ...response.headers
        }
    });

});



parcelRegister("4gdZ0", function(module, exports) {

var $1qbEC = parcelRequire("1qbEC");

var $g5tdz = parcelRequire("g5tdz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * GET HTTP request
 * @param {GetInput} input - Input for GET operation
 * @returns {GetOperation} Operation for GET request
 * @throws - {@link RestApiError}
 * @example
 * Send a GET request
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await get({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a GET request
 *
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = get({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$3988ae62b71be9a3 = (input)=>(0, $g5tdz.get)((0, $1qbEC.Amplify), input);
/**
 * POST HTTP request
 * @param {PostInput} input - Input for POST operation
 * @returns {PostOperation} Operation for POST request
 * @throws - {@link RestApiError}
 * @example
 * Send a POST request
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await post({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a POST request
 *
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = post({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$299ba2dee77727e9 = (input)=>(0, $g5tdz.post)((0, $1qbEC.Amplify), input);
/**
 * PUT HTTP request
 * @param {PutInput} input - Input for PUT operation
 * @returns {PutOperation} Operation for PUT request
 * @throws - {@link RestApiError}
 * @example
 * Send a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await put({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = put({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *     // handle request cancellation
 *   }
 * //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$327f7b26ebf455db = (input)=>(0, $g5tdz.put)((0, $1qbEC.Amplify), input);
/**
 * DELETE HTTP request
 * @param {DeleteInput} input - Input for DELETE operation
 * @returns {DeleteOperation} Operation for DELETE request
 * @throws - {@link RestApiError}
 * @example
 * Send a DELETE request
 * ```js
 * import { del } from '@aws-amplify/api';
 *
 * const { statusCode } = await del({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * ```
 */ const $3326d8896d8e99ec$export$1d2f21e549771e67 = (input)=>(0, $g5tdz.del)((0, $1qbEC.Amplify), input);
/**
 * HEAD HTTP request
 * @param {HeadInput} input - Input for HEAD operation
 * @returns {HeadOperation} Operation for HEAD request
 * @throws - {@link RestApiError}
 * @example
 * Send a HEAD request
 * ```js
 * import { head, isCancelError } from '@aws-amplify/api';
 *
 * const { headers, statusCode } = await head({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }),response;
 * ```
 *
 */ const $3326d8896d8e99ec$export$5fd5031fecdacec3 = (input)=>(0, $g5tdz.head)((0, $1qbEC.Amplify), input);
/**
 * PATCH HTTP request
 * @param {PatchInput} input - Input for PATCH operation
 * @returns {PatchOperation} Operation for PATCH request
 * @throws - {@link RestApiError}
 * @example
 * Send a PATCH request
 * ```js
 * import { patch } from '@aws-amplify/api';
 *
 * const { body } = await patch({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 *
 * @example
 * Cancel a PATCH request
 * ```js
 * import { patch, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = patch({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } catch (e) {
 *  if (isCancelError(e)) {
 *   // handle request cancellation
 *  }
 * //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$b76953f99ab2be78 = (input)=>(0, $g5tdz.patch)((0, $1qbEC.Amplify), input);

});
parcelRegister("g5tdz", function(module, exports) {

$parcel$export(module.exports, "get", () => $739a77b68798142b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $739a77b68798142b$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $739a77b68798142b$export$327f7b26ebf455db);
$parcel$export(module.exports, "del", () => $739a77b68798142b$export$1d2f21e549771e67);
$parcel$export(module.exports, "head", () => $739a77b68798142b$export$5fd5031fecdacec3);
$parcel$export(module.exports, "patch", () => $739a77b68798142b$export$b76953f99ab2be78);

var $hj5OQ = parcelRequire("hj5OQ");

var $a5hgs = parcelRequire("a5hgs");


parcelRequire("jaclz");

var $269lJ = parcelRequire("269lJ");

var $jDIGB = parcelRequire("jDIGB");

var $1RC0S = parcelRequire("1RC0S");

var $lbkdn = parcelRequire("lbkdn");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $739a77b68798142b$var$publicHandler = (amplify, options, method)=>{
    const { apiName: apiName, options: apiOptions = {}, path: apiPath } = options;
    const libraryConfigTimeout = amplify.libraryOptions?.API?.REST?.timeout?.({
        apiName: apiName,
        method: method
    });
    const timeout = apiOptions?.timeout || libraryConfigTimeout || undefined;
    const publicApisAbortController = new AbortController();
    const abortSignal = publicApisAbortController.signal;
    return (0, $hj5OQ.createCancellableOperation)(async ()=>{
        const url = (0, $269lJ.resolveApiUrl)(amplify, apiName, apiPath, apiOptions?.queryParams);
        const libraryConfigHeaders = await amplify.libraryOptions?.API?.REST?.headers?.({
            apiName: apiName
        });
        const { headers: invocationHeaders = {} } = apiOptions;
        const headers = {
            // custom headers from invocation options should precede library options
            ...libraryConfigHeaders,
            ...invocationHeaders
        };
        const signingServiceInfo = (0, $a5hgs.parseSigningInfo)(url, {
            amplify: amplify,
            apiName: apiName
        });
        (0, $jDIGB.logger).debug(method, url, headers, `IAM signing options: ${JSON.stringify(signingServiceInfo)}`);
        return (0, $lbkdn.transferHandler)(amplify, {
            ...apiOptions,
            url: url,
            method: method,
            headers: headers,
            abortSignal: abortSignal
        }, (0, $1RC0S.isIamAuthApplicableForRest), signingServiceInfo);
    }, publicApisAbortController, "public", timeout);
};
const $739a77b68798142b$export$3988ae62b71be9a3 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "GET");
const $739a77b68798142b$export$299ba2dee77727e9 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "POST");
const $739a77b68798142b$export$327f7b26ebf455db = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "PUT");
const $739a77b68798142b$export$1d2f21e549771e67 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "DELETE");
const $739a77b68798142b$export$5fd5031fecdacec3 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "HEAD");
const $739a77b68798142b$export$b76953f99ab2be78 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "PATCH");

});
parcelRegister("hj5OQ", function(module, exports) {

$parcel$export(module.exports, "createCancellableOperation", () => $ba05af205170c6e9$export$52e72f0a376807e8);

var $3Qiot = parcelRequire("3Qiot");

parcelRequire("jaclz");

var $fFah5 = parcelRequire("fFah5");

var $jDIGB = parcelRequire("jDIGB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $ba05af205170c6e9$export$52e72f0a376807e8(handler, abortController, operationType, timeout) {
    const abortSignal = abortController.signal;
    let abortReason;
    if (timeout != null) {
        if (timeout < 0) throw new Error("Timeout must be a non-negative number");
        setTimeout(()=>{
            abortReason = "TimeoutError";
            abortController.abort(abortReason);
        }, timeout);
    }
    const job = async ()=>{
        try {
            const response = await handler();
            if (response.statusCode >= 300) throw await (0, $fFah5.parseRestApiServiceError)(response);
            return response;
        } catch (error) {
            if (error.name === "AbortError" || abortSignal?.aborted === true) {
                // Check if timeout caused the abort
                const isTimeout = abortReason && abortReason === "TimeoutError";
                if (isTimeout) {
                    const timeoutError = new Error(`Request timeout after ${timeout}ms`);
                    timeoutError.name = "TimeoutError";
                    (0, $jDIGB.logger).debug(timeoutError);
                    throw timeoutError;
                } else {
                    const message = abortReason ?? abortSignal.reason;
                    const canceledError = new (0, $3Qiot.CanceledError)({
                        ...message && {
                            message: message
                        },
                        underlyingError: error,
                        recoverySuggestion: "The API request was explicitly canceled. If this is not intended, validate if you called the `cancel()` function on the API request erroneously."
                    });
                    (0, $jDIGB.logger).debug(canceledError);
                    throw canceledError;
                }
            }
            (0, $jDIGB.logger).debug(error);
            throw error;
        }
    };
    if (operationType === "internal") return job();
    else {
        const cancel = (abortMessage)=>{
            if (abortSignal.aborted === true) return;
            abortController.abort(abortMessage);
            // If abort reason is not supported, set a scoped reasons instead. The reason property inside an
            // AbortSignal is a readonly property and trying to set it would throw an error.
            if (abortMessage && abortSignal.reason !== abortMessage) abortReason = abortMessage;
        };
        return {
            response: job(),
            cancel: cancel
        };
    }
}

});
parcelRegister("jaclz", function(module, exports) {

$parcel$export(module.exports, "RestApiValidationErrorCode", () => $aa90e1be24f1eaa0$export$8684d9f0176ec7fd);
$parcel$export(module.exports, "validationErrorMap", () => $aa90e1be24f1eaa0$export$195137955146d376);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $aa90e1be24f1eaa0$export$8684d9f0176ec7fd;
(function(RestApiValidationErrorCode) {
    RestApiValidationErrorCode["InvalidApiName"] = "InvalidApiName";
})($aa90e1be24f1eaa0$export$8684d9f0176ec7fd || ($aa90e1be24f1eaa0$export$8684d9f0176ec7fd = {}));
const $aa90e1be24f1eaa0$export$195137955146d376 = {
    [$aa90e1be24f1eaa0$export$8684d9f0176ec7fd.InvalidApiName]: {
        message: "API name is invalid.",
        recoverySuggestion: "Check if the API name matches the one in your configuration or `aws-exports.js`"
    }
};

});

parcelRegister("fFah5", function(module, exports) {

$parcel$export(module.exports, "parseRestApiServiceError", () => $eed1162a5b8f7824$export$cdf23200529f687c);

var $bM38a = parcelRequire("bM38a");

var $elLC1 = parcelRequire("elLC1");
parcelRequire("jaclz");
/**
 * Parses both AWS and non-AWS error responses coming from the users' backend code.
 * * AWS errors generated by the AWS services(e.g. API Gateway, Bedrock). They can be Signature errors,
 *   ClockSkew errors, etc. These responses will be parsed to errors with proper name and message from the AWS
 *   services.
 * * non-AWS errors thrown by the user code. They can contain any headers or body. Users need to access the
 *   error.response to get the headers and body and parse them accordingly. The JS error name and message will
 *   be `UnknownError` and `Unknown error` respectively.
 */ const $eed1162a5b8f7824$export$cdf23200529f687c = async (response)=>{
    if (!response) // Response is not considered an error.
    return;
    const parsedAwsError = await (0, $bM38a.parseJsonError)($eed1162a5b8f7824$var$stubErrorResponse(response));
    if (!parsedAwsError) ;
    else {
        const bodyText = await response.body?.text();
        return $eed1162a5b8f7824$var$buildRestApiError(parsedAwsError, {
            statusCode: response.statusCode,
            headers: response.headers,
            body: bodyText
        });
    }
};
/**
 * The response object needs to be stub here because the parseAwsJsonError assumes the response body to be valid JSON.
 * Although this is true for AWS services, it is not true for responses from user's code. Once the response body is
 * unwrapped as JSON(and fail), it cannot be read as text again. Therefore, we need to stub the response body here to
 * make sure we can read the error response body as a JSON, and may fall back to read as text if it is not a valid JSON.
 */ const $eed1162a5b8f7824$var$stubErrorResponse = (response)=>{
    let bodyTextPromise;
    const bodyProxy = new Proxy(response.body, {
        get (target, prop, receiver) {
            if (prop === "json") // For potential AWS errors, error parser will try to parse the body as JSON first.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                try {
                    return JSON.parse(await bodyTextPromise);
                } catch (error) {
                    // If response body is not a valid JSON, we stub it to be an empty object and eventually parsed
                    // as an unknown error
                    return {};
                }
            };
            else if (prop === "text") // For non-AWS errors, users can access the body as a string as a fallback.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                return bodyTextPromise;
            };
            else return Reflect.get(target, prop, receiver);
        }
    });
    const responseProxy = new Proxy(response, {
        get (target, prop, receiver) {
            if (prop === "body") return bodyProxy;
            else return Reflect.get(target, prop, receiver);
        }
    });
    return responseProxy;
};
/**
 * Utility to create a new RestApiError from a service error.
 */ const $eed1162a5b8f7824$var$buildRestApiError = (error, response)=>{
    const restApiError = new (0, $elLC1.RestApiError)({
        name: error?.name,
        message: error.message,
        underlyingError: error,
        response: response
    });
    // $metadata is only required for backwards compatibility.
    return Object.assign(restApiError, {
        $metadata: error.$metadata
    });
};

});

parcelRegister("jDIGB", function(module, exports) {

$parcel$export(module.exports, "logger", () => $11b826f7e5531aec$export$af88d00dbe7f521);

var $gJw02 = parcelRequire("gJw02");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $11b826f7e5531aec$export$af88d00dbe7f521 = new (0, $gJw02.ConsoleLogger)("RestApis");

});


parcelRegister("a5hgs", function(module, exports) {

$parcel$export(module.exports, "parseSigningInfo", () => $e4af76b08febfda7$export$654dd12592b26445);

var $2d61L = parcelRequire("2d61L");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Infer the signing service and region from the given URL, and for REST API only, from the Amplify configuration.
 * It supports raw API Gateway endpoint and AppSync endpoint.
 *
 * @internal
 */ const $e4af76b08febfda7$export$654dd12592b26445 = (url, restApiOptions)=>{
    const { service: signingService = (0, $2d61L.DEFAULT_REST_IAM_SIGNING_SERVICE), region: signingRegion = (0, $2d61L.DEFAULT_IAM_SIGNING_REGION) } = restApiOptions?.amplify.getConfig()?.API?.REST?.[restApiOptions?.apiName] ?? {};
    const { hostname: hostname } = url;
    const [, service, region] = (0, $2d61L.APIG_HOSTNAME_PATTERN).exec(hostname) ?? [];
    if (service === (0, $2d61L.DEFAULT_REST_IAM_SIGNING_SERVICE)) // The configured endpoint is an API Gateway endpoint
    // @see: https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-call-api.html
    return {
        service: service,
        region: region ?? signingRegion
    };
    else if (service === "appsync-api") // AppSync endpoint is internally supported because GraphQL operation will send request using POST handler.
    // example: https://xxxx.appsync-api.us-east-1.amazonaws.com/graphql
    return {
        service: "appsync",
        region: region ?? signingRegion
    };
    else return {
        service: signingService,
        region: signingRegion
    };
};

});
parcelRegister("2d61L", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REST_IAM_SIGNING_SERVICE", () => $f628e48ffad78896$export$f8920556a4a329aa);
$parcel$export(module.exports, "DEFAULT_IAM_SIGNING_REGION", () => $f628e48ffad78896$export$c5a0e6a7389a299);
$parcel$export(module.exports, "APIG_HOSTNAME_PATTERN", () => $f628e48ffad78896$export$df1c07b38ace96c2);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f628e48ffad78896$export$f8920556a4a329aa = "execute-api";
const $f628e48ffad78896$export$30f5dbb18c8d33cd = "appsync-api";
const $f628e48ffad78896$export$c5a0e6a7389a299 = "us-east-1";
/**
 * The REST endpoints generated by API Gateway
 * @see {@link https://docs.aws.amazon.com/general/latest/gr/apigateway.html#apigateway_region_data_plane}
 */ const $f628e48ffad78896$export$df1c07b38ace96c2 = /^.+\.([a-z0-9-]+)\.([a-z0-9-]+)\.amazonaws\.com/;

});


parcelRegister("269lJ", function(module, exports) {

$parcel$export(module.exports, "resolveApiUrl", () => $650f468c821576c6$export$74befe2cc96b2f5);

var $7Ar4G = parcelRequire("7Ar4G");

var $elLC1 = parcelRequire("elLC1");

var $8sR3l = parcelRequire("8sR3l");

var $jaclz = parcelRequire("jaclz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resolve the REST API request URL by:
 * 1. Loading the REST API endpoint from the Amplify configuration with corresponding API name.
 * 2. Appending the path to the endpoint.
 * 3. Merge the query parameters from path and the queryParameter argument which is taken from the public REST API
 *   options.
 * 4. Validating the resulting URL string.
 *
 * @internal
 */ const $650f468c821576c6$export$74befe2cc96b2f5 = (amplify, apiName, path, queryParams)=>{
    const urlStr = amplify.getConfig()?.API?.REST?.[apiName]?.endpoint;
    (0, $8sR3l.assertValidationError)(!!urlStr, (0, $jaclz.RestApiValidationErrorCode).InvalidApiName);
    try {
        let url;
        if ((0, $7Ar4G.AmplifyUrl).canParse(urlStr + path)) url = new (0, $7Ar4G.AmplifyUrl)(urlStr + path);
        else url = new (0, $7Ar4G.AmplifyUrl)(urlStr + path, location?.origin);
        if (queryParams) {
            const mergedQueryParams = new (0, $7Ar4G.AmplifyUrlSearchParams)(url.searchParams);
            Object.entries(queryParams).forEach(([key, value])=>{
                mergedQueryParams.set(key, value);
            });
            url.search = new (0, $7Ar4G.AmplifyUrlSearchParams)(mergedQueryParams).toString();
        }
        return url;
    } catch (error) {
        throw new (0, $elLC1.RestApiError)({
            name: (0, $jaclz.RestApiValidationErrorCode).InvalidApiName,
            ...(0, $jaclz.validationErrorMap)[(0, $jaclz.RestApiValidationErrorCode).InvalidApiName],
            recoverySuggestion: `Please make sure the REST endpoint URL is a valid URL string. Got ${urlStr}`
        });
    }
};

});
parcelRegister("8sR3l", function(module, exports) {

$parcel$export(module.exports, "assertValidationError", () => $e66dc82f182fbc3a$export$45936001d12f9b53);

var $elLC1 = parcelRequire("elLC1");

var $jaclz = parcelRequire("jaclz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $e66dc82f182fbc3a$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $jaclz.validationErrorMap)[name];
    if (!assertion) throw new (0, $elLC1.RestApiError)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}

});


parcelRegister("1RC0S", function(module, exports) {

$parcel$export(module.exports, "isIamAuthApplicableForGraphQL", () => $b623a8fb05af0894$export$110fc5362a5a362d);
$parcel$export(module.exports, "isIamAuthApplicableForRest", () => $b623a8fb05af0894$export$71fd2df8c175c331);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if IAM authentication should be applied for a GraphQL request.
 *
 * This function checks the `headers` of the HTTP request to determine if IAM authentication
 * is applicable. IAM authentication is considered applicable if there is no `authorization`
 * header, no `x-api-key` header, and `signingServiceInfo` is provided.
 *
 * @param request - The HTTP request object containing headers.
 * @param signingServiceInfo - Optional signing service information,
 * including service and region.
 * @returns A boolean `true` if IAM authentication should be applied.
 *
 * @internal
 */ const $b623a8fb05af0894$export$110fc5362a5a362d = ({ headers: headers }, signingServiceInfo)=>!headers.authorization && !headers["x-api-key"] && !!signingServiceInfo;
/**
 * Determines if IAM authentication should be applied for a REST request.
 *
 * This function checks the `headers` of the HTTP request to determine if IAM authentication
 * is applicable. IAM authentication is considered applicable if there is no `authorization`
 * header and `signingServiceInfo` is provided.
 *
 * @param request - The HTTP request object containing headers.
 * @param signingServiceInfo - Optional signing service information,
 * including service and region.
 * @returns A boolean `true` if IAM authentication should be applied.
 *
 * @internal
 */ const $b623a8fb05af0894$export$71fd2df8c175c331 = ({ headers: headers }, signingServiceInfo)=>!headers.authorization && !!signingServiceInfo;

});

parcelRegister("lbkdn", function(module, exports) {

$parcel$export(module.exports, "transferHandler", () => $49f3b5598320df23$export$28f1d6139f3d8c0a);

var $4ZD6k = parcelRequire("4ZD6k");
var $5D9nd = parcelRequire("5D9nd");

parcelRequire("jaclz");

var $fFah5 = parcelRequire("fFah5");

var $jDIGB = parcelRequire("jDIGB");

var $a5hgs = parcelRequire("a5hgs");

var $6hYhc = parcelRequire("6hYhc");

var $iURDH = parcelRequire("iURDH");

var $hwfXM = parcelRequire("hwfXM");

var $ctahF = parcelRequire("ctahF");
/**
 * Make REST API call with best-effort IAM auth.
 * @param amplify Amplify instance to to resolve credentials and tokens. Should use different instance in client-side
 *   and SSR
 * @param options Options accepted from public API options when calling the handlers.
 * @param signingServiceInfo Internal-only options enable IAM auth as well as to to overwrite the IAM signing service
 *   and region. If specified, and NONE of API Key header or Auth header is present, IAM auth will be used.
 * @param iamAuthApplicable Callback function that is used to determine if IAM Auth should be used or not.
 *
 * @internal
 */ const $49f3b5598320df23$export$28f1d6139f3d8c0a = async (amplify, options, iamAuthApplicable, signingServiceInfo)=>{
    const { url: url, method: method, headers: headers, body: body, withCredentials: withCredentials, abortSignal: abortSignal, retryStrategy: retryStrategy } = options;
    const resolvedBody = body ? body instanceof FormData ? body : JSON.stringify(body ?? "") : undefined;
    const resolvedHeaders = (0, $iURDH.resolveHeaders)(headers, body);
    const request = {
        url: url,
        headers: resolvedHeaders,
        method: method,
        body: resolvedBody
    };
    const { retryStrategy: libraryRetryStrategy, defaultAuthMode: libraryDefaultAuthMode } = (0, $6hYhc.resolveLibraryOptions)(amplify);
    const baseOptions = {
        retryDecider: $49f3b5598320df23$var$getRetryDeciderFromStrategy(retryStrategy ?? libraryRetryStrategy),
        computeDelay: (0, $5D9nd.jitteredBackoff),
        withCrossDomainCredentials: withCredentials,
        abortSignal: abortSignal
    };
    const defaultAuthMode = options.defaultAuthMode ?? libraryDefaultAuthMode;
    let credentials = null;
    if (defaultAuthMode !== "none") credentials = await $49f3b5598320df23$var$resolveCredentials(amplify);
    let response;
    const isIamAuthApplicable = iamAuthApplicable(request, signingServiceInfo);
    if (isIamAuthApplicable && credentials) {
        const signingInfoFromUrl = (0, $a5hgs.parseSigningInfo)(url);
        const signingService = signingServiceInfo?.service ?? signingInfoFromUrl.service;
        const signingRegion = signingServiceInfo?.region ?? signingInfoFromUrl.region;
        response = await (0, $hwfXM.authenticatedHandler)(request, {
            ...baseOptions,
            credentials: credentials,
            region: signingRegion,
            service: signingService
        });
    } else response = await (0, $ctahF.unauthenticatedHandler)(request, {
        ...baseOptions
    });
    // Clean-up un-modeled properties from response.
    return {
        statusCode: response.statusCode,
        headers: response.headers,
        body: response.body
    };
};
const $49f3b5598320df23$var$getRetryDeciderFromStrategy = (retryStrategy)=>{
    const strategy = retryStrategy?.strategy;
    if (strategy === "no-retry") return ()=>Promise.resolve({
            retryable: false
        });
    return (0, $4ZD6k.getRetryDecider)((0, $fFah5.parseRestApiServiceError));
};
const $49f3b5598320df23$var$resolveCredentials = async (amplify)=>{
    try {
        const { credentials: credentials } = await amplify.Auth.fetchAuthSession();
        if (credentials) return credentials;
    } catch (e) {
        (0, $jDIGB.logger).debug("No credentials available, the request will be unsigned.");
    }
    return null;
};

});
parcelRegister("6hYhc", function(module, exports) {

$parcel$export(module.exports, "resolveLibraryOptions", () => $c81f36e1a8b874f6$export$101b589a61b1975e);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $c81f36e1a8b874f6$export$101b589a61b1975e = (amplify)=>{
    const retryStrategy = amplify.libraryOptions?.API?.REST?.retryStrategy;
    const defaultAuthMode = amplify.libraryOptions?.API?.REST?.defaultAuthMode;
    return {
        retryStrategy: retryStrategy,
        defaultAuthMode: defaultAuthMode
    };
};

});

parcelRegister("iURDH", function(module, exports) {

$parcel$export(module.exports, "resolveHeaders", () => $981c4e8ab4e5d02a$export$7dd43af7d8d48b8f);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $981c4e8ab4e5d02a$export$7dd43af7d8d48b8f = (headers, body)=>{
    const normalizedHeaders = {};
    for(const key in headers)normalizedHeaders[key.toLowerCase()] = headers[key];
    if (body) {
        const contentType = normalizedHeaders["content-type"];
        const isJsonCompatible = contentType && (contentType.startsWith("application/json") || contentType.startsWith("application/") && contentType.includes("+json"));
        if (!isJsonCompatible) normalizedHeaders["content-type"] = "application/json; charset=UTF-8";
        if (body instanceof FormData) /**
             * If body is a FormData we should not allow setting content-type.
             * It's because runtime HTTP handlers(xhr, fetch, undici, node-fetch,
             * etc.) will modify the content-type value when setting multipart
             * boundary.
             */ delete normalizedHeaders["content-type"];
    }
    return normalizedHeaders;
};

});

parcelRegister("hwfXM", function(module, exports) {

$parcel$export(module.exports, "authenticatedHandler", () => $4665416ad00251b6$export$caa14993632515f8);

var $anVi4 = parcelRequire("anVi4");
var $9NyS9 = parcelRequire("9NyS9");
var $3k9Yx = parcelRequire("3k9Yx");
var $aBoxv = parcelRequire("aBoxv");

var $8e8Xp = parcelRequire("8e8Xp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $4665416ad00251b6$export$caa14993632515f8 = (0, $8e8Xp.composeTransferHandler)((0, $anVi4.fetchTransferHandler), [
    (0, $aBoxv.userAgentMiddlewareFactory),
    (0, $9NyS9.retryMiddlewareFactory),
    (0, $3k9Yx.signingMiddlewareFactory)
]);

});
parcelRegister("3k9Yx", function(module, exports) {

$parcel$export(module.exports, "signingMiddlewareFactory", () => $5e05a21ab6358ec7$export$d8f74542d1f00e1d);

var $hVfGq = parcelRequire("hVfGq");
parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $dsAqn = parcelRequire("dsAqn");

var $apgva = parcelRequire("apgva");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware that SigV4 signs request with AWS credentials, and correct system clock offset.
 * This middleware is expected to be placed after retry middleware.
 */ const $5e05a21ab6358ec7$export$d8f74542d1f00e1d = ({ credentials: credentials, region: region, service: service, uriEscapePath: uriEscapePath = true })=>{
    let currentSystemClockOffset;
    return (next, context)=>async function signingMiddleware(request) {
            currentSystemClockOffset = currentSystemClockOffset ?? 0;
            const signRequestOptions = {
                credentials: typeof credentials === "function" ? await credentials({
                    forceRefresh: !!context?.isCredentialsExpired
                }) : credentials,
                signingDate: (0, $dsAqn.getSkewCorrectedDate)(currentSystemClockOffset),
                signingRegion: region,
                signingService: service,
                uriEscapePath: uriEscapePath
            };
            const signedRequest = await (0, $hVfGq.signRequest)(request, signRequestOptions);
            const response = await next(signedRequest);
            // Update system clock offset if response contains date header, regardless of the status code.
            // non-2xx response will still be returned from next handler instead of thrown, because it's
            // only thrown by the retry middleware.
            const dateString = $5e05a21ab6358ec7$var$getDateHeader(response);
            if (dateString) currentSystemClockOffset = (0, $apgva.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
            return response;
        };
};
const $5e05a21ab6358ec7$var$getDateHeader = ({ headers: headers } = {})=>headers?.date ?? headers?.Date ?? headers?.["x-amz-date"];

});
parcelRegister("hVfGq", function(module, exports) {

$parcel$export(module.exports, "signRequest", () => $3b8b0a35c7d2f42e$export$aa7d25cddbad24ed);

var $k9Bfc = parcelRequire("k9Bfc");

var $9a7M8 = parcelRequire("9a7M8");

var $5lANR = parcelRequire("5lANR");

var $cmsYW = parcelRequire("cmsYW");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Given a `HttpRequest`, returns a Signature Version 4 signed `HttpRequest`.
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns A `HttpRequest` with authentication headers which can grant temporary access to AWS resources.
 */ const $3b8b0a35c7d2f42e$export$aa7d25cddbad24ed = (request, options)=>{
    const signingValues = (0, $9a7M8.getSigningValues)(options);
    const { accessKeyId: accessKeyId, credentialScope: credentialScope, longDate: longDate, sessionToken: sessionToken } = signingValues;
    // create the request to sign
    const headers = {
        ...request.headers
    };
    headers[0, $5lANR.HOST_HEADER] = request.url.host;
    headers[0, $5lANR.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, $5lANR.TOKEN_HEADER] = sessionToken;
    const requestToSign = {
        ...request,
        headers: headers
    };
    // calculate and add the signature to the request
    const signature = (0, $cmsYW.getSignature)(requestToSign, signingValues);
    const credentialEntry = `Credential=${accessKeyId}/${credentialScope}`;
    const signedHeadersEntry = `SignedHeaders=${(0, $k9Bfc.getSignedHeaders)(headers)}`;
    const signatureEntry = `Signature=${signature}`;
    headers[0, $5lANR.AUTH_HEADER] = `${0, $5lANR.SHA256_ALGORITHM_IDENTIFIER} ${credentialEntry}, ${signedHeadersEntry}, ${signatureEntry}`;
    return requestToSign;
};

});
parcelRegister("k9Bfc", function(module, exports) {

$parcel$export(module.exports, "getSignedHeaders", () => $801e30203e6ee81f$export$812d6f56efda9cfa);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ const $801e30203e6ee81f$export$812d6f56efda9cfa = (headers)=>Object.keys(headers).map((key)=>key.toLowerCase()).sort().join(";");

});

parcelRegister("9a7M8", function(module, exports) {

$parcel$export(module.exports, "getSigningValues", () => $7c254d6715dfe620$export$188c70d4d3596d39);

var $ixXuO = parcelRequire("ixXuO");

var $9h49C = parcelRequire("9h49C");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Extracts common values used for signing both requests and urls.
 *
 * @param options `SignRequestOptions` object containing values used to construct the signature.
 * @returns Common `SigningValues` used for signing.
 *
 * @internal
 */ const $7c254d6715dfe620$export$188c70d4d3596d39 = ({ credentials: credentials, signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath = true })=>{
    // get properties from credentials
    const { accessKeyId: accessKeyId, secretAccessKey: secretAccessKey, sessionToken: sessionToken } = credentials;
    // get formatted dates for signing
    const { longDate: longDate, shortDate: shortDate } = (0, $9h49C.getFormattedDates)(signingDate);
    // copy header and set signing properties
    const credentialScope = (0, $ixXuO.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};

});
parcelRegister("ixXuO", function(module, exports) {

$parcel$export(module.exports, "getCredentialScope", () => $cf06eb9d7fea015f$export$a720a7c8dd7ab696);

var $5lANR = parcelRequire("5lANR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the credential scope which restricts the resulting signature to the specified region and service.
 *
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns  A string representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 *
 * @internal
 */ const $cf06eb9d7fea015f$export$a720a7c8dd7ab696 = (date, region, service)=>`${date}/${region}/${service}/${0, $5lANR.KEY_TYPE_IDENTIFIER}`;

});
parcelRegister("5lANR", function(module, exports) {

$parcel$export(module.exports, "AUTH_HEADER", () => $63c567658c1dc4ca$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "HOST_HEADER", () => $63c567658c1dc4ca$export$96307741595055fc);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $63c567658c1dc4ca$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "TOKEN_HEADER", () => $63c567658c1dc4ca$export$fdc81b663012a8d2);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $63c567658c1dc4ca$export$c4bf0942098f6bb);
$parcel$export(module.exports, "SHA256_ALGORITHM_IDENTIFIER", () => $63c567658c1dc4ca$export$aba583fcf2c2a4e9);
$parcel$export(module.exports, "SIGNATURE_IDENTIFIER", () => $63c567658c1dc4ca$export$c295e35583a9d67a);
$parcel$export(module.exports, "EMPTY_HASH", () => $63c567658c1dc4ca$export$b445dbfd1d7f2d42);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $63c567658c1dc4ca$export$91f7321b40d9fd07);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
const $63c567658c1dc4ca$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $63c567658c1dc4ca$export$6e114beec37430d7 = "X-Amz-Date";
const $63c567658c1dc4ca$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $63c567658c1dc4ca$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $63c567658c1dc4ca$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $63c567658c1dc4ca$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $63c567658c1dc4ca$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $63c567658c1dc4ca$export$8e1383b7eea7bee = "X-Amz-Security-Token";
// headers
const $63c567658c1dc4ca$export$9924a64a4b8b0d58 = "authorization";
const $63c567658c1dc4ca$export$96307741595055fc = "host";
const $63c567658c1dc4ca$export$acf4b8bdf24aab34 = $63c567658c1dc4ca$export$6e114beec37430d7.toLowerCase();
const $63c567658c1dc4ca$export$fdc81b663012a8d2 = $63c567658c1dc4ca$export$8e1383b7eea7bee.toLowerCase();
// identifiers
const $63c567658c1dc4ca$export$c4bf0942098f6bb = "aws4_request";
const $63c567658c1dc4ca$export$aba583fcf2c2a4e9 = "AWS4-HMAC-SHA256";
const $63c567658c1dc4ca$export$c295e35583a9d67a = "AWS4";
// preset values
const $63c567658c1dc4ca$export$b445dbfd1d7f2d42 = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
const $63c567658c1dc4ca$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";

});


parcelRegister("9h49C", function(module, exports) {

$parcel$export(module.exports, "getFormattedDates", () => $3e1220c52013c4f4$export$79cc774850e3b1b);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ const $3e1220c52013c4f4$export$79cc774850e3b1b = (date)=>{
    const longDate = date.toISOString().replace(/[:-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};

});


parcelRegister("cmsYW", function(module, exports) {

$parcel$export(module.exports, "getSignature", () => $68a3178cad332cbe$export$2f768fec5d73d91a);

var $9DDIC = parcelRequire("9DDIC");

var $1JAiq = parcelRequire("1JAiq");

var $9qHih = parcelRequire("9qHih");

var $4NKll = parcelRequire("4NKll");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculates and returns an AWS API Signature.
 * https://docs.aws.amazon.com/IAM/latest/UserGuide/create-signed-request.html
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns AWS API Signature to sign a request or url with.
 *
 * @internal
 */ const $68a3178cad332cbe$export$2f768fec5d73d91a = (request, { credentialScope: credentialScope, longDate: longDate, secretAccessKey: secretAccessKey, shortDate: shortDate, signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath })=>{
    // step 1: create a canonical request
    const canonicalRequest = (0, $1JAiq.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    const hashedRequest = (0, $9DDIC.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    const stringToSign = (0, $4NKll.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    const signature = (0, $9DDIC.getHashedDataAsHex)((0, $9qHih.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

});
parcelRegister("9DDIC", function(module, exports) {

$parcel$export(module.exports, "getHashedData", () => $e878efb7fb845f8e$export$1a568184069ac3c8);
$parcel$export(module.exports, "getHashedDataAsHex", () => $e878efb7fb845f8e$export$45d3ccefb0f0c6da);
parcelRequire("78v1Z");
var $4xNDb = parcelRequire("4xNDb");

var $lUOK3 = parcelRequire("lUOK3");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
/**
 * Returns the hashed data a `Uint8Array`.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns `Uint8Array` created from the data as input to a hash function.
 */ const $e878efb7fb845f8e$export$1a568184069ac3c8 = (key, data)=>{
    const sha256 = new (0, $4xNDb.Sha256)(key ?? undefined);
    sha256.update(data);
    // TODO: V6 flip to async digest
    const hashedData = sha256.digestSync();
    return hashedData;
};
/**
 * Returns the hashed data as a hex string.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns String using lowercase hexadecimal characters created from the data as input to a hash function.
 *
 * @internal
 */ const $e878efb7fb845f8e$export$45d3ccefb0f0c6da = (key, data)=>{
    const hashedData = $e878efb7fb845f8e$export$1a568184069ac3c8(key, data);
    return (0, $lUOK3.toHex)(hashedData);
};

});

parcelRegister("1JAiq", function(module, exports) {

$parcel$export(module.exports, "getCanonicalRequest", () => $1cff5c5577c43db0$export$78136353678f36ec);

var $1peWS = parcelRequire("1peWS");

var $lbuB1 = parcelRequire("lbuB1");

var $m3vdz = parcelRequire("m3vdz");

var $3YqIC = parcelRequire("3YqIC");

var $k9Bfc = parcelRequire("k9Bfc");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical request.
 *
 * @param request `HttpRequest` from which to create the canonical request from.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns String created by by concatenating the following strings, separated by newline characters:
 * - HTTPMethod
 * - CanonicalUri
 * - CanonicalQueryString
 * - CanonicalHeaders
 * - SignedHeaders
 * - HashedPayload
 *
 * @internal
 */ const $1cff5c5577c43db0$export$78136353678f36ec = ({ body: body, headers: headers, method: method, url: url }, uriEscapePath = true)=>[
        method,
        (0, $m3vdz.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, $lbuB1.getCanonicalQueryString)(url.searchParams),
        (0, $1peWS.getCanonicalHeaders)(headers),
        (0, $k9Bfc.getSignedHeaders)(headers),
        (0, $3YqIC.getHashedPayload)(body)
    ].join("\n");

});
parcelRegister("1peWS", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $802403cd603e7e8b$export$859d7f1bb55e2914);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns canonical headers.
 *
 * @param headers Headers from the request.
 * @returns Request headers that will be signed, and their values, separated by newline characters. Header names must
 * use lowercase characters, must appear in alphabetical order, and must be followed by a colon (:). For the values,
 * trim any leading or trailing spaces, convert sequential spaces to a single space, and separate the values
 * for a multi-value header using commas.
 *
 * @internal
 */ const $802403cd603e7e8b$export$859d7f1bb55e2914 = (headers)=>Object.entries(headers).map(([key, value])=>({
            key: key.toLowerCase(),
            value: value?.trim().replace(/\s+/g, " ") ?? ""
        })).sort((a, b)=>a.key < b.key ? -1 : 1).map((entry)=>`${entry.key}:${entry.value}\n`).join("");

});

parcelRegister("lbuB1", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQueryString", () => $836086e14a5fbbdd$export$87a9cc45e3be0a17);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical query string.
 *
 * @param searchParams `searchParams` from the request url.
 * @returns URL-encoded query string parameters, separated by ampersands (&). Percent-encode reserved characters,
 * including the space character. Encode names and values separately. If there are empty parameters, append the equals
 * sign to the parameter name before encoding. After encoding, sort the parameters alphabetically by key name. If there
 * is no query string, use an empty string ("").
 *
 * @internal
 */ const $836086e14a5fbbdd$export$87a9cc45e3be0a17 = (searchParams)=>Array.from(searchParams).sort(([keyA, valA], [keyB, valB])=>{
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(([key, val])=>`${$836086e14a5fbbdd$var$escapeUri(key)}=${$836086e14a5fbbdd$var$escapeUri(val)}`).join("&");
const $836086e14a5fbbdd$var$escapeUri = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $836086e14a5fbbdd$var$hexEncode);
const $836086e14a5fbbdd$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

});

parcelRegister("m3vdz", function(module, exports) {

$parcel$export(module.exports, "getCanonicalUri", () => $c23651d03b87ad66$export$4bbb144438cceb59);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ const $c23651d03b87ad66$export$4bbb144438cceb59 = (pathname, uriEscapePath = true)=>pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";

});

parcelRegister("3YqIC", function(module, exports) {

$parcel$export(module.exports, "getHashedPayload", () => $d9f6bc20607e1fa8$export$b671a27d01dfc160);

var $5lANR = parcelRequire("5lANR");

var $9DDIC = parcelRequire("9DDIC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the hashed payload.
 *
 * @param body `body` (payload) from the request.
 * @returns String created using the payload in the body of the HTTP request as input to a hash function. This string
 * uses lowercase hexadecimal characters. If the payload is empty, return precalculated result of an empty hash.
 *
 * @internal
 */ const $d9f6bc20607e1fa8$export$b671a27d01dfc160 = (body)=>{
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, $5lANR.EMPTY_HASH;
    if ($d9f6bc20607e1fa8$var$isSourceData(body)) {
        const hashedData = (0, $9DDIC.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, $5lANR.UNSIGNED_PAYLOAD;
};
const $d9f6bc20607e1fa8$var$isSourceData = (body)=>// Exclude UNSIGNED_PAYLOAD constant to prevent it from being hashed as a string
    body !== (0, $5lANR.UNSIGNED_PAYLOAD) && (typeof body === "string" || ArrayBuffer.isView(body) || $d9f6bc20607e1fa8$var$isArrayBuffer(body));
const $d9f6bc20607e1fa8$var$isArrayBuffer = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

});


parcelRegister("9qHih", function(module, exports) {

$parcel$export(module.exports, "getSigningKey", () => $20544ff12369282e$export$8b95a069d16dd783);

var $5lANR = parcelRequire("5lANR");

var $9DDIC = parcelRequire("9DDIC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a signing key to be used for signing requests.
 *
 * @param secretAccessKey AWS secret access key from credentials.
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns `Uint8Array` calculated from its composite parts.
 *
 * @internal
 */ const $20544ff12369282e$export$8b95a069d16dd783 = (secretAccessKey, date, region, service)=>{
    const key = `${(0, $5lANR.SIGNATURE_IDENTIFIER)}${secretAccessKey}`;
    const dateKey = (0, $9DDIC.getHashedData)(key, date);
    const regionKey = (0, $9DDIC.getHashedData)(dateKey, region);
    const serviceKey = (0, $9DDIC.getHashedData)(regionKey, service);
    const signingKey = (0, $9DDIC.getHashedData)(serviceKey, (0, $5lANR.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

});

parcelRegister("4NKll", function(module, exports) {

$parcel$export(module.exports, "getStringToSign", () => $2e89d4e84567a0b9$export$ff872c70ad45fed1);

var $5lANR = parcelRequire("5lANR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a string to be signed.
 *
 * @param date Current date in the format 'YYYYMMDDThhmmssZ'.
 * @param credentialScope String representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 * @param hashedRequest Hashed canonical request.
 *
 * @returns A string created by by concatenating the following strings, separated by newline characters:
 * - Algorithm
 * - RequestDateTime
 * - CredentialScope
 * - HashedCanonicalRequest
 *
 * @internal
 */ const $2e89d4e84567a0b9$export$ff872c70ad45fed1 = (date, credentialScope, hashedRequest)=>[
        (0, $5lANR.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");

});



parcelRegister("dsAqn", function(module, exports) {

$parcel$export(module.exports, "getSkewCorrectedDate", () => $0336c7502048c65b$export$86d5c90340985ada);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ const $0336c7502048c65b$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

});

parcelRegister("apgva", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSystemClockOffset", () => $e5b4b6cb4653f17c$export$1ed4d48b860b1348);

var $bQnWW = parcelRequire("bQnWW");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the difference between clock time and the current system time if clock is skewed.
 *
 * @param clockTimeInMilliseconds Clock time in milliseconds.
 * @param currentSystemClockOffset Current system clock offset in milliseconds.
 *
 * @internal
 */ const $e5b4b6cb4653f17c$export$1ed4d48b860b1348 = (clockTimeInMilliseconds, currentSystemClockOffset)=>{
    if ((0, $bQnWW.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

});
parcelRegister("bQnWW", function(module, exports) {

$parcel$export(module.exports, "isClockSkewed", () => $b350468427cf28cf$export$c162a01d4a03ea6f);

var $dsAqn = parcelRequire("dsAqn");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
const $b350468427cf28cf$var$SKEW_WINDOW = 300000;
/**
 * Checks if the provided date is within the skew window of 5 minutes.
 *
 * @param clockTimeInMilliseconds Time to check for skew in milliseconds.
 * @param clockOffsetInMilliseconds Offset to check clock against in milliseconds.
 *
 * @returns True if skewed. False otherwise.
 *
 * @internal
 */ const $b350468427cf28cf$export$c162a01d4a03ea6f = (clockTimeInMilliseconds, clockOffsetInMilliseconds)=>Math.abs((0, $dsAqn.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= $b350468427cf28cf$var$SKEW_WINDOW;

});




parcelRegister("ctahF", function(module, exports) {

$parcel$export(module.exports, "unauthenticatedHandler", () => $99bcc145f5efeb6b$export$ed7e1ccf00f39c4a);

var $anVi4 = parcelRequire("anVi4");
var $9NyS9 = parcelRequire("9NyS9");
var $aBoxv = parcelRequire("aBoxv");

var $8e8Xp = parcelRequire("8e8Xp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $99bcc145f5efeb6b$export$ed7e1ccf00f39c4a = (0, $8e8Xp.composeTransferHandler)((0, $anVi4.fetchTransferHandler), [
    (0, $aBoxv.userAgentMiddlewareFactory),
    (0, $9NyS9.retryMiddlewareFactory)
]);

});





parcelRegister("dOmJe", function(module, exports) {

$parcel$export(module.exports, "cancel", () => (parcelRequire("cfOsN")).cancel);
$parcel$export(module.exports, "post", () => (parcelRequire("cfOsN")).post);
$parcel$export(module.exports, "updateRequestToBeCancellable", () => (parcelRequire("cfOsN")).updateRequestToBeCancellable);

var $cfOsN = parcelRequire("cfOsN");

});
parcelRegister("cfOsN", function(module, exports) {

$parcel$export(module.exports, "post", () => $da10f03454fb4394$export$299ba2dee77727e9);
$parcel$export(module.exports, "cancel", () => $da10f03454fb4394$export$70b61ad426ddbe54);
$parcel$export(module.exports, "updateRequestToBeCancellable", () => $da10f03454fb4394$export$6224e208c7f72b42);

var $hj5OQ = parcelRequire("hj5OQ");


parcelRequire("jaclz");
parcelRequire("jDIGB");

var $1RC0S = parcelRequire("1RC0S");

var $lbkdn = parcelRequire("lbkdn");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This weak map provides functionality to cancel a request given the promise containing the `post` request.
 *
 * 1. For every GraphQL POST request, an abort controller is created and supplied to the request.
 * 2. The promise fulfilled by GraphGL POST request is then mapped to that abort controller.
 * 3. The promise is returned to the external caller.
 * 4. The caller can either wait for the promise to fulfill or call `cancel(promise)` to cancel the request.
 * 5. If `cancel(promise)` is called, then the corresponding abort controller is retrieved from the map below.
 * 6. GraphQL POST request will be rejected with the error message provided during cancel.
 * 7. Caller can check if the error is because of cancelling by calling `isCancelError(error)`.
 */ const $da10f03454fb4394$var$cancelTokenMap = new WeakMap();
/**
 * @internal
 *
 * REST POST handler to send GraphQL request to given endpoint. By default, it will use IAM to authorize
 * the request. In some auth modes, the IAM auth has to be disabled. Here's how to set up the request auth correctly:
 * * If auth mode is 'iam', you MUST NOT set 'authorization' header and 'x-api-key' header, since it would disable IAM
 *   auth. You MUST also set 'input.options.signingServiceInfo' option.
 *   * The including 'input.options.signingServiceInfo.service' and 'input.options.signingServiceInfo.region' are
 *     optional. If omitted, the signing service and region will be inferred from url.
 * * If auth mode is 'none', you MUST NOT set 'options.signingServiceInfo' option.
 * * If auth mode is 'apiKey', you MUST set 'x-api-key' custom header.
 * * If auth mode is 'oidc' or 'lambda' or 'userPool', you MUST set 'authorization' header.
 *
 * To make the internal post cancellable, you must also call `updateRequestToBeCancellable()` with the promise from
 * internal post call and the abort controller supplied to the internal post call.
 *
 * @param amplify the AmplifyClassV6 instance - it may be the singleton used on Web, or an instance created within
 * a context created by `runWithAmplifyServerContext`
 * @param postInput an object of {@link InternalPostInput}
 * @param postInput.url The URL that the POST request sends to
 * @param postInput.options Options of the POST request
 * @param postInput.abortController The abort controller used to cancel the POST request
 * @returns a {@link RestApiResponse}
 *
 * @throws an {@link AmplifyError} with `Network Error` as the `message` when the external resource is unreachable due to one
 * of the following reasons:
 *   1. no network connection
 *   2. CORS error
 * @throws a {@link CanceledError} when the ongoing POST request get cancelled
 */ const $da10f03454fb4394$export$299ba2dee77727e9 = (amplify, { url: url, options: options, abortController: abortController })=>{
    const controller = abortController ?? new AbortController();
    const responsePromise = (0, $hj5OQ.createCancellableOperation)(async ()=>{
        const response = (0, $lbkdn.transferHandler)(amplify, {
            url: url,
            method: "POST",
            ...options,
            abortSignal: controller.signal,
            retryStrategy: {
                strategy: "jittered-exponential-backoff"
            }
        }, (0, $1RC0S.isIamAuthApplicableForGraphQL), options?.signingServiceInfo);
        return response;
    }, controller, "internal");
    const responseWithCleanUp = responsePromise.finally(()=>{
        $da10f03454fb4394$var$cancelTokenMap.delete(responseWithCleanUp);
    });
    return responseWithCleanUp;
};
/**
 * Cancels a request given the promise returned by `post`.
 * If the request is already completed, this function does nothing.
 * It MUST be used after `updateRequestToBeCancellable` is called.
 */ const $da10f03454fb4394$export$70b61ad426ddbe54 = (promise, message)=>{
    const controller = $da10f03454fb4394$var$cancelTokenMap.get(promise);
    if (controller) {
        controller.abort(message);
        if (message && controller.signal.reason !== message) // In runtimes where `AbortSignal.reason` is not supported, we track the reason ourselves.
        // @ts-expect-error reason is read-only property.
        controller.signal.reason = message;
        return true;
    }
    return false;
};
/**
 * MUST be used to make a promise including internal `post` API call cancellable.
 */ const $da10f03454fb4394$export$6224e208c7f72b42 = (promise, controller)=>{
    $da10f03454fb4394$var$cancelTokenMap.set(promise, controller);
};

});


parcelRegister("99ZQ7", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncRealTimeProvider", () => $86064b38d58ca2f6$export$b7b5e6371992068d);

var $dj9FS = parcelRequire("dj9FS");
var $1ZViM = parcelRequire("1ZViM");

var $fuDKT = parcelRequire("fuDKT");

var $e7ubE = parcelRequire("e7ubE");

var $1DlsO = parcelRequire("1DlsO");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $86064b38d58ca2f6$var$PROVIDER_NAME = "AWSAppSyncRealTimeProvider";
const $86064b38d58ca2f6$var$WS_PROTOCOL_NAME = "graphql-ws";
const $86064b38d58ca2f6$var$CONNECT_URI = "/connect";
class $86064b38d58ca2f6$export$b7b5e6371992068d extends (0, $e7ubE.AWSWebSocketProvider) {
    constructor(){
        super({
            providerName: $86064b38d58ca2f6$var$PROVIDER_NAME,
            wsProtocolName: $86064b38d58ca2f6$var$WS_PROTOCOL_NAME,
            connectUri: $86064b38d58ca2f6$var$CONNECT_URI
        });
    }
    getProviderName() {
        return $86064b38d58ca2f6$var$PROVIDER_NAME;
    }
    subscribe(options, customUserAgentDetails) {
        return super.subscribe(options, customUserAgentDetails);
    }
    async _prepareSubscriptionPayload({ options: options, subscriptionId: subscriptionId, customUserAgentDetails: customUserAgentDetails, additionalCustomHeaders: additionalCustomHeaders, libraryConfigHeaders: libraryConfigHeaders }) {
        const { appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, authenticationType: authenticationType, query: query, variables: variables, apiKey: apiKey, region: region } = options;
        const data = {
            query: query,
            variables: variables
        };
        const serializedData = JSON.stringify(data);
        const headers = {
            ...await (0, $1DlsO.awsRealTimeHeaderBasedAuth)({
                apiKey: apiKey,
                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                authenticationType: authenticationType,
                payload: serializedData,
                canonicalUri: "",
                region: region,
                additionalCustomHeaders: additionalCustomHeaders
            }),
            ...libraryConfigHeaders,
            ...additionalCustomHeaders,
            [(0, $1ZViM.USER_AGENT_HEADER)]: (0, $dj9FS.getAmplifyUserAgent)(customUserAgentDetails)
        };
        const subscriptionMessage = {
            id: subscriptionId,
            payload: {
                data: serializedData,
                extensions: {
                    authorization: {
                        ...headers
                    }
                }
            },
            type: (0, $fuDKT.MESSAGE_TYPES).GQL_START
        };
        const serializedSubscriptionMessage = JSON.stringify(subscriptionMessage);
        return serializedSubscriptionMessage;
    }
    _handleSubscriptionData(message) {
        this.logger.debug(`subscription message from AWS AppSync RealTime: ${message.data}`);
        const { id: id = "", payload: payload, type: type } = JSON.parse(String(message.data));
        const { observer: observer = null, query: query = "", variables: variables = {} } = this.subscriptionObserverMap.get(id) || {};
        this.logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, $fuDKT.MESSAGE_TYPES).DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else this.logger.debug(`observer not found for id: ${id}`);
            return [
                true,
                {
                    id: id,
                    type: type,
                    payload: payload
                }
            ];
        }
        return [
            false,
            {
                id: id,
                type: type,
                payload: payload
            }
        ];
    }
    _unsubscribeMessage(subscriptionId) {
        return {
            id: subscriptionId,
            type: (0, $fuDKT.MESSAGE_TYPES).GQL_STOP
        };
    }
    _extractConnectionTimeout(data) {
        const { payload: { connectionTimeoutMs: connectionTimeoutMs = (0, $fuDKT.DEFAULT_KEEP_ALIVE_TIMEOUT) } = {} } = data;
        return connectionTimeoutMs;
    }
    _extractErrorCodeAndType(data) {
        const { payload: { errors: [{ errorType: errorType = "", errorCode: errorCode = 0 } = {}] = [] } = {} } = data;
        return {
            errorCode: errorCode,
            errorType: errorType
        };
    }
}

});
parcelRegister("fuDKT", function(module, exports) {

$parcel$export(module.exports, "MAX_DELAY_MS", () => $cc2a59cca225035e$export$76041b1400befb8b);
$parcel$export(module.exports, "NON_RETRYABLE_CODES", () => $cc2a59cca225035e$export$d0eacfe8369b1f8e);
$parcel$export(module.exports, "NON_RETRYABLE_ERROR_TYPES", () => $cc2a59cca225035e$export$92b33158052a96b3);
$parcel$export(module.exports, "CONNECTION_STATE_CHANGE", () => $cc2a59cca225035e$export$a222eb271a4ce46b);
$parcel$export(module.exports, "MESSAGE_TYPES", () => $cc2a59cca225035e$export$e5fcfdba4a8ae715);
$parcel$export(module.exports, "SUBSCRIPTION_STATUS", () => $cc2a59cca225035e$export$50fc1b1dccfe0f97);
$parcel$export(module.exports, "SOCKET_STATUS", () => $cc2a59cca225035e$export$453843f36861c0a2);
$parcel$export(module.exports, "AWS_APPSYNC_REALTIME_HEADERS", () => $cc2a59cca225035e$export$7a236fa930e45f72);
$parcel$export(module.exports, "CONNECTION_INIT_TIMEOUT", () => $cc2a59cca225035e$export$c36bbd48cffe7fa4);
$parcel$export(module.exports, "START_ACK_TIMEOUT", () => $cc2a59cca225035e$export$c6bc4b7cffb2ca8);
$parcel$export(module.exports, "DEFAULT_KEEP_ALIVE_TIMEOUT", () => $cc2a59cca225035e$export$71a299b29e2098f0);
$parcel$export(module.exports, "DEFAULT_KEEP_ALIVE_HEARTBEAT_TIMEOUT", () => $cc2a59cca225035e$export$75c75dcdbe06fef4);
$parcel$export(module.exports, "DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT", () => $cc2a59cca225035e$export$2cb64c85846dde7d);
$parcel$export(module.exports, "RECONNECT_DELAY", () => $cc2a59cca225035e$export$6040e6f953ecf619);
$parcel$export(module.exports, "RECONNECT_INTERVAL", () => $cc2a59cca225035e$export$6229bdb3fed88d41);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cc2a59cca225035e$export$76041b1400befb8b = 5000;
const $cc2a59cca225035e$export$d0eacfe8369b1f8e = [
    400,
    401,
    403
];
const $cc2a59cca225035e$export$92b33158052a96b3 = [
    "BadRequestException",
    "UnauthorizedException"
];
const $cc2a59cca225035e$export$a222eb271a4ce46b = "ConnectionStateChange";
var $cc2a59cca225035e$export$e5fcfdba4a8ae715;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime or Events
     */ MESSAGE_TYPES["DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
    /**
     * Client -> Server message.
     * This message type is for registering subscriptions with Events
     */ MESSAGE_TYPES["EVENT_SUBSCRIBE"] = "subscribe";
    /**
     * Client -> Server message.
     * This message type is for publishing a message with Events
     */ MESSAGE_TYPES["EVENT_PUBLISH"] = "publish";
    /**
     * Server -> Client message.
     * Server acknowledges successful subscription
     */ MESSAGE_TYPES["EVENT_SUBSCRIBE_ACK"] = "subscribe_success";
    /**
     * Server -> Client message.
     * Server acknowledges successful publish
     */ MESSAGE_TYPES["EVENT_PUBLISH_ACK"] = "publish_success";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["EVENT_STOP"] = "unsubscribe";
    /**
     * Server -> Client message.
     * This is the ack response from AWS AppSync Events to EVENT_STOP message
     */ MESSAGE_TYPES["EVENT_COMPLETE"] = "unsubscribe_success";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync Events to the client
     */ MESSAGE_TYPES["EVENT_SUBSCRIBE_ERROR"] = "subscribe_error";
})($cc2a59cca225035e$export$e5fcfdba4a8ae715 || ($cc2a59cca225035e$export$e5fcfdba4a8ae715 = {}));
var $cc2a59cca225035e$export$50fc1b1dccfe0f97;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($cc2a59cca225035e$export$50fc1b1dccfe0f97 || ($cc2a59cca225035e$export$50fc1b1dccfe0f97 = {}));
var $cc2a59cca225035e$export$453843f36861c0a2;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($cc2a59cca225035e$export$453843f36861c0a2 || ($cc2a59cca225035e$export$453843f36861c0a2 = {}));
const $cc2a59cca225035e$export$7a236fa930e45f72 = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */ const $cc2a59cca225035e$export$c36bbd48cffe7fa4 = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */ const $cc2a59cca225035e$export$c6bc4b7cffb2ca8 = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ const $cc2a59cca225035e$export$71a299b29e2098f0 = 300000;
/**
 * Default Time in milleseconds between monitoring checks of keep alive status
 */ const $cc2a59cca225035e$export$75c75dcdbe06fef4 = 5000;
/**
 * Default Time in milleseconds to alert for missed GQL_CONNECTION_KEEP_ALIVE message
 */ const $cc2a59cca225035e$export$2cb64c85846dde7d = 65000;
/**
 * Default delay time in milleseconds between when reconnect is triggered vs when it is attempted
 */ const $cc2a59cca225035e$export$6040e6f953ecf619 = 5000;
/**
 * Default interval time in milleseconds between when reconnect is re-attempted
 */ const $cc2a59cca225035e$export$6229bdb3fed88d41 = 60000;

});

parcelRegister("e7ubE", function(module, exports) {

$parcel$export(module.exports, "AWSWebSocketProvider", () => $71127e642c2cde6d$export$4098fdf2357c088f);

var $6OiYn = parcelRequire("6OiYn");

var $fHcz3 = parcelRequire("fHcz3");

var $gJw02 = parcelRequire("gJw02");
var $5RCQ5 = parcelRequire("5RCQ5");

var $5RCQ5 = parcelRequire("5RCQ5");
var $3jt4M = parcelRequire("3jt4M");
var $ijwDq = parcelRequire("ijwDq");
var $g2b7y = parcelRequire("g2b7y");
var $01Ziv = parcelRequire("01Ziv");
var $i62vd = parcelRequire("i62vd");

var $OwgYH = parcelRequire("OwgYH");

var $fuDKT = parcelRequire("fuDKT");

var $7LQNq = parcelRequire("7LQNq");

var $bDWoz = parcelRequire("bDWoz");

var $gfTKe = parcelRequire("gfTKe");

var $1DlsO = parcelRequire("1DlsO");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $71127e642c2cde6d$var$dispatchApiEvent = (payload)=>{
    (0, $5RCQ5.Hub).dispatch("api", payload, "PubSub", (0, $5RCQ5.AMPLIFY_SYMBOL));
};
class $71127e642c2cde6d$export$4098fdf2357c088f {
    constructor(args){
        this.subscriptionObserverMap = new Map();
        this.allowNoSubscriptions = false;
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
        this.keepAliveTimestamp = Date.now();
        this.promiseArray = [];
        this.connectionStateMonitor = new (0, $7LQNq.ConnectionStateMonitor)();
        this.reconnectionMonitor = new (0, $bDWoz.ReconnectionMonitor)();
        /**
         * Open WebSocket connection & perform handshake
         * Ref: https://docs.aws.amazon.com/appsync/latest/devguide/real-time-websocket-client.html#appsynclong-real-time-websocket-client-implementation-guide-for-graphql-subscriptions
         *
         * @param subprotocol -
         */ this._establishConnection = async (awsRealTimeUrl, subprotocol)=>{
            this.logger.debug(`Establishing WebSocket connection to ${awsRealTimeUrl}`);
            try {
                await this._openConnection(awsRealTimeUrl, subprotocol);
                await this._initiateHandshake();
            } catch (err) {
                const { errorType: errorType, errorCode: errorCode } = err;
                if ((0, $fuDKT.NON_RETRYABLE_CODES).includes(errorCode) || // Event API does not currently return `errorCode`. This may change in the future.
                // For now fall back to also checking known non-retryable error types
                (0, $fuDKT.NON_RETRYABLE_ERROR_TYPES).includes(errorType)) throw new (0, $i62vd.NonRetryableError)(errorType);
                else if (errorType) throw new Error(errorType);
                else throw err;
            }
        };
        this.logger = new (0, $gJw02.ConsoleLogger)(args.providerName);
        this.wsProtocolName = args.wsProtocolName;
        this.wsConnectUri = args.connectUri;
        this.connectionStateMonitorSubscription = this._startConnectionStateMonitoring();
    }
    /**
     * Mark the socket closed and release all active listeners
     */ close() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
        return new Promise((resolve, reject)=>{
            if (this.awsRealTimeSocket) {
                this.awsRealTimeSocket.onclose = (_)=>{
                    this._closeSocket();
                    this.subscriptionObserverMap = new Map();
                    this.awsRealTimeSocket = undefined;
                    resolve();
                };
                this.awsRealTimeSocket.onerror = (err)=>{
                    reject(err);
                };
                this.awsRealTimeSocket.close();
            } else resolve();
        });
    }
    subscribe(options, customUserAgentDetails) {
        return new (0, $6OiYn.Observable)((observer)=>{
            if (!options?.appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        {
                            ...new (0, $fHcz3.GraphQLError)(`Subscribe only available for AWS AppSync endpoint`)
                        }
                    ]
                });
                observer.complete();
                return;
            }
            let subscriptionStartInProgress = false;
            const subscriptionId = (0, $3jt4M.amplifyUuid)();
            const startSubscription = ()=>{
                if (!subscriptionStartInProgress) {
                    subscriptionStartInProgress = true;
                    this._startSubscriptionWithAWSAppSyncRealTime({
                        options: options,
                        observer: observer,
                        subscriptionId: subscriptionId,
                        customUserAgentDetails: customUserAgentDetails
                    }).catch((err)=>{
                        this.logger.debug(`${(0, $OwgYH.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR}: ${err}`);
                        this._closeSocket();
                    }).finally(()=>{
                        subscriptionStartInProgress = false;
                    });
                }
            };
            // Add an observable to the reconnection list to manage reconnection for this subscription
            const reconnectSubscription = new (0, $6OiYn.Observable)((reconnectSubscriptionObserver)=>{
                this.reconnectionMonitor.addObserver(reconnectSubscriptionObserver);
            }).subscribe(()=>{
                startSubscription();
            });
            startSubscription();
            return async ()=>{
                await this._cleanupSubscription(subscriptionId, reconnectSubscription);
            };
        });
    }
    async connect(options) {
        if (this.socketStatus === (0, $fuDKT.SOCKET_STATUS).READY) return;
        await this._connectWebSocket(options);
    }
    async publish(options, customUserAgentDetails) {
        if (this.socketStatus !== (0, $fuDKT.SOCKET_STATUS).READY) throw new Error("Subscription has not been initialized");
        return this._publishMessage(options, customUserAgentDetails);
    }
    async _connectWebSocket(options) {
        const { apiKey: apiKey, appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, authenticationType: authenticationType, region: region } = options;
        const { additionalCustomHeaders: additionalCustomHeaders } = await (0, $gfTKe.additionalHeadersFromOptions)(options);
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).OPENING_CONNECTION);
        await this._initializeWebSocketConnection({
            apiKey: apiKey,
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            region: region,
            additionalCustomHeaders: additionalCustomHeaders
        });
    }
    async _publishMessage(options, customUserAgentDetails) {
        const subscriptionId = (0, $3jt4M.amplifyUuid)();
        const { additionalCustomHeaders: additionalCustomHeaders, libraryConfigHeaders: libraryConfigHeaders } = await (0, $gfTKe.additionalHeadersFromOptions)(options);
        const serializedSubscriptionMessage = await this._prepareSubscriptionPayload({
            options: options,
            subscriptionId: subscriptionId,
            customUserAgentDetails: customUserAgentDetails,
            additionalCustomHeaders: additionalCustomHeaders,
            libraryConfigHeaders: libraryConfigHeaders,
            publish: true
        });
        return new Promise((resolve, reject)=>{
            if (this.awsRealTimeSocket) {
                const publishListener = (event)=>{
                    const data = JSON.parse(event.data);
                    if (data.id === subscriptionId && data.type === "publish_success") {
                        this.awsRealTimeSocket && this.awsRealTimeSocket.removeEventListener("message", publishListener);
                        cleanup();
                        resolve();
                    }
                    if (data.errors && data.errors.length > 0) {
                        const errorTypes = data.errors.map((error)=>error.errorType);
                        cleanup();
                        reject(new Error(`Publish errors: ${errorTypes.join(", ")}`));
                    }
                };
                const errorListener = (error)=>{
                    cleanup();
                    reject(new Error(`WebSocket error: ${error}`));
                };
                const closeListener = ()=>{
                    cleanup();
                    reject(new Error("WebSocket is closed"));
                };
                const cleanup = ()=>{
                    this.awsRealTimeSocket?.removeEventListener("message", publishListener);
                    this.awsRealTimeSocket?.removeEventListener("error", errorListener);
                    this.awsRealTimeSocket?.removeEventListener("close", closeListener);
                };
                this.awsRealTimeSocket.addEventListener("message", publishListener);
                this.awsRealTimeSocket.addEventListener("error", errorListener);
                this.awsRealTimeSocket.addEventListener("close", closeListener);
                this.awsRealTimeSocket.send(serializedSubscriptionMessage);
            } else reject(new Error("WebSocket is not connected"));
        });
    }
    async _cleanupSubscription(subscriptionId, reconnectSubscription) {
        // Cleanup reconnection subscription
        reconnectSubscription?.unsubscribe();
        // Cleanup after unsubscribing or observer.complete was called after _startSubscriptionWithAWSAppSyncRealTime
        try {
            // Waiting that subscription has been connected before trying to unsubscribe
            await this._waitForSubscriptionToBeConnected(subscriptionId);
            const { subscriptionState: subscriptionState } = this.subscriptionObserverMap.get(subscriptionId) || {};
            if (!subscriptionState) // subscription already unsubscribed
            return;
            if (subscriptionState === (0, $fuDKT.SUBSCRIPTION_STATUS).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId);
            else throw new Error("Subscription never connected");
        } catch (err) {
            this.logger.debug(`Error while unsubscribing ${err}`);
        } finally{
            this._removeSubscriptionObserver(subscriptionId);
        }
    }
    // Monitor the connection state and pass changes along to Hub
    _startConnectionStateMonitoring() {
        return this.connectionStateMonitor.connectionStateObservable.subscribe((connectionState)=>{
            $71127e642c2cde6d$var$dispatchApiEvent({
                event: (0, $fuDKT.CONNECTION_STATE_CHANGE),
                data: {
                    provider: this,
                    connectionState: connectionState
                },
                message: `Connection state is ${connectionState}`
            });
            this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, $OwgYH.ConnectionState).ConnectionDisrupted) this.reconnectionMonitor.record((0, $bDWoz.ReconnectEvent).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            // ConnectionDisrupted or Connecting
            if ([
                (0, $OwgYH.ConnectionState).Connected,
                (0, $OwgYH.ConnectionState).ConnectedPendingDisconnect,
                (0, $OwgYH.ConnectionState).ConnectedPendingKeepAlive,
                (0, $OwgYH.ConnectionState).ConnectedPendingNetwork,
                (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork,
                (0, $OwgYH.ConnectionState).Disconnected
            ].includes(connectionState)) this.reconnectionMonitor.record((0, $bDWoz.ReconnectEvent).HALT_RECONNECT);
        });
    }
    async _startSubscriptionWithAWSAppSyncRealTime({ options: options, observer: observer, subscriptionId: subscriptionId, customUserAgentDetails: customUserAgentDetails }) {
        const { query: query, variables: variables } = options;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query ?? "",
            variables: variables ?? {},
            subscriptionState: (0, $fuDKT.SUBSCRIPTION_STATUS).PENDING,
            startAckTimeoutId: undefined
        });
        const { additionalCustomHeaders: additionalCustomHeaders, libraryConfigHeaders: libraryConfigHeaders } = await (0, $gfTKe.additionalHeadersFromOptions)(options);
        const serializedSubscriptionMessage = await this._prepareSubscriptionPayload({
            options: options,
            subscriptionId: subscriptionId,
            customUserAgentDetails: customUserAgentDetails,
            additionalCustomHeaders: additionalCustomHeaders,
            libraryConfigHeaders: libraryConfigHeaders
        });
        try {
            await this._connectWebSocket(options);
        } catch (err) {
            this._logStartSubscriptionError(subscriptionId, observer, err);
            return;
        }
        // Potential race condition can occur when unsubscribe is called during _initializeWebSocketConnection.
        // E.g.unsubscribe gets invoked prior to finishing WebSocket handshake or START_ACK.
        // Both subscriptionFailedCallback and subscriptionReadyCallback are used to synchronized this.
        const { subscriptionFailedCallback: subscriptionFailedCallback, subscriptionReadyCallback: subscriptionReadyCallback } = this.subscriptionObserverMap.get(subscriptionId) ?? {};
        // This must be done before sending the message in order to be listening immediately
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            subscriptionState: (0, $fuDKT.SUBSCRIPTION_STATUS).PENDING,
            query: query ?? "",
            variables: variables ?? {},
            subscriptionReadyCallback: subscriptionReadyCallback,
            subscriptionFailedCallback: subscriptionFailedCallback,
            startAckTimeoutId: setTimeout(()=>{
                this._timeoutStartSubscriptionAck(subscriptionId);
            }, (0, $fuDKT.START_ACK_TIMEOUT))
        });
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(serializedSubscriptionMessage);
    }
    // Log logic for start subscription failures
    _logStartSubscriptionError(subscriptionId, observer, err) {
        this.logger.debug({
            err: err
        });
        const message = String(err.message ?? "");
        // Resolving to give the state observer time to propogate the update
        this._closeSocket();
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, $g2b7y.isNonRetryableError)(err)) observer.error({
                errors: [
                    {
                        ...new (0, $fHcz3.GraphQLError)(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${message}`)
                    }
                ]
            });
            else this.logger.debug(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${message}`);
            const { subscriptionFailedCallback: subscriptionFailedCallback } = this.subscriptionObserverMap.get(subscriptionId) || {};
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    }
    // Waiting that subscription has been connected before trying to unsubscribe
    async _waitForSubscriptionToBeConnected(subscriptionId) {
        const subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            const { subscriptionState: subscriptionState } = subscriptionObserver;
            // This in case unsubscribe is invoked before sending start subscription message
            if (subscriptionState === (0, $fuDKT.SUBSCRIPTION_STATUS).PENDING) return new Promise((resolve, reject)=>{
                const { observer: observer, subscriptionState: observedSubscriptionState, variables: variables, query: query } = subscriptionObserver;
                this.subscriptionObserverMap.set(subscriptionId, {
                    observer: observer,
                    subscriptionState: observedSubscriptionState,
                    variables: variables,
                    query: query,
                    subscriptionReadyCallback: resolve,
                    subscriptionFailedCallback: reject
                });
            });
        }
    }
    _sendUnsubscriptionMessage(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, $fuDKT.SOCKET_STATUS).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                const unsubscribeMessage = this._unsubscribeMessage(subscriptionId);
                const stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            this.logger.debug({
                err: err
            });
        }
    }
    _removeSubscriptionObserver(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        if (!this.allowNoSubscriptions) setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    }
    _closeSocketIfRequired() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            this.logger.debug("closing WebSocket...");
            const tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            this._closeSocket();
        }
    }
    maintainKeepAlive() {
        this.keepAliveTimestamp = Date.now();
    }
    keepAliveHeartbeat(connectionTimeoutMs) {
        const currentTime = Date.now();
        // Check for missed KA message
        if (currentTime - this.keepAliveTimestamp > (0, $fuDKT.DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT)) this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).KEEP_ALIVE_MISSED);
        else this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).KEEP_ALIVE);
        // Recognize we are disconnected if we haven't seen messages in the keep alive timeout period
        if (currentTime - this.keepAliveTimestamp > connectionTimeoutMs) this._errorDisconnect((0, $OwgYH.CONTROL_MSG).TIMEOUT_DISCONNECT);
    }
    _handleIncomingSubscriptionMessage(message) {
        if (typeof message.data !== "string") return;
        const [isData, data] = this._handleSubscriptionData(message);
        if (isData) {
            this.maintainKeepAlive();
            return;
        }
        const { type: type, id: id, payload: payload } = data;
        const { observer: observer = null, query: query = "", variables: variables = {}, startAckTimeoutId: startAckTimeoutId, subscriptionReadyCallback: subscriptionReadyCallback, subscriptionFailedCallback: subscriptionFailedCallback } = this.subscriptionObserverMap.get(id) || {};
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_START_ACK || type === (0, $fuDKT.MESSAGE_TYPES).EVENT_SUBSCRIBE_ACK) {
            this.logger.debug(`subscription ready for ${JSON.stringify({
                query: query,
                variables: variables
            })}`);
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            $71127e642c2cde6d$var$dispatchApiEvent({
                event: (0, $OwgYH.CONTROL_MSG).SUBSCRIPTION_ACK,
                data: {
                    query: query,
                    variables: variables
                },
                message: "Connection established for subscription"
            });
            const subscriptionState = (0, $fuDKT.SUBSCRIPTION_STATUS).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_KEEP_ALIVE) {
            this.maintainKeepAlive();
            return;
        }
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_ERROR || type === (0, $fuDKT.MESSAGE_TYPES).EVENT_SUBSCRIBE_ERROR) {
            const subscriptionState = (0, $fuDKT.SUBSCRIPTION_STATUS).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                let errorMessage = JSON.stringify(payload ?? data);
                let isAuthError = false;
                const AUTH_ERROR_TYPES = [
                    "UnauthorizedException",
                    "Unauthorized",
                    "NotAuthorizedException"
                ];
                if (type === (0, $fuDKT.MESSAGE_TYPES).EVENT_SUBSCRIBE_ERROR) {
                    const { errors: errors } = JSON.parse(String(message.data));
                    if (Array.isArray(errors) && errors.length > 0) {
                        const error = errors[0];
                        errorMessage = `${error.errorType}: ${error.message}`;
                        isAuthError = AUTH_ERROR_TYPES.includes(error.errorType) || error.message?.includes("Token expired");
                    }
                } else if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_ERROR && payload && typeof payload === "object") {
                    const { errors: errors } = payload;
                    if (Array.isArray(errors) && errors.length > 0) {
                        const error = errors[0];
                        isAuthError = AUTH_ERROR_TYPES.includes(error.errorType) || error.message?.includes("Token expired");
                    }
                }
                this.logger.debug(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${errorMessage}`);
                // On auth errors, close the socket to trigger reconnection with fresh tokens.
                // The onclose handler fires _errorDisconnect → CONNECTION_CLOSED, which the
                // ConnectionStateMonitor picks up as ConnectionDisrupted and the
                // ReconnectionMonitor reconnects with refreshed credentials.
                if (isAuthError && this.awsRealTimeSocket) {
                    this.logger.warn("Subscription failed due to auth error, closing WebSocket to trigger reconnection with fresh tokens");
                    this.awsRealTimeSocket.close(1000, "Auth error - reconnecting");
                }
                observer.error({
                    errors: [
                        {
                            ...new (0, $fHcz3.GraphQLError)(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${errorMessage}`)
                        }
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
            }
        }
    }
    _errorDisconnect(msg) {
        this.logger.debug(`Disconnect error: ${msg}`);
        if (this.awsRealTimeSocket) {
            this._closeSocket();
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
    }
    _closeSocket() {
        if (this.keepAliveHeartbeatIntervalId) {
            clearInterval(this.keepAliveHeartbeatIntervalId);
            this.keepAliveHeartbeatIntervalId = undefined;
        }
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED);
    }
    _timeoutStartSubscriptionAck(subscriptionId) {
        const subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            const { observer: observer, query: query, variables: variables } = subscriptionObserver;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, $fuDKT.SUBSCRIPTION_STATUS).FAILED
            });
            this._closeSocket();
            this.logger.debug("timeoutStartSubscription", JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    }
    _initializeWebSocketConnection({ appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, authenticationType: authenticationType, apiKey: apiKey, region: region, additionalCustomHeaders: additionalCustomHeaders }) {
        if (this.socketStatus === (0, $fuDKT.SOCKET_STATUS).READY) return;
        // TODO(Eslint): refactor to now use async function as the promise executor
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            this.promiseArray.push({
                res: resolve,
                rej: reject
            });
            if (this.socketStatus === (0, $fuDKT.SOCKET_STATUS).CLOSED) try {
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CONNECTING;
                // Empty payload on connect
                const payloadString = "{}";
                const authHeader = await (0, $1DlsO.awsRealTimeHeaderBasedAuth)({
                    authenticationType: authenticationType,
                    payload: payloadString,
                    canonicalUri: this.wsConnectUri,
                    apiKey: apiKey,
                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                    region: region,
                    additionalCustomHeaders: additionalCustomHeaders
                });
                const headerString = authHeader ? JSON.stringify(authHeader) : "";
                // base64url-encoded string
                const encodedHeader = (0, $ijwDq.base64Encoder).convert(headerString, {
                    urlSafe: true,
                    skipPadding: true
                });
                const authTokenSubprotocol = `header-${encodedHeader}`;
                const queryParams = (0, $gfTKe.queryParamsFromCustomHeaders)(additionalCustomHeaders);
                const awsRealTimeUrl = (0, $gfTKe.realtimeUrlWithQueryString)(appSyncGraphqlEndpoint, queryParams);
                await this._establishRetryableConnection(awsRealTimeUrl, authTokenSubprotocol);
                this.promiseArray.forEach(({ res: res })=>{
                    this.logger.debug("Notifying connection successful");
                    res();
                });
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).READY;
                this.promiseArray = [];
            } catch (err) {
                this.logger.debug("Connection exited with", err);
                this.promiseArray.forEach(({ rej: rej })=>{
                    rej(err);
                });
                this.promiseArray = [];
                if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                this.awsRealTimeSocket = undefined;
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            }
        });
    }
    async _establishRetryableConnection(awsRealTimeUrl, subprotocol) {
        this.logger.debug(`Establishing retryable connection`);
        await (0, $01Ziv.jitteredExponentialRetry)(this._establishConnection.bind(this), [
            awsRealTimeUrl,
            subprotocol
        ], (0, $fuDKT.MAX_DELAY_MS));
    }
    async _openConnection(awsRealTimeUrl, subprotocol) {
        return new Promise((resolve, reject)=>{
            const newSocket = this._getNewWebSocket(awsRealTimeUrl, [
                this.wsProtocolName,
                subprotocol
            ]);
            newSocket.onerror = ()=>{
                this.logger.debug(`WebSocket connection error`);
            };
            newSocket.onclose = ()=>{
                this._closeSocket();
                reject(new Error("Connection handshake error"));
            };
            newSocket.onopen = ()=>{
                this.awsRealTimeSocket = newSocket;
                resolve();
            };
        });
    }
    _getNewWebSocket(url, protocol) {
        return new WebSocket(url, protocol);
    }
    async _initiateHandshake() {
        return new Promise((resolve, reject)=>{
            if (!this.awsRealTimeSocket) {
                reject(new Error("awsRealTimeSocket undefined"));
                return;
            }
            let ackOk = false;
            this.awsRealTimeSocket.onerror = (error)=>{
                this.logger.debug(`WebSocket error ${JSON.stringify(error)}`);
            };
            this.awsRealTimeSocket.onclose = (event)=>{
                this.logger.debug(`WebSocket closed ${event.reason}`);
                this._closeSocket();
                reject(new Error(JSON.stringify(event)));
            };
            this.awsRealTimeSocket.onmessage = (message)=>{
                if (typeof message.data !== "string") return;
                this.logger.debug(`subscription message from AWS AppSyncRealTime: ${message.data} `);
                const data = JSON.parse(message.data);
                const { type: type } = data;
                const connectionTimeoutMs = this._extractConnectionTimeout(data);
                if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_ACK) {
                    ackOk = true;
                    this._registerWebsocketHandlers(connectionTimeoutMs);
                    resolve("Connected to AWS AppSyncRealTime");
                    return;
                }
                if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_ERROR) {
                    const { errorType: errorType, errorCode: errorCode } = this._extractErrorCodeAndType(data);
                    // TODO(Eslint): refactor to reject an Error object instead of a plain object
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject({
                        errorType: errorType,
                        errorCode: errorCode
                    });
                }
            };
            const gqlInit = {
                type: (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_INIT
            };
            this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
            const checkAckOk = (targetAckOk)=>{
                if (!targetAckOk) {
                    this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_FAILED);
                    reject(new Error(`Connection timeout: ack from AWSAppSyncRealTime was not received after ${(0, $fuDKT.CONNECTION_INIT_TIMEOUT)} ms`));
                }
            };
            setTimeout(()=>{
                checkAckOk(ackOk);
            }, (0, $fuDKT.CONNECTION_INIT_TIMEOUT));
        });
    }
    _registerWebsocketHandlers(connectionTimeoutMs) {
        if (!this.awsRealTimeSocket) return;
        // Set up a keep alive heartbeat for this connection
        this.keepAliveHeartbeatIntervalId = setInterval(()=>{
            this.keepAliveHeartbeat(connectionTimeoutMs);
        }, (0, $fuDKT.DEFAULT_KEEP_ALIVE_HEARTBEAT_TIMEOUT));
        this.awsRealTimeSocket.onmessage = this._handleIncomingSubscriptionMessage.bind(this);
        this.awsRealTimeSocket.onerror = (err)=>{
            this.logger.debug(err);
            this._errorDisconnect((0, $OwgYH.CONTROL_MSG).CONNECTION_CLOSED);
        };
        this.awsRealTimeSocket.onclose = (event)=>{
            this.logger.debug(`WebSocket closed ${event.reason}`);
            this._closeSocket();
            this._errorDisconnect((0, $OwgYH.CONTROL_MSG).CONNECTION_CLOSED);
        };
    }
}

});
parcelRegister("ijwDq", function(module, exports) {

$parcel$export(module.exports, "base64Encoder", () => $a67be9353d05d3e6$export$695b149896bd3e2a);

var $dfMUF = parcelRequire("dfMUF");

var $1AT8d = parcelRequire("1AT8d");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a67be9353d05d3e6$export$695b149896bd3e2a = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $1AT8d.bytesToString)(input);
        let encodedStr = (0, $dfMUF.getBtoa)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, "-").replace(/\//g, "_");
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, "");
        return encodedStr;
    }
};

});
parcelRegister("1AT8d", function(module, exports) {

$parcel$export(module.exports, "bytesToString", () => $2388b4cedba94ebc$export$7c746b75f47c9c7d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $2388b4cedba94ebc$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}

});


parcelRegister("g2b7y", function(module, exports) {

$parcel$export(module.exports, "isNonRetryableError", () => $e8dbabe11e4625cd$export$490cab1f6f83794d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e8dbabe11e4625cd$export$490cab1f6f83794d = (obj)=>{
    const key = "nonRetryable";
    return obj && obj[key];
};

});

parcelRegister("01Ziv", function(module, exports) {

$parcel$export(module.exports, "jitteredExponentialRetry", () => $dc95ff395620ab33$export$a24aa7705df9cf44);

var $1Ns4m = parcelRequire("1Ns4m");

var $h05tY = parcelRequire("h05tY");

var $1jQno = parcelRequire("1jQno");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ const $dc95ff395620ab33$export$a24aa7705df9cf44 = (functionToRetry, args, maxDelayMs = (0, $1Ns4m.MAX_DELAY_MS), onTerminate)=>(0, $1jQno.retry)(functionToRetry, args, (0, $h05tY.jitteredBackoff)(maxDelayMs), onTerminate);

});
parcelRegister("1jQno", function(module, exports) {

$parcel$export(module.exports, "retry", () => $3640de013fea6a9b$export$9369b12211e1fce4);

var $gJw02 = parcelRequire("gJw02");

var $g2b7y = parcelRequire("g2b7y");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3640de013fea6a9b$var$logger = new (0, $gJw02.ConsoleLogger)("retryUtil");
/**
 * @private
 * Internal use of Amplify only
 */ async function $3640de013fea6a9b$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    // TODO(eslint): remove this linter suppression with refactoring.
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject)=>{
        let attempt = 0;
        let terminated = false;
        let timeout;
        let wakeUp = ()=>{
        // no-op
        }; // will be replaced with a resolver()
        // used after the loop if terminated while waiting for a timer.
        let lastError;
        onTerminate && onTerminate.then(()=>{
            // signal not to try anymore.
            terminated = true;
            // stop sleeping if we're sleeping.
            clearTimeout(timeout);
            wakeUp();
        });
        // TODO(eslint): remove this linter suppression with refactoring.
        // eslint-disable-next-line no-unmodified-loop-condition
        while(!terminated){
            attempt++;
            $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} attempt #${attempt} with this vars: ${JSON.stringify(args)}`);
            try {
                resolve(await functionToRetry(...args));
                return;
            } catch (err) {
                lastError = err;
                $3640de013fea6a9b$var$logger.debug(`error on ${functionToRetry.name}`, err);
                if ((0, $g2b7y.isNonRetryableError)(err)) {
                    $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} non retryable error`, err);
                    reject(err);
                    return;
                }
                const retryIn = delayFn(attempt, args, err);
                $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} retrying in ${retryIn} ms`);
                // we check `terminated` again here because it could have flipped
                // in the time it took `functionToRetry` to return.
                if (retryIn === false || terminated) {
                    reject(err);
                    return;
                } else await new Promise((_resolve)=>{
                    wakeUp = _resolve; // export wakeUp for onTerminate handling
                    timeout = setTimeout(wakeUp, retryIn);
                });
            }
        }
        // reached if terminated while waiting for a timer.
        reject(lastError);
    });
}

});


parcelRegister("i62vd", function(module, exports) {

$parcel$export(module.exports, "NonRetryableError", () => $4a5528a46d771b76$export$1e38badc838ad384);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $4a5528a46d771b76$export$1e38badc838ad384 extends Error {
    constructor(){
        super(...arguments);
        this.nonRetryable = true;
    }
}

});

parcelRegister("OwgYH", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", () => $e94925d7f6d2ab83$export$f96baa4bc836aea4);
$parcel$export(module.exports, "ConnectionState", () => $e94925d7f6d2ab83$export$cd9c3c6bf535afc9);
var $e94925d7f6d2ab83$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($e94925d7f6d2ab83$export$f96baa4bc836aea4 || ($e94925d7f6d2ab83$export$f96baa4bc836aea4 = {}));
/** @enum {string} */ var $e94925d7f6d2ab83$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})($e94925d7f6d2ab83$export$cd9c3c6bf535afc9 || ($e94925d7f6d2ab83$export$cd9c3c6bf535afc9 = {}));

});

parcelRegister("7LQNq", function(module, exports) {

$parcel$export(module.exports, "CONNECTION_CHANGE", () => $69f8b000bf003237$export$77ad93647ea34124);
$parcel$export(module.exports, "ConnectionStateMonitor", () => $69f8b000bf003237$export$d8916ed266c478dd);

var $d6DLj = parcelRequire("d6DLj");
var $d4PzE = parcelRequire("d4PzE");
var $6OiYn = parcelRequire("6OiYn");

var $OwgYH = parcelRequire("OwgYH");

var $3cx2X = parcelRequire("3cx2X");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69f8b000bf003237$export$77ad93647ea34124 = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: "unhealthy"
    },
    KEEP_ALIVE: {
        keepAliveState: "healthy"
    },
    CONNECTION_ESTABLISHED: {
        connectionState: "connected"
    },
    CONNECTION_FAILED: {
        intendedConnectionState: "disconnected",
        connectionState: "disconnected"
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: "disconnected"
    },
    OPENING_CONNECTION: {
        intendedConnectionState: "connected",
        connectionState: "connecting"
    },
    CLOSED: {
        connectionState: "disconnected"
    },
    ONLINE: {
        networkState: "connected"
    },
    OFFLINE: {
        networkState: "disconnected"
    }
};
class $69f8b000bf003237$export$d8916ed266c478dd {
    constructor(){
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: "connected",
            connectionState: "disconnected",
            intendedConnectionState: "disconnected",
            keepAliveState: "healthy"
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, $3cx2X.ReachabilityMonitor)().subscribe(({ online: online })=>{
            this.record(online ? $69f8b000bf003237$export$77ad93647ea34124.ONLINE : $69f8b000bf003237$export$77ad93647ea34124.OFFLINE);
            this._initialNetworkStateSubscription?.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, $6OiYn.Observable)((connectionStateObserver)=>{
            connectionStateObserver.next(this._linkedConnectionState);
            this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ enableNetworkMonitoring() {
        // If no initial network state was discovered, stop trying
        this._initialNetworkStateSubscription?.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, $3cx2X.ReachabilityMonitor)().subscribe(({ online: online })=>{
            this.record(online ? $69f8b000bf003237$export$77ad93647ea34124.ONLINE : $69f8b000bf003237$export$77ad93647ea34124.OFFLINE);
        });
    }
    /**
     * Turn network state monitoring off if it isn't off already
     */ disableNetworkMonitoring() {
        this._networkMonitoringSubscription?.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    }
    /**
     * Get the observable that allows us to monitor the connection state
     *
     * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
     */ get connectionStateObservable() {
        let previous;
        // The linked state aggregates state changes to any of the network, connection,
        // intendedConnection and keepAliveHealth. Some states will change these independent
        // states without changing the overall connection state.
        // After translating from linked states to ConnectionState, then remove any duplicates
        return this._linkedConnectionStateObservable.pipe((0, $d4PzE.map)((value)=>{
            return this.connectionStatesTranslator(value);
        })).pipe((0, $d6DLj.filter)((current)=>{
            const toInclude = current !== previous;
            previous = current;
            return toInclude;
        }));
    }
    /*
     * Updates local connection state and emits the full state to the observer.
     */ record(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === "connected") this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === "disconnected") this.disableNetworkMonitoring();
        // Maintain the socket state
        const newSocketStatus = {
            ...this._linkedConnectionState,
            ...statusUpdates
        };
        this._linkedConnectionState = {
            ...newSocketStatus
        };
        this._linkedConnectionStateObserver?.next(this._linkedConnectionState);
    }
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ connectionStatesTranslator({ connectionState: connectionState, networkState: networkState, intendedConnectionState: intendedConnectionState, keepAliveState: keepAliveState }) {
        if (connectionState === "connected" && networkState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectedPendingNetwork;
        if (connectionState === "connected" && intendedConnectionState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectedPendingDisconnect;
        if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork;
        if (connectionState === "disconnected" && intendedConnectionState === "connected") return (0, $OwgYH.ConnectionState).ConnectionDisrupted;
        if (connectionState === "connected" && keepAliveState === "unhealthy") return (0, $OwgYH.ConnectionState).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === "connecting") return (0, $OwgYH.ConnectionState).Connecting;
        if (connectionState === "disconnected") return (0, $OwgYH.ConnectionState).Disconnected;
        return (0, $OwgYH.ConnectionState).Connected;
    }
}

});
parcelRegister("d6DLj", function(module, exports) {

$parcel$export(module.exports, "filter", () => $98aaadcfa91e6727$export$3dea766d36a8935f);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("3cx2X", function(module, exports) {

$parcel$export(module.exports, "ReachabilityMonitor", () => $e84318ed5419b5d0$export$2636160e319be4f9);

var $apURp = parcelRequire("apURp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e84318ed5419b5d0$export$2636160e319be4f9 = ()=>new (0, $apURp.Reachability)().networkMonitor();

});
parcelRegister("apURp", function(module, exports) {

$parcel$export(module.exports, "Reachability", () => $c2db73d795074c30$export$ccee288f4c11aa98);

var $46Tqd = parcelRequire("46Tqd");
var $6OiYn = parcelRequire("6OiYn");




var $lt7Sl = parcelRequire("lt7Sl");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $c2db73d795074c30$export$ccee288f4c11aa98 {
    networkMonitor(_) {
        const globalObj = (0, $lt7Sl.isWebWorker)() ? self : typeof window !== "undefined" && window;
        if (!globalObj) return (0, $46Tqd.from)([
            {
                online: true
            }
        ]);
        return new (0, $6OiYn.Observable)((observer)=>{
            observer.next({
                online: globalObj.navigator.onLine
            });
            const notifyOnline = ()=>{
                observer.next({
                    online: true
                });
            };
            const notifyOffline = ()=>{
                observer.next({
                    online: false
                });
            };
            globalObj.addEventListener("online", notifyOnline);
            globalObj.addEventListener("offline", notifyOffline);
            $c2db73d795074c30$export$ccee288f4c11aa98._observers.push(observer);
            return ()=>{
                globalObj.removeEventListener("online", notifyOnline);
                globalObj.removeEventListener("offline", notifyOffline);
                $c2db73d795074c30$export$ccee288f4c11aa98._observers = $c2db73d795074c30$export$ccee288f4c11aa98._observers.filter((_observer)=>_observer !== observer);
            };
        });
    }
    // expose observers to simulate offline mode for integration testing
    static _observerOverride(status) {
        for (const observer of this._observers){
            if (observer.closed) {
                this._observers = this._observers.filter((_observer)=>_observer !== observer);
                continue;
            }
            observer?.next && observer.next(status);
        }
    }
}
$c2db73d795074c30$export$ccee288f4c11aa98._observers = [];

});
parcelRegister("46Tqd", function(module, exports) {

$parcel$export(module.exports, "from", () => $2fe2b696577919a5$export$6788812c4e6611e6);

var $ci5Ul = parcelRequire("ci5Ul");

var $2ypWW = parcelRequire("2ypWW");
function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $ci5Ul.scheduled)(input, scheduler) : (0, $2ypWW.innerFrom)(input);
}

});
parcelRegister("ci5Ul", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $8f2bbfa9b5105688$export$49c44dfc2bb21d70);

var $jxGcZ = parcelRequire("jxGcZ");

var $aS4Ip = parcelRequire("aS4Ip");

var $16Erw = parcelRequire("16Erw");

var $4ZsdA = parcelRequire("4ZsdA");

var $i3S70 = parcelRequire("i3S70");

var $rOw2q = parcelRequire("rOw2q");

var $dy1jD = parcelRequire("dy1jD");

var $bGCU7 = parcelRequire("bGCU7");

var $fQMll = parcelRequire("fQMll");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $7gZl2 = parcelRequire("7gZl2");

var $arhob = parcelRequire("arhob");
function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return (0, $jxGcZ.scheduleObservable)(input, scheduler);
        if ((0, $bGCU7.isArrayLike)(input)) return (0, $16Erw.scheduleArray)(input, scheduler);
        if ((0, $dy1jD.isPromise)(input)) return (0, $aS4Ip.schedulePromise)(input, scheduler);
        if ((0, $aGtFl.isAsyncIterable)(input)) return (0, $i3S70.scheduleAsyncIterable)(input, scheduler);
        if ((0, $fQMll.isIterable)(input)) return (0, $4ZsdA.scheduleIterable)(input, scheduler);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return (0, $arhob.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}

});
parcelRegister("jxGcZ", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $e3a1d71c442b5de9$export$ed8bd553a12b6a30);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});
parcelRegister("3blUb", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $25136415cad576bc$export$9007f49c319d1ac7);

var $4yU8l = parcelRequire("4yU8l");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});
parcelRegister("4yU8l", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $3525e15e439f8b93$export$a2b7447487315232);
function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});


parcelRegister("iNvbf", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $daf4fd612cb884aa$export$1eb44d8f5f64733b);

var $d9kQQ = parcelRequire("d9kQQ");
function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("aS4Ip", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $7ea29ae5d684fb04$export$fc9afd948577f0a8);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});

parcelRegister("16Erw", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $0ce5b91768be0a6d$export$b34673931371729a);

var $6OiYn = parcelRequire("6OiYn");
function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("4ZsdA", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $3a22bf76b9b6de63$export$2b75c58ab9b5b766);

var $6OiYn = parcelRequire("6OiYn");

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");

var $4yU8l = parcelRequire("4yU8l");
function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var iterator;
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $ZpNjd.iterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $gCSeg.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("i3S70", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $d2627b52a3f1ff1b$export$7c7f0979b56a32f3);

var $6OiYn = parcelRequire("6OiYn");

var $4yU8l = parcelRequire("4yU8l");
function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $6OiYn.Observable)(function(subscriber) {
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("arhob", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $7999ea1c5b71ad25$export$3385251aeecad28a);

var $i3S70 = parcelRequire("i3S70");

var $7gZl2 = parcelRequire("7gZl2");
function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $i3S70.scheduleAsyncIterable)((0, $7gZl2.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});



parcelRegister("lt7Sl", function(module, exports) {

$parcel$export(module.exports, "isWebWorker", () => $1f1375287e0673d4$export$97b87b8868ff7a3c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1f1375287e0673d4$export$97b87b8868ff7a3c = ()=>{
    if (typeof self === "undefined") return false;
    const selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};

});




parcelRegister("bDWoz", function(module, exports) {

$parcel$export(module.exports, "ReconnectEvent", () => $4197e818e967ca46$export$ce528341f93f43f1);
$parcel$export(module.exports, "ReconnectionMonitor", () => $4197e818e967ca46$export$6d01b279c51a2afb);

var $fuDKT = parcelRequire("fuDKT");
var $4197e818e967ca46$export$ce528341f93f43f1;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})($4197e818e967ca46$export$ce528341f93f43f1 || ($4197e818e967ca46$export$ce528341f93f43f1 = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ class $4197e818e967ca46$export$6d01b279c51a2afb {
    constructor(){
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ addObserver(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    }
    /**
     * Given a reconnect event, start the appropriate behavior
     */ record(event) {
        if (event === $4197e818e967ca46$export$ce528341f93f43f1.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(()=>{
                // Reconnect now
                this._triggerReconnect();
                // Retry reconnect every periodically until it works
                this.reconnectIntervalId = setInterval(()=>{
                    this._triggerReconnect();
                }, (0, $fuDKT.RECONNECT_INTERVAL));
            }, (0, $fuDKT.RECONNECT_DELAY));
        }
        if (event === $4197e818e967ca46$export$ce528341f93f43f1.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    }
    /**
     * Complete all reconnect observers
     */ close() {
        this.reconnectObservers.forEach((reconnectObserver)=>{
            reconnectObserver.complete?.();
        });
    }
    _triggerReconnect() {
        this.reconnectObservers.forEach((reconnectObserver)=>{
            reconnectObserver.next?.();
        });
    }
}

});

parcelRegister("gfTKe", function(module, exports) {

$parcel$export(module.exports, "queryParamsFromCustomHeaders", () => $9ca0eb4ce64626e9$export$487d35aa31cc4471);
$parcel$export(module.exports, "realtimeUrlWithQueryString", () => $9ca0eb4ce64626e9$export$2d5691170fc71c9a);
$parcel$export(module.exports, "additionalHeadersFromOptions", () => $9ca0eb4ce64626e9$export$2d67d7e4cd58f58a);

var $7Ar4G = parcelRequire("7Ar4G");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9ca0eb4ce64626e9$var$protocol = "wss://";
const $9ca0eb4ce64626e9$var$standardDomainPattern = /^https:\/\/\w{26}\.appsync-api\.\w{2}(?:(?:-\w{2,})+)-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
const $9ca0eb4ce64626e9$var$eventDomainPattern = /^https:\/\/\w{26}\.\w+-api\.\w{2}(?:(?:-\w{2,})+)-\d\.amazonaws.com(?:\.cn)?\/event$/i;
const $9ca0eb4ce64626e9$var$customDomainPath = "/realtime";
const $9ca0eb4ce64626e9$export$97f4c254b641e719 = (url)=>{
    return url.match($9ca0eb4ce64626e9$var$standardDomainPattern) === null;
};
const $9ca0eb4ce64626e9$var$isEventDomain = (url)=>url.match($9ca0eb4ce64626e9$var$eventDomainPattern) !== null;
const $9ca0eb4ce64626e9$export$aba033eb25bf30f1 = (appSyncGraphqlEndpoint)=>{
    let realtimeEndpoint = appSyncGraphqlEndpoint ?? "";
    if ($9ca0eb4ce64626e9$var$isEventDomain(realtimeEndpoint)) realtimeEndpoint = realtimeEndpoint.concat($9ca0eb4ce64626e9$var$customDomainPath).replace("ddpg-api", "grt-gamma").replace("appsync-api", "appsync-realtime-api");
    else if ($9ca0eb4ce64626e9$export$97f4c254b641e719(realtimeEndpoint)) realtimeEndpoint = realtimeEndpoint.concat($9ca0eb4ce64626e9$var$customDomainPath);
    else realtimeEndpoint = realtimeEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta").replace("ddpg-api", "grt-gamma");
    realtimeEndpoint = realtimeEndpoint.replace("https://", $9ca0eb4ce64626e9$var$protocol).replace("http://", $9ca0eb4ce64626e9$var$protocol);
    return new (0, $7Ar4G.AmplifyUrl)(realtimeEndpoint);
};
/**
 * Strips out `Authorization` header if present
 */ const $9ca0eb4ce64626e9$var$extractNonAuthHeaders = (headers)=>{
    if (!headers) return {};
    if ("Authorization" in headers) {
        const { Authorization: _, ...nonAuthHeaders } = headers;
        return nonAuthHeaders;
    }
    return headers;
};
/**
 *
 * @param headers - http headers
 * @returns uri-encoded query parameters derived from custom headers
 */ const $9ca0eb4ce64626e9$export$487d35aa31cc4471 = (headers)=>{
    const nonAuthHeaders = $9ca0eb4ce64626e9$var$extractNonAuthHeaders(headers);
    const params = new (0, $7Ar4G.AmplifyUrlSearchParams)();
    Object.entries(nonAuthHeaders).forEach(([k, v])=>{
        params.append(k, v);
    });
    return params;
};
/**
 * Normalizes AppSync realtime endpoint URL
 *
 * @param appSyncGraphqlEndpoint - AppSync endpointUri from config
 * @param urlParams - URLSearchParams
 * @returns fully resolved string realtime endpoint URL
 */ const $9ca0eb4ce64626e9$export$2d5691170fc71c9a = (appSyncGraphqlEndpoint, urlParams)=>{
    const realtimeEndpointUrl = $9ca0eb4ce64626e9$export$aba033eb25bf30f1(appSyncGraphqlEndpoint);
    // preserves any query params a customer might manually set in the configuration
    const existingParams = new (0, $7Ar4G.AmplifyUrlSearchParams)(realtimeEndpointUrl.search);
    for (const [k, v] of urlParams.entries())existingParams.append(k, v);
    realtimeEndpointUrl.search = existingParams.toString();
    return realtimeEndpointUrl.toString();
};
// TODO: move to separate file?
const $9ca0eb4ce64626e9$export$2d67d7e4cd58f58a = async (options)=>{
    const { appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, query: query, libraryConfigHeaders: libraryConfigHeaders = ()=>({}), additionalHeaders: additionalHeaders = {}, authToken: authToken } = options;
    let additionalCustomHeaders = {};
    const _libraryConfigHeaders = await libraryConfigHeaders();
    if (typeof additionalHeaders === "function") {
        const requestOptions = {
            url: appSyncGraphqlEndpoint || "",
            queryString: query || ""
        };
        additionalCustomHeaders = await additionalHeaders(requestOptions);
    } else additionalCustomHeaders = additionalHeaders;
    // if an authorization header is set, have the explicit, operation-level authToken take precedence
    if (authToken) additionalCustomHeaders = {
        ...additionalCustomHeaders,
        Authorization: authToken
    };
    return {
        additionalCustomHeaders: additionalCustomHeaders,
        libraryConfigHeaders: _libraryConfigHeaders
    };
};

});

parcelRegister("1DlsO", function(module, exports) {

$parcel$export(module.exports, "awsRealTimeHeaderBasedAuth", () => $2b4f19d8f4fc9e3f$export$25a3dd724dac7678);

var $gJw02 = parcelRequire("gJw02");
var $kwYKv = parcelRequire("kwYKv");

var $hVfGq = parcelRequire("hVfGq");

var $7Ar4G = parcelRequire("7Ar4G");

var $fuDKT = parcelRequire("fuDKT");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2b4f19d8f4fc9e3f$var$logger = new (0, $gJw02.ConsoleLogger)("AWSAppSyncRealTimeProvider Auth");
const $2b4f19d8f4fc9e3f$var$awsAuthTokenHeader = async ({ host: host })=>{
    const session = await (0, $kwYKv.fetchAuthSession)();
    return {
        Authorization: session?.tokens?.accessToken?.toString(),
        host: host
    };
};
const $2b4f19d8f4fc9e3f$var$awsRealTimeApiKeyHeader = async ({ apiKey: apiKey, host: host })=>{
    const dt = new Date();
    const dtStr = dt.toISOString().replace(/[:-]|\.\d{3}/g, "");
    return {
        host: host,
        "x-amz-date": dtStr,
        "x-api-key": apiKey
    };
};
const $2b4f19d8f4fc9e3f$var$awsRealTimeIAMHeader = async ({ payload: payload, canonicalUri: canonicalUri, appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, region: region })=>{
    const endpointInfo = {
        region: region,
        service: "appsync"
    };
    const creds = (await (0, $kwYKv.fetchAuthSession)()).credentials;
    const request = {
        url: `${appSyncGraphqlEndpoint}${canonicalUri}`,
        data: payload,
        method: "POST",
        headers: {
            ...(0, $fuDKT.AWS_APPSYNC_REALTIME_HEADERS)
        }
    };
    const signedParams = (0, $hVfGq.signRequest)({
        headers: request.headers,
        method: request.method,
        url: new (0, $7Ar4G.AmplifyUrl)(request.url),
        body: request.data
    }, {
        credentials: creds,
        signingRegion: endpointInfo.region,
        signingService: endpointInfo.service
    });
    return signedParams.headers;
};
const $2b4f19d8f4fc9e3f$var$customAuthHeader = async ({ host: host, additionalCustomHeaders: additionalCustomHeaders })=>{
    /**
     * If `additionalHeaders` was provided to the subscription as a function,
     * the headers that are returned by that function will already have been
     * provided before this function is called.
     */ if (!additionalCustomHeaders?.Authorization) throw new Error("No auth token specified");
    return {
        Authorization: additionalCustomHeaders.Authorization,
        host: host
    };
};
const $2b4f19d8f4fc9e3f$export$25a3dd724dac7678 = async ({ apiKey: apiKey, authenticationType: authenticationType, canonicalUri: canonicalUri, appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, region: region, additionalCustomHeaders: additionalCustomHeaders, payload: payload })=>{
    const headerHandler = {
        apiKey: $2b4f19d8f4fc9e3f$var$awsRealTimeApiKeyHeader,
        iam: $2b4f19d8f4fc9e3f$var$awsRealTimeIAMHeader,
        oidc: $2b4f19d8f4fc9e3f$var$awsAuthTokenHeader,
        userPool: $2b4f19d8f4fc9e3f$var$awsAuthTokenHeader,
        lambda: $2b4f19d8f4fc9e3f$var$customAuthHeader,
        none: $2b4f19d8f4fc9e3f$var$customAuthHeader
    };
    if (!authenticationType || !headerHandler[authenticationType]) {
        $2b4f19d8f4fc9e3f$var$logger.debug(`Authentication type ${authenticationType} not supported`);
        return undefined;
    } else {
        const handler = headerHandler[authenticationType];
        const host = appSyncGraphqlEndpoint ? new (0, $7Ar4G.AmplifyUrl)(appSyncGraphqlEndpoint).host : undefined;
        const resolvedApiKey = authenticationType === "apiKey" ? apiKey : undefined;
        $2b4f19d8f4fc9e3f$var$logger.debug(`Authenticating with ${JSON.stringify(authenticationType)}`);
        const result = await handler({
            payload: payload,
            canonicalUri: canonicalUri,
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            apiKey: resolvedApiKey,
            region: region,
            host: host,
            additionalCustomHeaders: additionalCustomHeaders
        });
        return result;
    }
};

});
parcelRegister("kwYKv", function(module, exports) {

$parcel$export(module.exports, "fetchAuthSession", () => $83614fd30266723c$export$39430dfe49142ae);

var $1qbEC = parcelRequire("1qbEC");

var $eL2i9 = parcelRequire("eL2i9");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
 * of non-expired tokens with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const $83614fd30266723c$export$39430dfe49142ae = (options)=>{
    return (0, $eL2i9.fetchAuthSession)((0, $1qbEC.Amplify), options);
};

});
parcelRegister("eL2i9", function(module, exports) {

$parcel$export(module.exports, "fetchAuthSession", () => $bb56c3c3b8aca32b$export$39430dfe49142ae);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bb56c3c3b8aca32b$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};

});





parcelRegister("4un4F", function(module, exports) {

$parcel$export(module.exports, "resolveConfig", () => $195ef80a28056421$export$7eca4ea16d4c8343);

var $gJw02 = parcelRequire("gJw02");


var $iGqn8 = parcelRequire("iGqn8");

var $025mJ = parcelRequire("025mJ");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $195ef80a28056421$var$logger = new (0, $gJw02.ConsoleLogger)("GraphQLAPI resolveConfig");
/**
 * @internal
 */ const $195ef80a28056421$export$7eca4ea16d4c8343 = (amplify)=>{
    const config = amplify.getConfig();
    if (!config.API?.GraphQL) $195ef80a28056421$var$logger.warn("The API configuration is missing. This is likely due to Amplify.configure() not being called prior to generateClient().");
    const { apiKey: apiKey, customEndpoint: customEndpoint, customEndpointRegion: customEndpointRegion, defaultAuthMode: defaultAuthMode, endpoint: endpoint, region: region } = config.API?.GraphQL ?? {};
    // TODO: re-enable when working in all test environments:
    // assertValidationError(!!endpoint, APIValidationErrorCode.NoEndpoint);
    (0, $iGqn8.assertValidationError)(!(!customEndpoint && customEndpointRegion), (0, $025mJ.APIValidationErrorCode).NoCustomEndpoint);
    return {
        apiKey: apiKey,
        customEndpoint: customEndpoint,
        customEndpointRegion: customEndpointRegion,
        defaultAuthMode: defaultAuthMode,
        endpoint: endpoint,
        region: region
    };
};

});
parcelRegister("iGqn8", function(module, exports) {

$parcel$export(module.exports, "assertValidationError", () => $838eb75e47a73edc$export$45936001d12f9b53);

var $aPZn6 = parcelRequire("aPZn6");

var $025mJ = parcelRequire("025mJ");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $838eb75e47a73edc$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $025mJ.validationErrorMap)[name];
    if (!assertion) throw new (0, $aPZn6.GraphQLApiError)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}

});
parcelRegister("aPZn6", function(module, exports) {

$parcel$export(module.exports, "GraphQLApiError", () => $e75a423e9aaaec77$export$1d95cbddd5b6dc7f);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $e75a423e9aaaec77$export$1d95cbddd5b6dc7f extends (0, $e0exy.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $e75a423e9aaaec77$export$1d95cbddd5b6dc7f;
        Object.setPrototypeOf(this, $e75a423e9aaaec77$export$1d95cbddd5b6dc7f.prototype);
    }
}

});

parcelRegister("025mJ", function(module, exports) {

$parcel$export(module.exports, "APIValidationErrorCode", () => $e1e0ad0aeee1ab28$export$f60466a0651ec80d);
$parcel$export(module.exports, "validationErrorMap", () => $e1e0ad0aeee1ab28$export$195137955146d376);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e1e0ad0aeee1ab28$export$f60466a0651ec80d;
(function(APIValidationErrorCode) {
    APIValidationErrorCode["NoAuthSession"] = "NoAuthSession";
    APIValidationErrorCode["NoRegion"] = "NoRegion";
    APIValidationErrorCode["NoCustomEndpoint"] = "NoCustomEndpoint";
})($e1e0ad0aeee1ab28$export$f60466a0651ec80d || ($e1e0ad0aeee1ab28$export$f60466a0651ec80d = {}));
const $e1e0ad0aeee1ab28$export$195137955146d376 = {
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoAuthSession]: {
        message: "Auth session should not be empty."
    },
    // TODO: re-enable when working in all test environments:
    // [APIValidationErrorCode.NoEndpoint]: {
    // 	message: 'Missing endpoint',
    // },
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoRegion]: {
        message: "Missing region."
    },
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoCustomEndpoint]: {
        message: "Custom endpoint region is present without custom endpoint."
    }
};

});



parcelRegister("2bSZt", function(module, exports) {

$parcel$export(module.exports, "resolveLibraryOptions", () => $5ba9283f5eedfa02$export$101b589a61b1975e);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $5ba9283f5eedfa02$export$101b589a61b1975e = (amplify)=>{
    const headers = amplify.libraryOptions?.API?.GraphQL?.headers;
    const withCredentials = amplify.libraryOptions?.API?.GraphQL?.withCredentials;
    return {
        headers: headers,
        withCredentials: withCredentials
    };
};

});

parcelRegister("027iw", function(module, exports) {

$parcel$export(module.exports, "repackageUnauthorizedError", () => $5bc2672d5026b0ee$export$ae53c576cf0e7264);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Checks to see if the given response or subscription message contains an
 * Unauthorized error. If it does, it changes the error message to include instructions
 * for the app developer.
 */ function $5bc2672d5026b0ee$export$ae53c576cf0e7264(content) {
    if (content.errors && Array.isArray(content.errors)) content.errors.forEach((e)=>{
        if ($5bc2672d5026b0ee$var$isUnauthorizedError(e)) {
            e.message = "Unauthorized";
            e.recoverySuggestion = `If you're calling an Amplify-generated API, make sure ` + `to set the "authMode" in generateClient({ authMode: '...' }) to the backend authorization ` + `rule's auth provider ('apiKey', 'userPool', 'iam', 'oidc', 'lambda')`;
        }
    });
    return content;
}
function $5bc2672d5026b0ee$var$isUnauthorizedError(error) {
    // Error pattern corresponding to appsync calls
    if (error?.originalError?.name?.startsWith("UnauthorizedException")) return true;
    // Error pattern corresponding to appsync subscriptions
    if (error.message?.startsWith("Connection failed:") && error.message?.includes("Permission denied")) return true;
    return false;
}

});

parcelRegister("d4tMy", function(module, exports) {

$parcel$export(module.exports, "NO_API_KEY", () => $557623384645476e$export$db1e3522cf5fbda);
$parcel$export(module.exports, "NO_VALID_CREDENTIALS", () => $557623384645476e$export$df1566d136fb3f71);
$parcel$export(module.exports, "NO_VALID_AUTH_TOKEN", () => $557623384645476e$export$cdac08ea09af35a7);
$parcel$export(module.exports, "NO_SIGNED_IN_USER", () => $557623384645476e$export$cbd630257945fcb4);
$parcel$export(module.exports, "NO_AUTH_TOKEN_HEADER", () => $557623384645476e$export$5ceb35ef0230aa92);
$parcel$export(module.exports, "NO_ENDPOINT", () => $557623384645476e$export$daa0b1c19bc2f9cd);

var $lvJDy = parcelRequire("lvJDy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $557623384645476e$export$db1e3522cf5fbda = {
    name: "NoApiKey",
    // ideal: No API key configured.
    message: (0, $lvJDy.GraphQLAuthError).NO_API_KEY,
    recoverySuggestion: 'The API request was made with `authMode: "apiKey"` but no API Key was passed into `Amplify.configure()`. Review if your API key is passed into the `Amplify.configure()` function.'
};
const $557623384645476e$export$df1566d136fb3f71 = {
    name: "NoCredentials",
    // ideal: No auth credentials available.
    message: (0, $lvJDy.GraphQLAuthError).NO_CREDENTIALS,
    recoverySuggestion: `The API request was made with \`authMode: "iam"\` but no authentication credentials are available.

If you intended to make a request using an authenticated role, review if your user is signed in before making the request.

If you intend to make a request using an unauthenticated role or also known as "guest access", verify if "Auth.Cognito.allowGuestAccess" is set to "true" in the \`Amplify.configure()\` function.`
};
const $557623384645476e$export$cdac08ea09af35a7 = {
    name: "NoValidAuthTokens",
    // ideal: No valid JWT auth token provided to make the API request..
    message: (0, $lvJDy.GraphQLAuthError).NO_FEDERATED_JWT,
    recoverySuggestion: "If you intended to make an authenticated API request, review if the current user is signed in."
};
const $557623384645476e$export$cbd630257945fcb4 = {
    name: "NoSignedUser",
    // ideal: Couldn't retrieve authentication credentials to make the API request.
    message: (0, $lvJDy.GraphQLAuthError).NO_CURRENT_USER,
    recoverySuggestion: "Review the underlying exception field for more details. If you intended to make an authenticated API request, review if the current user is signed in."
};
const $557623384645476e$export$5ceb35ef0230aa92 = {
    name: "NoAuthorizationHeader",
    // ideal: Authorization header not specified.
    message: (0, $lvJDy.GraphQLAuthError).NO_AUTH_TOKEN,
    recoverySuggestion: 'The API request was made with `authMode: "lambda"` but no `authToken` is set. Review if a valid authToken is passed into the request options or in the `Amplify.configure()` function.'
};
const $557623384645476e$export$daa0b1c19bc2f9cd = {
    name: "NoEndpoint",
    message: "No GraphQL endpoint configured in `Amplify.configure()`.",
    recoverySuggestion: "Review if the GraphQL API endpoint is set in the `Amplify.configure()` function."
};

});

parcelRegister("28CpK", function(module, exports) {

$parcel$export(module.exports, "createGraphQLResultWithError", () => $2829a72104e32f00$export$4032c85a95d7ba2a);

var $fHcz3 = parcelRequire("fHcz3");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2829a72104e32f00$export$4032c85a95d7ba2a = (error)=>{
    return {
        data: {},
        errors: [
            new (0, $fHcz3.GraphQLError)(error.message, null, null, null, null, error)
        ]
    };
};

});

parcelRegister("4eb9l", function(module, exports) {

$parcel$export(module.exports, "isGraphQLResponseWithErrors", () => $087673285e6a449a$export$394a6dc6d03c9f4c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $087673285e6a449a$export$394a6dc6d03c9f4c(response) {
    if (!response) return false;
    const r = response;
    return Array.isArray(r.errors) && r.errors.length > 0;
}

});

parcelRegister("37s7d", function(module, exports) {

$parcel$export(module.exports, "headerBasedAuth", () => $b9bace6c1ac6faf9$export$af90cb94162671bb);

var $aPZn6 = parcelRequire("aPZn6");



var $d4tMy = parcelRequire("d4tMy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $b9bace6c1ac6faf9$export$af90cb94162671bb(amplify, authMode, apiKey, additionalHeaders = {}) {
    let headers = {};
    switch(authMode){
        case "apiKey":
            if (!apiKey) throw new (0, $aPZn6.GraphQLApiError)((0, $d4tMy.NO_API_KEY));
            headers = {
                "X-Api-Key": apiKey
            };
            break;
        case "iam":
            {
                const session = await amplify.Auth.fetchAuthSession();
                if (session.credentials === undefined) throw new (0, $aPZn6.GraphQLApiError)((0, $d4tMy.NO_VALID_CREDENTIALS));
                break;
            }
        case "oidc":
        case "userPool":
            {
                let token;
                try {
                    token = (await amplify.Auth.fetchAuthSession()).tokens?.accessToken.toString();
                } catch (e) {
                    // fetchAuthSession failed
                    throw new (0, $aPZn6.GraphQLApiError)({
                        ...(0, $d4tMy.NO_SIGNED_IN_USER),
                        underlyingError: e
                    });
                }
                // `fetchAuthSession()` succeeded but didn't return `tokens`.
                // This may happen when unauthenticated access is enabled and there is
                // no user signed in.
                if (!token) throw new (0, $aPZn6.GraphQLApiError)((0, $d4tMy.NO_VALID_AUTH_TOKEN));
                headers = {
                    Authorization: token
                };
                break;
            }
        case "lambda":
            if (typeof additionalHeaders === "object" && !additionalHeaders.Authorization) throw new (0, $aPZn6.GraphQLApiError)((0, $d4tMy.NO_AUTH_TOKEN_HEADER));
            headers = {
                Authorization: additionalHeaders.Authorization
            };
            break;
    }
    return headers;
}

});






parcelRegister("le7Hi", function(module, exports) {
module.exports = JSON.parse('{"aws_project_region":"us-east-2","aws_appsync_graphqlEndpoint":"https://dfjzgwt2dbbh7aigsqfgqh4uuu.appsync-api.us-east-2.amazonaws.com/graphql","aws_appsync_region":"us-east-2","aws_appsync_authenticationType":"API_KEY","aws_appsync_apiKey":"da2-4fc6vk3f5jesza4ewmx43z5a3a"}');

});


//# sourceMappingURL=index.4b267937.js.map
